// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiAiKnowledgeChunksByIdData, DeleteApiAiKnowledgeChunksByIdErrors, DeleteApiAiKnowledgeChunksByIdResponses, DeleteApiAminoAgeCorrelationConfigsByIdData, DeleteApiAminoAgeCorrelationConfigsByIdErrors, DeleteApiAminoAgeCorrelationConfigsByIdResponses, DeleteApiAminoAgeSnapshotsByIdData, DeleteApiAminoAgeSnapshotsByIdErrors, DeleteApiAminoAgeSnapshotsByIdResponses, DeleteApiAminoAgeTrendAssessmentsByIdData, DeleteApiAminoAgeTrendAssessmentsByIdErrors, DeleteApiAminoAgeTrendAssessmentsByIdResponses, DeleteApiAssessmentAiMetadataByIdData, DeleteApiAssessmentAiMetadataByIdErrors, DeleteApiAssessmentAiMetadataByIdResponses, DeleteApiAssessmentEmphasizedBiometricsByIdData, DeleteApiAssessmentEmphasizedBiometricsByIdErrors, DeleteApiAssessmentEmphasizedBiometricsByIdResponses, DeleteApiAssessmentRecommendationProgressByIdData, DeleteApiAssessmentRecommendationProgressByIdErrors, DeleteApiAssessmentRecommendationProgressByIdResponses, DeleteApiAssessmentRecommendationsByIdData, DeleteApiAssessmentRecommendationsByIdErrors, DeleteApiAssessmentRecommendationsByIdResponses, DeleteApiAssessmentsByIdData, DeleteApiAssessmentsByIdErrors, DeleteApiAssessmentsByIdResponses, DeleteApiAssessmentVariantMetadataByIdData, DeleteApiAssessmentVariantMetadataByIdErrors, DeleteApiAssessmentVariantMetadataByIdResponses, DeleteApiAssessmentVariantsByIdData, DeleteApiAssessmentVariantsByIdErrors, DeleteApiAssessmentVariantsByIdResponses, DeleteApiAuditLogsByIdData, DeleteApiAuditLogsByIdErrors, DeleteApiAuditLogsByIdResponses, DeleteApiAuthorizationUserRolesByIdData, DeleteApiAuthorizationUserRolesByIdErrors, DeleteApiAuthorizationUserRolesByIdResponses, DeleteApiBhtQuestionAlternativesByIdData, DeleteApiBhtQuestionAlternativesByIdErrors, DeleteApiBhtQuestionAlternativesByIdResponses, DeleteApiBhtQuestionResponsesByIdData, DeleteApiBhtQuestionResponsesByIdErrors, DeleteApiBhtQuestionResponsesByIdResponses, DeleteApiBhtQuestionsByIdData, DeleteApiBhtQuestionsByIdErrors, DeleteApiBhtQuestionsByIdResponses, DeleteApiBiometricCategoriesByIdData, DeleteApiBiometricCategoriesByIdErrors, DeleteApiBiometricCategoriesByIdResponses, DeleteApiBiometricPricesByIdData, DeleteApiBiometricPricesByIdErrors, DeleteApiBiometricPricesByIdResponses, DeleteApiBiometricReferenceRangesByIdData, DeleteApiBiometricReferenceRangesByIdErrors, DeleteApiBiometricReferenceRangesByIdResponses, DeleteApiBiometricResultsByIdData, DeleteApiBiometricResultsByIdErrors, DeleteApiBiometricResultsByIdResponses, DeleteApiBiometricsByIdData, DeleteApiBiometricsByIdErrors, DeleteApiBiometricsByIdResponses, DeleteApiBloodTestPackagesByIdData, DeleteApiBloodTestPackagesByIdErrors, DeleteApiBloodTestPackagesByIdResponses, DeleteApiCategoriesByIdData, DeleteApiCategoriesByIdErrors, DeleteApiCategoriesByIdResponses, DeleteApiCompaniesByIdData, DeleteApiCompaniesByIdErrors, DeleteApiCompaniesByIdResponses, DeleteApiConsultationNotesByIdData, DeleteApiConsultationNotesByIdErrors, DeleteApiConsultationNotesByIdResponses, DeleteApiCrmUserByIdData, DeleteApiCrmUserByIdErrors, DeleteApiCrmUserByIdResponses, DeleteApiFeatureFlagsByIdData, DeleteApiFeatureFlagsByIdErrors, DeleteApiFeatureFlagsByIdResponses, DeleteApiFeedbackByIdData, DeleteApiFeedbackByIdErrors, DeleteApiFeedbackByIdResponses, DeleteApiFurstAnalysisHistoryByIdData, DeleteApiFurstAnalysisHistoryByIdErrors, DeleteApiFurstAnalysisHistoryByIdResponses, DeleteApiGarminBodyBatterySamplesByIdData, DeleteApiGarminBodyBatterySamplesByIdErrors, DeleteApiGarminBodyBatterySamplesByIdResponses, DeleteApiGarminDailySnapshotsByIdData, DeleteApiGarminDailySnapshotsByIdErrors, DeleteApiGarminDailySnapshotsByIdResponses, DeleteApiHealthDailySnapshotsByIdData, DeleteApiHealthDailySnapshotsByIdErrors, DeleteApiHealthDailySnapshotsByIdResponses, DeleteApiInternalNotesByIdData, DeleteApiInternalNotesByIdErrors, DeleteApiInternalNotesByIdResponses, DeleteApiInternalUserCommentsByIdData, DeleteApiInternalUserCommentsByIdErrors, DeleteApiInternalUserCommentsByIdResponses, DeleteApiInvoicesByIdData, DeleteApiInvoicesByIdErrors, DeleteApiInvoicesByIdResponses, DeleteApiJournalNotesByIdData, DeleteApiJournalNotesByIdErrors, DeleteApiJournalNotesByIdResponses, DeleteApiLabPricesByIdData, DeleteApiLabPricesByIdErrors, DeleteApiLabPricesByIdResponses, DeleteApiLabsByIdData, DeleteApiLabsByIdErrors, DeleteApiLabsByIdResponses, DeleteApiLabVisitRequisitionBiometricsByIdData, DeleteApiLabVisitRequisitionBiometricsByIdErrors, DeleteApiLabVisitRequisitionBiometricsByIdResponses, DeleteApiLabVisitRequisitionsByIdData, DeleteApiLabVisitRequisitionsByIdErrors, DeleteApiLabVisitRequisitionsByIdResponses, DeleteApiLabVisitsByIdData, DeleteApiLabVisitsByIdErrors, DeleteApiLabVisitsByIdResponses, DeleteApiLabVisitUserNotesByIdData, DeleteApiLabVisitUserNotesByIdErrors, DeleteApiLabVisitUserNotesByIdResponses, DeleteApiMarketingReferralsByIdData, DeleteApiMarketingReferralsByIdErrors, DeleteApiMarketingReferralsByIdResponses, DeleteApiMetricSourcePreferencesByIdData, DeleteApiMetricSourcePreferencesByIdErrors, DeleteApiMetricSourcePreferencesByIdResponses, DeleteApiOnboardingByIdData, DeleteApiOnboardingByIdErrors, DeleteApiOnboardingByIdResponses, DeleteApiPricesByIdData, DeleteApiPricesByIdErrors, DeleteApiPricesByIdResponses, DeleteApiQuestionAlternativesByIdData, DeleteApiQuestionAlternativesByIdErrors, DeleteApiQuestionAlternativesByIdResponses, DeleteApiQuestionCategoriesByIdData, DeleteApiQuestionCategoriesByIdErrors, DeleteApiQuestionCategoriesByIdResponses, DeleteApiQuestionNumericRulesByIdData, DeleteApiQuestionNumericRulesByIdErrors, DeleteApiQuestionNumericRulesByIdResponses, DeleteApiQuestionResponsesByIdData, DeleteApiQuestionResponsesByIdErrors, DeleteApiQuestionResponsesByIdResponses, DeleteApiQuestionsByIdData, DeleteApiQuestionsByIdErrors, DeleteApiQuestionsByIdResponses, DeleteApiRagDocumentsByIdData, DeleteApiRagDocumentsByIdErrors, DeleteApiRagDocumentsByIdResponses, DeleteApiRecruitmentCodesByIdData, DeleteApiRecruitmentCodesByIdErrors, DeleteApiRecruitmentCodesByIdResponses, DeleteApiSinglePaymentsByIdData, DeleteApiSinglePaymentsByIdErrors, DeleteApiSinglePaymentsByIdResponses, DeleteApiStatusHistoryByIdData, DeleteApiStatusHistoryByIdErrors, DeleteApiStatusHistoryByIdResponses, DeleteApiSubscriptionsByIdData, DeleteApiSubscriptionsByIdErrors, DeleteApiSubscriptionsByIdResponses, DeleteApiSystemJobsByIdData, DeleteApiSystemJobsByIdErrors, DeleteApiSystemJobsByIdResponses, DeleteApiUserDevicePushTokensByIdData, DeleteApiUserDevicePushTokensByIdErrors, DeleteApiUserDevicePushTokensByIdResponses, DeleteApiUserFeatureFlagsByIdData, DeleteApiUserFeatureFlagsByIdErrors, DeleteApiUserFeatureFlagsByIdResponses, DeleteApiUserPlanActionProgressByIdData, DeleteApiUserPlanActionProgressByIdErrors, DeleteApiUserPlanActionProgressByIdResponses, DeleteApiUserPlanActionsByIdData, DeleteApiUserPlanActionsByIdErrors, DeleteApiUserPlanActionsByIdResponses, DeleteApiUserProfilesByIdData, DeleteApiUserProfilesByIdErrors, DeleteApiUserProfilesByIdResponses, DeleteApiUsersNeedingActionByIdData, DeleteApiUsersNeedingActionByIdErrors, DeleteApiUsersNeedingActionByIdResponses, DeleteApiUserUiSettingsByIdData, DeleteApiUserUiSettingsByIdErrors, DeleteApiUserUiSettingsByIdResponses, DeleteApiWearablesDataData, DeleteApiWearablesDataErrors, DeleteApiWearablesDataResponses, DeleteApiWearablesGarminDisconnectData, DeleteApiWearablesGarminDisconnectErrors, DeleteApiWearablesGarminDisconnectResponses, DeleteApiWearableSourcePreferencesByIdData, DeleteApiWearableSourcePreferencesByIdErrors, DeleteApiWearableSourcePreferencesByIdResponses, GetApiAdminHelfoEngineBiometricMapData, GetApiAdminHelfoEngineBiometricMapErrors, GetApiAdminHelfoEngineBiometricMapResponses, GetApiAdminHelfoEngineMedicationKeywordsData, GetApiAdminHelfoEngineMedicationKeywordsErrors, GetApiAdminHelfoEngineMedicationKeywordsResponses, GetApiAdminLabVisitsByIdFollowupSuggestionsData, GetApiAdminLabVisitsByIdFollowupSuggestionsErrors, GetApiAdminLabVisitsByIdFollowupSuggestionsResponses, GetApiAdminLabVisitsByIdHelfoEvaluationData, GetApiAdminLabVisitsByIdHelfoEvaluationErrors, GetApiAdminLabVisitsByIdHelfoEvaluationResponses, GetApiAdminLabVisitsByIdWearableDeltasData, GetApiAdminLabVisitsByIdWearableDeltasErrors, GetApiAdminLabVisitsByIdWearableDeltasResponses, GetApiAdminLabVisitsHelfoCommentData, GetApiAdminLabVisitsHelfoCommentErrors, GetApiAdminLabVisitsHelfoCommentResponses, GetApiAdminLabVisitsPendingRequisitionsData, GetApiAdminLabVisitsPendingRequisitionsErrors, GetApiAdminLabVisitsPendingRequisitionsResponses, GetApiAdminUsersByAuthUserIdWearableCurrentData, GetApiAdminUsersByAuthUserIdWearableCurrentErrors, GetApiAdminUsersByAuthUserIdWearableCurrentResponses, GetApiAiKnowledgeChunksByIdData, GetApiAiKnowledgeChunksByIdErrors, GetApiAiKnowledgeChunksByIdResponses, GetApiAiKnowledgeChunksData, GetApiAiKnowledgeChunksErrors, GetApiAiKnowledgeChunksResponses, GetApiAminoAgeCorrelationConfigsByIdData, GetApiAminoAgeCorrelationConfigsByIdErrors, GetApiAminoAgeCorrelationConfigsByIdResponses, GetApiAminoAgeCorrelationConfigsData, GetApiAminoAgeCorrelationConfigsErrors, GetApiAminoAgeCorrelationConfigsResponses, GetApiAminoAgeData, GetApiAminoAgeErrors, GetApiAminoAgePreviewData, GetApiAminoAgeResponses, GetApiAminoAgeSnapshotsByIdData, GetApiAminoAgeSnapshotsByIdErrors, GetApiAminoAgeSnapshotsByIdResponses, GetApiAminoAgeSnapshotsData, GetApiAminoAgeSnapshotsErrors, GetApiAminoAgeSnapshotsResponses, GetApiAminoAgeTrendAssessmentsByIdData, GetApiAminoAgeTrendAssessmentsByIdErrors, GetApiAminoAgeTrendAssessmentsByIdResponses, GetApiAminoAgeTrendAssessmentsData, GetApiAminoAgeTrendAssessmentsErrors, GetApiAminoAgeTrendAssessmentsResponses, GetApiAminoAgeTrendGenerationStatusData, GetApiAminoAgeTrendGenerationStatusErrors, GetApiAminoAgeTrendGenerationStatusResponses, GetApiAnalyticsDatasetsByNameData, GetApiAnalyticsDatasetsData, GetApiAssessmentAiMetadataByIdData, GetApiAssessmentAiMetadataByIdErrors, GetApiAssessmentAiMetadataByIdResponses, GetApiAssessmentAiMetadataData, GetApiAssessmentAiMetadataErrors, GetApiAssessmentAiMetadataResponses, GetApiAssessmentEmphasizedBiometricsByIdData, GetApiAssessmentEmphasizedBiometricsByIdErrors, GetApiAssessmentEmphasizedBiometricsByIdResponses, GetApiAssessmentEmphasizedBiometricsData, GetApiAssessmentEmphasizedBiometricsErrors, GetApiAssessmentEmphasizedBiometricsResponses, GetApiAssessmentRecommendationProgressByIdData, GetApiAssessmentRecommendationProgressByIdErrors, GetApiAssessmentRecommendationProgressByIdResponses, GetApiAssessmentRecommendationProgressData, GetApiAssessmentRecommendationProgressErrors, GetApiAssessmentRecommendationProgressResponses, GetApiAssessmentRecommendationsByIdData, GetApiAssessmentRecommendationsByIdErrors, GetApiAssessmentRecommendationsByIdResponses, GetApiAssessmentRecommendationsData, GetApiAssessmentRecommendationsErrors, GetApiAssessmentRecommendationsResponses, GetApiAssessmentsByIdData, GetApiAssessmentsByIdErrors, GetApiAssessmentsByIdResponses, GetApiAssessmentsData, GetApiAssessmentsErrors, GetApiAssessmentsResponses, GetApiAssessmentVariantMetadataByIdData, GetApiAssessmentVariantMetadataByIdErrors, GetApiAssessmentVariantMetadataByIdResponses, GetApiAssessmentVariantMetadataData, GetApiAssessmentVariantMetadataErrors, GetApiAssessmentVariantMetadataResponses, GetApiAssessmentVariantsByIdData, GetApiAssessmentVariantsByIdErrors, GetApiAssessmentVariantsByIdResponses, GetApiAssessmentVariantsData, GetApiAssessmentVariantsErrors, GetApiAssessmentVariantsResponses, GetApiAuditLogsByIdData, GetApiAuditLogsByIdErrors, GetApiAuditLogsByIdResponses, GetApiAuditLogsData, GetApiAuditLogsErrors, GetApiAuditLogsImpersonatorsByPatientUserIdData, GetApiAuditLogsImpersonatorsByPatientUserIdErrors, GetApiAuditLogsImpersonatorsByPatientUserIdResponses, GetApiAuditLogsImpersonatorsData, GetApiAuditLogsImpersonatorsErrors, GetApiAuditLogsImpersonatorsResponses, GetApiAuditLogsResponses, GetApiAuthDevUsersData, GetApiAuthorizationDailyPatientLimitData, GetApiAuthorizationDailyPatientLimitErrors, GetApiAuthorizationDailyPatientLimitResponses, GetApiAuthorizationUserRolesByIdData, GetApiAuthorizationUserRolesByIdErrors, GetApiAuthorizationUserRolesByIdResponses, GetApiAuthorizationUserRolesData, GetApiAuthorizationUserRolesErrors, GetApiAuthorizationUserRolesResponses, GetApiBhtQuestionAlternativesByIdData, GetApiBhtQuestionAlternativesByIdErrors, GetApiBhtQuestionAlternativesByIdResponses, GetApiBhtQuestionAlternativesData, GetApiBhtQuestionAlternativesErrors, GetApiBhtQuestionAlternativesResponses, GetApiBhtQuestionResponsesByIdData, GetApiBhtQuestionResponsesByIdErrors, GetApiBhtQuestionResponsesByIdResponses, GetApiBhtQuestionResponsesData, GetApiBhtQuestionResponsesErrors, GetApiBhtQuestionResponsesResponses, GetApiBhtQuestionsByIdData, GetApiBhtQuestionsByIdErrors, GetApiBhtQuestionsByIdResponses, GetApiBhtQuestionsData, GetApiBhtQuestionsErrors, GetApiBhtQuestionsResponses, GetApiBillingPredictedIncomeData, GetApiBillingPredictedIncomeErrors, GetApiBillingPredictedIncomeResponses, GetApiBillingRecruitmentStatsData, GetApiBillingRecruitmentStatsErrors, GetApiBillingRecruitmentStatsResponses, GetApiBiometricCategoriesByIdData, GetApiBiometricCategoriesByIdErrors, GetApiBiometricCategoriesByIdResponses, GetApiBiometricCategoriesData, GetApiBiometricCategoriesErrors, GetApiBiometricCategoriesResponses, GetApiBiometricPricesByIdData, GetApiBiometricPricesByIdErrors, GetApiBiometricPricesByIdResponses, GetApiBiometricPricesData, GetApiBiometricPricesErrors, GetApiBiometricPricesResponses, GetApiBiometricReferenceRangesByIdData, GetApiBiometricReferenceRangesByIdErrors, GetApiBiometricReferenceRangesByIdResponses, GetApiBiometricReferenceRangesData, GetApiBiometricReferenceRangesErrors, GetApiBiometricReferenceRangesResponses, GetApiBiometricResultsByIdData, GetApiBiometricResultsByIdErrors, GetApiBiometricResultsByIdResponses, GetApiBiometricResultsData, GetApiBiometricResultsErrors, GetApiBiometricResultsResponses, GetApiBiometricsByIdData, GetApiBiometricsByIdErrors, GetApiBiometricsByIdResponses, GetApiBiometricsData, GetApiBiometricsErrors, GetApiBiometricsResponses, GetApiBloodTestPackagesByIdData, GetApiBloodTestPackagesByIdErrors, GetApiBloodTestPackagesByIdResponses, GetApiBloodTestPackagesData, GetApiBloodTestPackagesErrors, GetApiBloodTestPackagesResponses, GetApiCategoriesByIdData, GetApiCategoriesByIdErrors, GetApiCategoriesByIdResponses, GetApiCategoriesData, GetApiCategoriesErrors, GetApiCategoriesResponses, GetApiCompaniesByIdData, GetApiCompaniesByIdErrors, GetApiCompaniesByIdResponses, GetApiCompaniesData, GetApiCompaniesErrors, GetApiCompaniesLookupByLookupData, GetApiCompaniesLookupByLookupErrors, GetApiCompaniesLookupByLookupResponses, GetApiCompaniesResponses, GetApiConsultationNotesByIdData, GetApiConsultationNotesByIdErrors, GetApiConsultationNotesByIdResponses, GetApiConsultationNotesData, GetApiConsultationNotesErrors, GetApiConsultationNotesResponses, GetApiCrmLookupData, GetApiCrmLookupErrors, GetApiCrmLookupResponses, GetApiCrmPeriodDetailsData, GetApiCrmPeriodDetailsResponses, GetApiCrmPeriodStatsData, GetApiCrmPeriodStatsResponses, GetApiCrmSubscriptionTiersData, GetApiCrmSubscriptionTiersErrors, GetApiCrmSubscriptionTiersResponses, GetApiCrmUserByIdData, GetApiCrmUserByIdErrors, GetApiCrmUserByIdNinData, GetApiCrmUserByIdNinErrors, GetApiCrmUserByIdNinResponses, GetApiCrmUserByIdResponses, GetApiCrmUserCountData, GetApiCrmUserCountErrors, GetApiCrmUserCountResponses, GetApiCrmUserData, GetApiCrmUserErrors, GetApiCrmUserResponses, GetApiDashboardsData, GetApiDashboardsResponses, GetApiDoctorMessagesThreadsByIdReplySuggestionData, GetApiDoctorMessagesThreadsByIdReplySuggestionErrors, GetApiDoctorMessagesThreadsByIdReplySuggestionResponses, GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdData, GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdErrors, GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdResponses, GetApiDoctorMessagesThreadsData, GetApiDoctorMessagesThreadsErrors, GetApiDoctorMessagesThreadsResponses, GetApiFeatureFlagsByIdData, GetApiFeatureFlagsByIdErrors, GetApiFeatureFlagsByIdResponses, GetApiFeatureFlagsData, GetApiFeatureFlagsErrors, GetApiFeatureFlagsResponses, GetApiFeedbackByIdData, GetApiFeedbackByIdErrors, GetApiFeedbackByIdResponses, GetApiFeedbackData, GetApiFeedbackErrors, GetApiFeedbackResponses, GetApiFurstAnalysisHistoryByIdData, GetApiFurstAnalysisHistoryByIdErrors, GetApiFurstAnalysisHistoryByIdResponses, GetApiFurstAnalysisHistoryData, GetApiFurstAnalysisHistoryErrors, GetApiFurstAnalysisHistoryResponses, GetApiGarminBodyBatterySamplesByIdData, GetApiGarminBodyBatterySamplesByIdErrors, GetApiGarminBodyBatterySamplesByIdResponses, GetApiGarminBodyBatterySamplesData, GetApiGarminBodyBatterySamplesErrors, GetApiGarminBodyBatterySamplesResponses, GetApiGarminConnectionsData, GetApiGarminConnectionsResponses, GetApiGarminDailySnapshotsByIdData, GetApiGarminDailySnapshotsByIdErrors, GetApiGarminDailySnapshotsByIdResponses, GetApiGarminDailySnapshotsData, GetApiGarminDailySnapshotsErrors, GetApiGarminDailySnapshotsResponses, GetApiHealthDailySnapshotsByIdData, GetApiHealthDailySnapshotsByIdErrors, GetApiHealthDailySnapshotsByIdResponses, GetApiHealthDailySnapshotsData, GetApiHealthDailySnapshotsErrors, GetApiHealthDailySnapshotsResponses, GetApiInternalNotesByIdData, GetApiInternalNotesByIdErrors, GetApiInternalNotesByIdResponses, GetApiInternalNotesData, GetApiInternalNotesErrors, GetApiInternalNotesResponses, GetApiInternalUserCommentsByIdData, GetApiInternalUserCommentsByIdErrors, GetApiInternalUserCommentsByIdResponses, GetApiInternalUserCommentsData, GetApiInternalUserCommentsErrors, GetApiInternalUserCommentsResponses, GetApiInvoicesByIdData, GetApiInvoicesByIdErrors, GetApiInvoicesByIdResponses, GetApiInvoicesData, GetApiInvoicesErrors, GetApiInvoicesResponses, GetApiJournalNotesByIdData, GetApiJournalNotesByIdErrors, GetApiJournalNotesByIdResponses, GetApiJournalNotesData, GetApiJournalNotesErrors, GetApiJournalNotesResponses, GetApiLabPricesByIdData, GetApiLabPricesByIdErrors, GetApiLabPricesByIdResponses, GetApiLabPricesData, GetApiLabPricesErrors, GetApiLabPriceSourcesData, GetApiLabPriceSourcesResponses, GetApiLabPricesResponses, GetApiLabsByIdData, GetApiLabsData, GetApiLabsErrors, GetApiLabsResponses, GetApiLabVisitCostBreakdownByIdData, GetApiLabVisitCostBreakdownByIdResponses, GetApiLabVisitRequisitionBiometricsByIdData, GetApiLabVisitRequisitionBiometricsByIdErrors, GetApiLabVisitRequisitionBiometricsByIdResponses, GetApiLabVisitRequisitionBiometricsData, GetApiLabVisitRequisitionBiometricsErrors, GetApiLabVisitRequisitionBiometricsResponses, GetApiLabVisitRequisitionsByIdData, GetApiLabVisitRequisitionsByIdErrors, GetApiLabVisitRequisitionsByIdResponses, GetApiLabVisitRequisitionsData, GetApiLabVisitRequisitionsErrors, GetApiLabVisitRequisitionsResponses, GetApiLabVisitsByIdAnalysisPdfData, GetApiLabVisitsByIdAnalysisPdfErrors, GetApiLabVisitsByIdAnalysisPdfResponses, GetApiLabVisitsByIdData, GetApiLabVisitsByIdErrors, GetApiLabVisitsByIdPdfData, GetApiLabVisitsByIdPdfErrors, GetApiLabVisitsByIdPdfResponses, GetApiLabVisitsByIdResponses, GetApiLabVisitsData, GetApiLabVisitsErrors, GetApiLabVisitsResponses, GetApiLabVisitUserNotesByIdData, GetApiLabVisitUserNotesByIdErrors, GetApiLabVisitUserNotesByIdResponses, GetApiLabVisitUserNotesData, GetApiLabVisitUserNotesErrors, GetApiLabVisitUserNotesResponses, GetApiMarketingReferralsByIdData, GetApiMarketingReferralsByIdErrors, GetApiMarketingReferralsByIdResponses, GetApiMarketingReferralsData, GetApiMarketingReferralsErrors, GetApiMarketingReferralsResponses, GetApiMetricSourcePreferencesByIdData, GetApiMetricSourcePreferencesByIdErrors, GetApiMetricSourcePreferencesByIdResponses, GetApiMetricSourcePreferencesData, GetApiMetricSourcePreferencesErrors, GetApiMetricSourcePreferencesResponses, GetApiOnboardingByIdData, GetApiOnboardingByIdErrors, GetApiOnboardingByIdResponses, GetApiOnboardingData, GetApiOnboardingErrors, GetApiOnboardingResponses, GetApiPricesByIdData, GetApiPricesByIdErrors, GetApiPricesByIdResponses, GetApiPricesData, GetApiPricesErrors, GetApiPricesResponses, GetApiQuestionAlternativesByIdData, GetApiQuestionAlternativesByIdErrors, GetApiQuestionAlternativesByIdResponses, GetApiQuestionAlternativesData, GetApiQuestionAlternativesErrors, GetApiQuestionAlternativesResponses, GetApiQuestionCategoriesByIdData, GetApiQuestionCategoriesByIdErrors, GetApiQuestionCategoriesByIdResponses, GetApiQuestionCategoriesData, GetApiQuestionCategoriesErrors, GetApiQuestionCategoriesResponses, GetApiQuestionNumericRulesByIdData, GetApiQuestionNumericRulesByIdErrors, GetApiQuestionNumericRulesByIdResponses, GetApiQuestionNumericRulesData, GetApiQuestionNumericRulesErrors, GetApiQuestionNumericRulesResponses, GetApiQuestionResponsesByIdData, GetApiQuestionResponsesByIdErrors, GetApiQuestionResponsesByIdResponses, GetApiQuestionResponsesData, GetApiQuestionResponsesErrors, GetApiQuestionResponsesResponses, GetApiQuestionsByIdData, GetApiQuestionsByIdErrors, GetApiQuestionsByIdResponses, GetApiQuestionsData, GetApiQuestionsErrors, GetApiQuestionsResponses, GetApiRagDocumentsByIdData, GetApiRagDocumentsByIdErrors, GetApiRagDocumentsByIdResponses, GetApiRagDocumentsData, GetApiRagDocumentsErrors, GetApiRagDocumentsResponses, GetApiRecruitmentCodesByIdData, GetApiRecruitmentCodesByIdErrors, GetApiRecruitmentCodesByIdResponses, GetApiRecruitmentCodesData, GetApiRecruitmentCodesErrors, GetApiRecruitmentCodesResponses, GetApiSinglePaymentsByIdData, GetApiSinglePaymentsByIdErrors, GetApiSinglePaymentsByIdResponses, GetApiSinglePaymentsData, GetApiSinglePaymentsErrors, GetApiSinglePaymentsResponses, GetApiStatusHistoryByIdData, GetApiStatusHistoryByIdErrors, GetApiStatusHistoryByIdResponses, GetApiStatusHistoryData, GetApiStatusHistoryErrors, GetApiStatusHistoryResponses, GetApiSubscriptionsByIdData, GetApiSubscriptionsByIdErrors, GetApiSubscriptionsByIdResponses, GetApiSubscriptionsData, GetApiSubscriptionsErrors, GetApiSubscriptionsResponses, GetApiSystemApiKeysByIdUsageData, GetApiSystemApiKeysByIdUsageResponses, GetApiSystemApiKeysData, GetApiSystemApiKeysResponses, GetApiSystemConversionsData, GetApiSystemCronJobsData, GetApiSystemCronJobsResponses, GetApiSystemEventsData, GetApiSystemEventsResponses, GetApiSystemEventsStreamsData, GetApiSystemEventsStreamsResponses, GetApiSystemHealthData, GetApiSystemHealthResponses, GetApiSystemJobsByIdData, GetApiSystemJobsByIdErrors, GetApiSystemJobsByIdResponses, GetApiSystemJobsByWorkerData, GetApiSystemJobsByWorkerResponses, GetApiSystemJobsData, GetApiSystemJobsResponses, GetApiSystemJobsStuckData, GetApiSystemJobsStuckResponses, GetApiSystemLiveData, GetApiSystemLogsData, GetApiSystemLogsExportPromptData, GetApiSystemLogsExportPromptResponses, GetApiSystemLogsResponses, GetApiSystemLogsSignatureData, GetApiSystemLogsSignatureErrors, GetApiSystemLogsSignatureResponses, GetApiSystemLogsSignaturesData, GetApiSystemLogsSignaturesResponses, GetApiSystemLogsStatsData, GetApiSystemLogsStatsResponses, GetApiSystemStatsData, GetApiSystemStatsResponses, GetApiSystemTelemetryData, GetApiSystemTelemetryResponses, GetApiSystemThroughputData, GetApiSystemThroughputResponses, GetApiUserDevicePushTokensByIdData, GetApiUserDevicePushTokensByIdErrors, GetApiUserDevicePushTokensByIdResponses, GetApiUserDevicePushTokensData, GetApiUserDevicePushTokensErrors, GetApiUserDevicePushTokensResponses, GetApiUserFeatureFlagsByIdData, GetApiUserFeatureFlagsByIdErrors, GetApiUserFeatureFlagsByIdResponses, GetApiUserFeatureFlagsData, GetApiUserFeatureFlagsErrors, GetApiUserFeatureFlagsResponses, GetApiUserPlanActionProgressByIdData, GetApiUserPlanActionProgressByIdErrors, GetApiUserPlanActionProgressByIdResponses, GetApiUserPlanActionProgressData, GetApiUserPlanActionProgressErrors, GetApiUserPlanActionProgressResponses, GetApiUserPlanActionsByIdData, GetApiUserPlanActionsByIdErrors, GetApiUserPlanActionsByIdResponses, GetApiUserPlanActionsData, GetApiUserPlanActionsErrors, GetApiUserPlanActionsResponses, GetApiUserProfilesByIdData, GetApiUserProfilesByIdErrors, GetApiUserProfilesByIdResponses, GetApiUserProfilesData, GetApiUserProfilesEmailVerificationData, GetApiUserProfilesEmailVerificationErrors, GetApiUserProfilesEmailVerificationResponses, GetApiUserProfilesErrors, GetApiUserProfilesResponses, GetApiUsersNeedingActionByIdData, GetApiUsersNeedingActionByIdErrors, GetApiUsersNeedingActionByIdResponses, GetApiUsersNeedingActionData, GetApiUsersNeedingActionErrors, GetApiUsersNeedingActionResponses, GetApiUserUiSettingsByIdData, GetApiUserUiSettingsByIdErrors, GetApiUserUiSettingsByIdResponses, GetApiUserUiSettingsData, GetApiUserUiSettingsErrors, GetApiUserUiSettingsResponses, GetApiWearablesGarminCallbackData, GetApiWearablesGarminStatusData, GetApiWearablesGarminStatusErrors, GetApiWearablesGarminStatusResponses, GetApiWearableSourcePreferencesByIdData, GetApiWearableSourcePreferencesByIdErrors, GetApiWearableSourcePreferencesByIdResponses, GetApiWearableSourcePreferencesData, GetApiWearableSourcePreferencesErrors, GetApiWearableSourcePreferencesResponses, GetApiWearablesPreferredSnapshotsData, GetApiWearablesPreferredSnapshotsErrors, GetApiWearablesPreferredSnapshotsResponses, GetApiWearablesSourceOptionsData, GetApiWearablesSourceOptionsErrors, GetApiWearablesSourceOptionsResponses, GetApiWearablesSourceRefreshStatusData, GetApiWearablesSourceRefreshStatusErrors, GetApiWearablesSourceRefreshStatusResponses, GetApiWearablesSyncAccountData, GetApiWearablesSyncAccountErrors, GetApiWearablesSyncAccountResponses, GetHealthData, PostApiAdminFurstImportImportData, PostApiAdminFurstImportSearchData, PostApiAdminHelfoEngineEvaluateData, PostApiAdminHelfoEngineEvaluateErrors, PostApiAdminHelfoEngineEvaluateResponses, PostApiAdminHelfoEngineValidateClinicalInfoData, PostApiAdminHelfoEngineValidateClinicalInfoErrors, PostApiAdminHelfoEngineValidateClinicalInfoResponses, PostApiAdminLabVisitRequisitionsByIdEtterrekvireringData, PostApiAdminLabVisitRequisitionsByIdEtterrekvireringErrors, PostApiAdminLabVisitRequisitionsByIdEtterrekvireringResponses, PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateData, PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateErrors, PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateResponses, PostApiAdminLabVisitsByIdGenerateAssessmentsData, PostApiAdminLabVisitsByIdGenerateAssessmentsErrors, PostApiAdminLabVisitsByIdGenerateAssessmentsResponses, PostApiAdminLabVisitsByIdMockLabResultsData, PostApiAdminLabVisitsByIdMockLabResultsErrors, PostApiAdminLabVisitsByIdMockLabResultsResponses, PostApiAdminLabVisitsByIdRequisitionData, PostApiAdminLabVisitsByIdRequisitionErrors, PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedData, PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedErrors, PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedResponses, PostApiAdminLabVisitsByIdRequisitionResponses, PostApiAdminLabVisitsByIdRevertStatusData, PostApiAdminLabVisitsByIdRevertStatusErrors, PostApiAdminLabVisitsByIdRevertStatusResponses, PostApiAiKnowledgeChunksData, PostApiAiKnowledgeChunksErrors, PostApiAiKnowledgeChunksResponses, PostApiAminoAgeAnalyzeData, PostApiAminoAgeAnalyzeErrors, PostApiAminoAgeAnalyzeResponses, PostApiAminoAgeCorrelationConfigsByIdActivateData, PostApiAminoAgeCorrelationConfigsByIdActivateErrors, PostApiAminoAgeCorrelationConfigsByIdActivateResponses, PostApiAminoAgeCorrelationConfigsData, PostApiAminoAgeCorrelationConfigsErrors, PostApiAminoAgeCorrelationConfigsResponses, PostApiAminoAgeRefreshCategoryTrendData, PostApiAminoAgeRefreshCategoryTrendErrors, PostApiAminoAgeRefreshCategoryTrendResponses, PostApiAminoAgeRefreshTrendsData, PostApiAminoAgeRefreshTrendsErrors, PostApiAminoAgeRefreshTrendsResponses, PostApiAminoAgeSnapshotsData, PostApiAminoAgeSnapshotsErrors, PostApiAminoAgeSnapshotsResponses, PostApiAminoAgeTrendAssessmentsData, PostApiAminoAgeTrendAssessmentsErrors, PostApiAminoAgeTrendAssessmentsResponses, PostApiAnalyticsQueryData, PostApiAnalyticsQueryErrors, PostApiAnalyticsQueryResponses, PostApiAssessmentAiMetadataData, PostApiAssessmentAiMetadataErrors, PostApiAssessmentAiMetadataResponses, PostApiAssessmentEmphasizedBiometricsData, PostApiAssessmentEmphasizedBiometricsErrors, PostApiAssessmentEmphasizedBiometricsResponses, PostApiAssessmentRecommendationProgressData, PostApiAssessmentRecommendationProgressErrors, PostApiAssessmentRecommendationProgressResponses, PostApiAssessmentRecommendationsData, PostApiAssessmentRecommendationsErrors, PostApiAssessmentRecommendationsResponses, PostApiAssessmentsData, PostApiAssessmentsErrors, PostApiAssessmentsResponses, PostApiAssessmentVariantMetadataData, PostApiAssessmentVariantMetadataErrors, PostApiAssessmentVariantMetadataResponses, PostApiAssessmentVariantsData, PostApiAssessmentVariantsErrors, PostApiAssessmentVariantsResponses, PostApiAuditLogsData, PostApiAuditLogsErrors, PostApiAuditLogsResponses, PostApiAuthDevNewUserData, PostApiAuthMintTokenData, PostApiAuthorizationCreateImpersonationCodeData, PostApiAuthorizationCreateImpersonationCodeErrors, PostApiAuthorizationCreateImpersonationCodeResponses, PostApiAuthorizationDailyPatientLimitResetData, PostApiAuthorizationDailyPatientLimitResetErrors, PostApiAuthorizationDailyPatientLimitResetResponses, PostApiAuthorizationExchangeImpersonationCodeData, PostApiAuthorizationExchangeImpersonationCodeErrors, PostApiAuthorizationExchangeImpersonationCodeResponses, PostApiAuthorizationImpersonateData, PostApiAuthorizationImpersonateErrors, PostApiAuthorizationImpersonateResponses, PostApiAuthorizationMintAdminTokenData, PostApiAuthorizationMintAdminTokenErrors, PostApiAuthorizationMintAdminTokenResponses, PostApiAuthorizationRefreshTokenData, PostApiAuthorizationRefreshTokenErrors, PostApiAuthorizationRefreshTokenResponses, PostApiAuthorizationUserRolesData, PostApiAuthorizationUserRolesErrors, PostApiAuthorizationUserRolesResponses, PostApiAuthRefreshTokenData, PostApiAuthRefreshTokenErrors, PostApiAuthRefreshTokenResponses, PostApiBedriftContactData, PostApiBhtQuestionAlternativesData, PostApiBhtQuestionAlternativesErrors, PostApiBhtQuestionAlternativesResponses, PostApiBhtQuestionResponsesData, PostApiBhtQuestionResponsesErrors, PostApiBhtQuestionResponsesResponses, PostApiBhtQuestionsData, PostApiBhtQuestionsErrors, PostApiBhtQuestionsResponses, PostApiBillingCancelSubscriptionData, PostApiBillingCancelSubscriptionErrors, PostApiBillingCancelSubscriptionResponses, PostApiBillingCheckDiscountData, PostApiBillingCheckDiscountErrors, PostApiBillingCheckDiscountResponses, PostApiBillingCreateDraftData, PostApiBillingCreateDraftErrors, PostApiBillingCreateDraftResponses, PostApiBillingCreateSinglePaymentData, PostApiBillingCreateSinglePaymentErrors, PostApiBillingCreateSinglePaymentResponses, PostApiBillingCreateUpgradePaymentData, PostApiBillingCreateUpgradePaymentErrors, PostApiBillingCreateUpgradePaymentResponses, PostApiBillingPollSinglePaymentStatusData, PostApiBillingPollSinglePaymentStatusErrors, PostApiBillingPollSinglePaymentStatusResponses, PostApiBillingPollSubscriptionStatusData, PostApiBillingPollSubscriptionStatusErrors, PostApiBillingPollSubscriptionStatusResponses, PostApiBillingRefreshSubscriptionData, PostApiBillingRefreshSubscriptionErrors, PostApiBillingRefreshSubscriptionResponses, PostApiBillingUndoCancelSubscriptionData, PostApiBillingUndoCancelSubscriptionErrors, PostApiBillingUndoCancelSubscriptionResponses, PostApiBillingUpdateSubscriptionData, PostApiBillingUpdateSubscriptionErrors, PostApiBillingUpdateSubscriptionResponses, PostApiBiometricCategoriesData, PostApiBiometricCategoriesErrors, PostApiBiometricCategoriesResponses, PostApiBiometricPricesData, PostApiBiometricPricesErrors, PostApiBiometricPricesResponses, PostApiBiometricReferenceRangesData, PostApiBiometricReferenceRangesErrors, PostApiBiometricReferenceRangesResponses, PostApiBiometricResultsData, PostApiBiometricResultsErrors, PostApiBiometricResultsResponses, PostApiBiometricsData, PostApiBiometricsErrors, PostApiBiometricsResponses, PostApiBloodTestPackagesData, PostApiBloodTestPackagesErrors, PostApiBloodTestPackagesResponses, PostApiCategoriesData, PostApiCategoriesErrors, PostApiCategoriesResponses, PostApiCompaniesData, PostApiCompaniesErrors, PostApiCompaniesResponses, PostApiConsultationNotesData, PostApiConsultationNotesErrors, PostApiConsultationNotesResponses, PostApiCrmUserData, PostApiCrmUserErrors, PostApiCrmUserResponses, PostApiDashboardsB2bEconomicsCompanyEconomicsRunData, PostApiDashboardsB2bEconomicsCompanyEconomicsRunErrors, PostApiDashboardsB2bEconomicsCompanyEconomicsRunResponses, PostApiDashboardsB2bEconomicsMarkerUsageRunData, PostApiDashboardsB2bEconomicsMarkerUsageRunErrors, PostApiDashboardsB2bEconomicsMarkerUsageRunResponses, PostApiDashboardsB2bEconomicsProductEconomicsRunData, PostApiDashboardsB2bEconomicsProductEconomicsRunErrors, PostApiDashboardsB2bEconomicsProductEconomicsRunResponses, PostApiDashboardsB2bEconomicsSamplingRatesRunData, PostApiDashboardsB2bEconomicsSamplingRatesRunErrors, PostApiDashboardsB2bEconomicsSamplingRatesRunResponses, PostApiDashboardsB2bLabVisitsCompanyTotalsRunData, PostApiDashboardsB2bLabVisitsCompanyTotalsRunErrors, PostApiDashboardsB2bLabVisitsCompanyTotalsRunResponses, PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunData, PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunErrors, PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunResponses, PostApiDashboardsB2bLabVisitsStatusBreakdownRunData, PostApiDashboardsB2bLabVisitsStatusBreakdownRunErrors, PostApiDashboardsB2bLabVisitsStatusBreakdownRunResponses, PostApiDashboardsB2bLabVisitsVisitsOverTimeRunData, PostApiDashboardsB2bLabVisitsVisitsOverTimeRunErrors, PostApiDashboardsB2bLabVisitsVisitsOverTimeRunResponses, PostApiDashboardsChurnActiveTrendRunData, PostApiDashboardsChurnActiveTrendRunErrors, PostApiDashboardsChurnActiveTrendRunResponses, PostApiDashboardsChurnAvailableTiersRunData, PostApiDashboardsChurnAvailableTiersRunErrors, PostApiDashboardsChurnAvailableTiersRunResponses, PostApiDashboardsChurnHeadlineRunData, PostApiDashboardsChurnHeadlineRunErrors, PostApiDashboardsChurnHeadlineRunResponses, PostApiDashboardsChurnTimeToChurnRunData, PostApiDashboardsChurnTimeToChurnRunErrors, PostApiDashboardsChurnTimeToChurnRunResponses, PostApiDashboardsChurnYoyRetentionRunData, PostApiDashboardsChurnYoyRetentionRunErrors, PostApiDashboardsChurnYoyRetentionRunResponses, PostApiDashboardsCohortConversionCohortGridRunData, PostApiDashboardsCohortConversionCohortGridRunErrors, PostApiDashboardsCohortConversionCohortGridRunResponses, PostApiDashboardsCohortConversionDemographicAgeRunData, PostApiDashboardsCohortConversionDemographicAgeRunErrors, PostApiDashboardsCohortConversionDemographicAgeRunResponses, PostApiDashboardsCohortConversionDemographicGenderRunData, PostApiDashboardsCohortConversionDemographicGenderRunErrors, PostApiDashboardsCohortConversionDemographicGenderRunResponses, PostApiDashboardsCohortConversionKpisRunData, PostApiDashboardsCohortConversionKpisRunErrors, PostApiDashboardsCohortConversionKpisRunResponses, PostApiDashboardsCohortConversionTimeToConvertRunData, PostApiDashboardsCohortConversionTimeToConvertRunErrors, PostApiDashboardsCohortConversionTimeToConvertRunResponses, PostApiDashboardsCustomerAttributionSourcesRunData, PostApiDashboardsCustomerAttributionSourcesRunErrors, PostApiDashboardsCustomerAttributionSourcesRunResponses, PostApiDashboardsCustomerPortraitSnapshotRunData, PostApiDashboardsCustomerPortraitSnapshotRunErrors, PostApiDashboardsCustomerPortraitSnapshotRunResponses, PostApiDashboardsDiscountCodesCodeTotalsRunData, PostApiDashboardsDiscountCodesCodeTotalsRunErrors, PostApiDashboardsDiscountCodesCodeTotalsRunResponses, PostApiDashboardsDiscountCodesUsageOverTimeRunData, PostApiDashboardsDiscountCodesUsageOverTimeRunErrors, PostApiDashboardsDiscountCodesUsageOverTimeRunResponses, PostApiDashboardsDiscountCodesUsersForCodeRunData, PostApiDashboardsDiscountCodesUsersForCodeRunErrors, PostApiDashboardsDiscountCodesUsersForCodeRunResponses, PostApiDashboardsFeedbackNegativeFeedbackRunData, PostApiDashboardsFeedbackNegativeFeedbackRunErrors, PostApiDashboardsFeedbackNegativeFeedbackRunResponses, PostApiDashboardsFeedbackPlatformSplitRunData, PostApiDashboardsFeedbackPlatformSplitRunErrors, PostApiDashboardsFeedbackPlatformSplitRunResponses, PostApiDashboardsFeedbackSummaryRunData, PostApiDashboardsFeedbackSummaryRunErrors, PostApiDashboardsFeedbackSummaryRunResponses, PostApiDashboardsFeedbackSurfaceSummaryRunData, PostApiDashboardsFeedbackSurfaceSummaryRunErrors, PostApiDashboardsFeedbackSurfaceSummaryRunResponses, PostApiDashboardsFeedbackWeeklyRunData, PostApiDashboardsFeedbackWeeklyRunErrors, PostApiDashboardsFeedbackWeeklyRunResponses, PostApiDashboardsHealthOutcomesOptionsRunData, PostApiDashboardsHealthOutcomesOptionsRunErrors, PostApiDashboardsHealthOutcomesOptionsRunResponses, PostApiDashboardsHealthOutcomesSnapshotRunData, PostApiDashboardsHealthOutcomesSnapshotRunErrors, PostApiDashboardsHealthOutcomesSnapshotRunResponses, PostApiDashboardsHelfoRulesV2ComparisonRunData, PostApiDashboardsHelfoRulesV2ComparisonRunErrors, PostApiDashboardsHelfoRulesV2ComparisonRunResponses, PostApiDashboardsLabUsageLabTotalsRunData, PostApiDashboardsLabUsageLabTotalsRunErrors, PostApiDashboardsLabUsageLabTotalsRunResponses, PostApiDashboardsLabUsageVisitsOverTimeRunData, PostApiDashboardsLabUsageVisitsOverTimeRunErrors, PostApiDashboardsLabUsageVisitsOverTimeRunResponses, PostApiDashboardsLeadsAbandonedCheckoutRunData, PostApiDashboardsLeadsAbandonedCheckoutRunErrors, PostApiDashboardsLeadsAbandonedCheckoutRunResponses, PostApiDashboardsLeadsB2bNoPersonalPurchaseRunData, PostApiDashboardsLeadsB2bNoPersonalPurchaseRunErrors, PostApiDashboardsLeadsB2bNoPersonalPurchaseRunResponses, PostApiDashboardsLeadsBankidNoPurchaseRunData, PostApiDashboardsLeadsBankidNoPurchaseRunErrors, PostApiDashboardsLeadsBankidNoPurchaseRunResponses, PostApiDashboardsLeadsChurnedSubscribersRunData, PostApiDashboardsLeadsChurnedSubscribersRunErrors, PostApiDashboardsLeadsChurnedSubscribersRunResponses, PostApiDashboardsLeadsEmailNoBankidRunData, PostApiDashboardsLeadsEmailNoBankidRunErrors, PostApiDashboardsLeadsEmailNoBankidRunResponses, PostApiDashboardsLeadsExclusionsRunData, PostApiDashboardsLeadsExclusionsRunErrors, PostApiDashboardsLeadsExclusionsRunResponses, PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunData, PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunErrors, PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunData, PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunErrors, PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunData, PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunErrors, PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyStartedNotFinishedRunData, PostApiDashboardsLeadsSurveyStartedNotFinishedRunErrors, PostApiDashboardsLeadsSurveyStartedNotFinishedRunResponses, PostApiDashboardsLeadsTierSelectedNoPurchaseRunData, PostApiDashboardsLeadsTierSelectedNoPurchaseRunErrors, PostApiDashboardsLeadsTierSelectedNoPurchaseRunResponses, PostApiDashboardsLeadsWearableNoPurchaseRunData, PostApiDashboardsLeadsWearableNoPurchaseRunErrors, PostApiDashboardsLeadsWearableNoPurchaseRunResponses, PostApiDashboardsReferralsDemographicsOverTimeRunData, PostApiDashboardsReferralsDemographicsOverTimeRunErrors, PostApiDashboardsReferralsDemographicsOverTimeRunResponses, PostApiDashboardsReferralsFilterOptionsRunData, PostApiDashboardsReferralsFilterOptionsRunErrors, PostApiDashboardsReferralsFilterOptionsRunResponses, PostApiDashboardsReferralsReferralsOverTimeRunData, PostApiDashboardsReferralsReferralsOverTimeRunErrors, PostApiDashboardsReferralsReferralsOverTimeRunResponses, PostApiDashboardsReferralsReferrersRunData, PostApiDashboardsReferralsReferrersRunErrors, PostApiDashboardsReferralsReferrersRunResponses, PostApiDashboardsReferralsVervetCodeOverTimeRunData, PostApiDashboardsReferralsVervetCodeOverTimeRunErrors, PostApiDashboardsReferralsVervetCodeOverTimeRunResponses, PostApiDoctorMessagesThreadsByIdMessagesData, PostApiDoctorMessagesThreadsByIdMessagesErrors, PostApiDoctorMessagesThreadsByIdMessagesResponses, PostApiDoctorMessagesThreadsByIdReplyData, PostApiDoctorMessagesThreadsByIdReplyErrors, PostApiDoctorMessagesThreadsByIdReplyResponses, PostApiDoctorMessagesThreadsByIdReplySuggestionData, PostApiDoctorMessagesThreadsByIdReplySuggestionErrors, PostApiDoctorMessagesThreadsByIdReplySuggestionResponses, PostApiDoctorMessagesThreadsByIdStatusData, PostApiDoctorMessagesThreadsByIdStatusErrors, PostApiDoctorMessagesThreadsByIdStatusResponses, PostApiDoctorMessagesThreadsData, PostApiDoctorMessagesThreadsErrors, PostApiDoctorMessagesThreadsResponses, PostApiFeatureFlagsData, PostApiFeatureFlagsErrors, PostApiFeatureFlagsResponses, PostApiFeedbackData, PostApiFeedbackErrors, PostApiFeedbackResponses, PostApiFurstAnalysisHistoryData, PostApiFurstAnalysisHistoryErrors, PostApiFurstAnalysisHistoryResponses, PostApiGarminBodyBatterySamplesData, PostApiGarminBodyBatterySamplesErrors, PostApiGarminBodyBatterySamplesResponses, PostApiGarminDailySnapshotsData, PostApiGarminDailySnapshotsErrors, PostApiGarminDailySnapshotsResponses, PostApiHealthDailySnapshotsData, PostApiHealthDailySnapshotsErrors, PostApiHealthDailySnapshotsResponses, PostApiInternalNotesData, PostApiInternalNotesErrors, PostApiInternalNotesResponses, PostApiInternalUserCommentsData, PostApiInternalUserCommentsErrors, PostApiInternalUserCommentsResponses, PostApiInvoicesData, PostApiInvoicesErrors, PostApiInvoicesResponses, PostApiJournalNotesData, PostApiJournalNotesErrors, PostApiJournalNotesResponses, PostApiLabPricesData, PostApiLabPricesErrors, PostApiLabPricesResponses, PostApiLabsData, PostApiLabsErrors, PostApiLabsResponses, PostApiLabVisitRequisitionBiometricsData, PostApiLabVisitRequisitionBiometricsErrors, PostApiLabVisitRequisitionBiometricsResponses, PostApiLabVisitRequisitionsData, PostApiLabVisitRequisitionsErrors, PostApiLabVisitRequisitionsResponses, PostApiLabVisitsData, PostApiLabVisitsErrors, PostApiLabVisitsResponses, PostApiLabVisitUserNotesData, PostApiLabVisitUserNotesErrors, PostApiLabVisitUserNotesResponses, PostApiLiaisonWebhookSvarLabData, PostApiMarketingReferralsData, PostApiMarketingReferralsErrors, PostApiMarketingReferralsResponses, PostApiMetricSourcePreferencesData, PostApiMetricSourcePreferencesErrors, PostApiMetricSourcePreferencesResponses, PostApiOnboardingByIdConsentData, PostApiOnboardingData, PostApiOnboardingErrors, PostApiOnboardingResponses, PostApiPricesData, PostApiPricesErrors, PostApiPricesResponses, PostApiQuestionAlternativesData, PostApiQuestionAlternativesErrors, PostApiQuestionAlternativesResponses, PostApiQuestionCategoriesData, PostApiQuestionCategoriesErrors, PostApiQuestionCategoriesResponses, PostApiQuestionNumericRulesData, PostApiQuestionNumericRulesErrors, PostApiQuestionNumericRulesResponses, PostApiQuestionResponsesData, PostApiQuestionResponsesErrors, PostApiQuestionResponsesResponses, PostApiQuestionsData, PostApiQuestionsErrors, PostApiQuestionsResponses, PostApiRagDocumentsData, PostApiRagDocumentsErrors, PostApiRagDocumentsResponses, PostApiRecruitmentCodesData, PostApiRecruitmentCodesErrors, PostApiRecruitmentCodesResponses, PostApiSinglePaymentsData, PostApiSinglePaymentsErrors, PostApiSinglePaymentsResponses, PostApiStatusHistoryData, PostApiStatusHistoryErrors, PostApiStatusHistoryResponses, PostApiSubscriptionsData, PostApiSubscriptionsErrors, PostApiSubscriptionsResponses, PostApiSystemApiKeysByIdRevokeData, PostApiSystemApiKeysByIdRevokeErrors, PostApiSystemApiKeysByIdRevokeResponses, PostApiSystemApiKeysData, PostApiSystemApiKeysResponses, PostApiSystemCronJobsByWorkerTriggerData, PostApiSystemCronJobsByWorkerTriggerErrors, PostApiSystemCronJobsByWorkerTriggerResponses, PostApiSystemJobsByIdCancelData, PostApiSystemJobsByIdCancelErrors, PostApiSystemJobsByIdCancelResponses, PostApiSystemJobsByIdRequeueData, PostApiSystemJobsByIdRequeueErrors, PostApiSystemJobsByIdRequeueResponses, PostApiSystemJobsByIdRetryData, PostApiSystemJobsByIdRetryErrors, PostApiSystemJobsByIdRetryResponses, PostApiSystemJobsCleanupData, PostApiSystemJobsCleanupResponses, PostApiSystemJobsData, PostApiSystemJobsErrors, PostApiSystemJobsRecoverStuckData, PostApiSystemJobsRecoverStuckResponses, PostApiSystemJobsResponses, PostApiSystemLogsCleanupData, PostApiSystemLogsCleanupResponses, PostApiSystemLogsSignatureMuteData, PostApiSystemLogsSignatureMuteResponses, PostApiSystemLogsSignatureResolveData, PostApiSystemLogsSignatureResolveResponses, PostApiUserDevicePushTokensData, PostApiUserDevicePushTokensErrors, PostApiUserDevicePushTokensResponses, PostApiUserFeatureFlagsData, PostApiUserFeatureFlagsErrors, PostApiUserFeatureFlagsResponses, PostApiUserPlanActionProgressData, PostApiUserPlanActionProgressErrors, PostApiUserPlanActionProgressResponses, PostApiUserPlanActionsData, PostApiUserPlanActionsErrors, PostApiUserPlanActionsResponses, PostApiUserProfilesConsentData, PostApiUserProfilesData, PostApiUserProfilesEmailVerificationConfirmData, PostApiUserProfilesEmailVerificationConfirmErrors, PostApiUserProfilesEmailVerificationConfirmResponses, PostApiUserProfilesEmailVerificationData, PostApiUserProfilesEmailVerificationErrors, PostApiUserProfilesEmailVerificationResponses, PostApiUserProfilesErrors, PostApiUserProfilesResponses, PostApiUsersNeedingActionData, PostApiUsersNeedingActionErrors, PostApiUsersNeedingActionResponses, PostApiUserUiSettingsData, PostApiUserUiSettingsErrors, PostApiUserUiSettingsResponses, PostApiWearablesAppleHealthSnapshotsData, PostApiWearablesAppleHealthSnapshotsErrors, PostApiWearablesAppleHealthSnapshotsResponses, PostApiWearablesGarminBackfillData, PostApiWearablesGarminBackfillErrors, PostApiWearablesGarminBackfillResponses, PostApiWearablesGarminLoginData, PostApiWearablesGarminLoginErrors, PostApiWearablesGarminLoginResponses, PostApiWearablesGarminRefreshData, PostApiWearablesGarminRefreshErrors, PostApiWearablesGarminRefreshResponses, PostApiWearablesGarminWebhookData, PostApiWearablesGarminWebhookErrors, PostApiWearablesGarminWebhookResponses, PostApiWearablesHealthConnectSnapshotsData, PostApiWearablesHealthConnectSnapshotsErrors, PostApiWearablesHealthConnectSnapshotsResponses, PostApiWearableSourcePreferencesData, PostApiWearableSourcePreferencesErrors, PostApiWearableSourcePreferencesResponses, PostApiWebhooksLiaisonApprecData, PostApiWebhooksPeriodeData, PostLiaisonWebhookSvarLabData, PostWebhooksLiaisonApprecData, PutApiAdminLabVisitsByLabVisitIdMarkersData, PutApiAdminLabVisitsByLabVisitIdMarkersErrors, PutApiAdminLabVisitsByLabVisitIdMarkersResponses, PutApiAiKnowledgeChunksByIdData, PutApiAiKnowledgeChunksByIdErrors, PutApiAiKnowledgeChunksByIdResponses, PutApiAminoAgeCorrelationConfigsByIdData, PutApiAminoAgeCorrelationConfigsByIdErrors, PutApiAminoAgeCorrelationConfigsByIdResponses, PutApiAminoAgeSnapshotsByIdData, PutApiAminoAgeSnapshotsByIdErrors, PutApiAminoAgeSnapshotsByIdResponses, PutApiAminoAgeTrendAssessmentsByIdData, PutApiAminoAgeTrendAssessmentsByIdErrors, PutApiAminoAgeTrendAssessmentsByIdResponses, PutApiAssessmentAiMetadataByIdData, PutApiAssessmentAiMetadataByIdErrors, PutApiAssessmentAiMetadataByIdResponses, PutApiAssessmentEmphasizedBiometricsByIdData, PutApiAssessmentEmphasizedBiometricsByIdErrors, PutApiAssessmentEmphasizedBiometricsByIdResponses, PutApiAssessmentRecommendationProgressByIdData, PutApiAssessmentRecommendationProgressByIdErrors, PutApiAssessmentRecommendationProgressByIdResponses, PutApiAssessmentRecommendationsByIdData, PutApiAssessmentRecommendationsByIdErrors, PutApiAssessmentRecommendationsByIdResponses, PutApiAssessmentsByIdData, PutApiAssessmentsByIdErrors, PutApiAssessmentsByIdResponses, PutApiAssessmentVariantMetadataByIdData, PutApiAssessmentVariantMetadataByIdErrors, PutApiAssessmentVariantMetadataByIdResponses, PutApiAssessmentVariantsByIdData, PutApiAssessmentVariantsByIdErrors, PutApiAssessmentVariantsByIdResponses, PutApiAuditLogsByIdData, PutApiAuditLogsByIdErrors, PutApiAuditLogsByIdResponses, PutApiAuthorizationUserRolesByIdData, PutApiAuthorizationUserRolesByIdErrors, PutApiAuthorizationUserRolesByIdResponses, PutApiBhtQuestionAlternativesByIdData, PutApiBhtQuestionAlternativesByIdErrors, PutApiBhtQuestionAlternativesByIdResponses, PutApiBhtQuestionResponsesByIdData, PutApiBhtQuestionResponsesByIdErrors, PutApiBhtQuestionResponsesByIdResponses, PutApiBhtQuestionsByIdData, PutApiBhtQuestionsByIdErrors, PutApiBhtQuestionsByIdResponses, PutApiBiometricCategoriesByIdData, PutApiBiometricCategoriesByIdErrors, PutApiBiometricCategoriesByIdResponses, PutApiBiometricPricesByIdData, PutApiBiometricPricesByIdErrors, PutApiBiometricPricesByIdResponses, PutApiBiometricReferenceRangesByIdData, PutApiBiometricReferenceRangesByIdErrors, PutApiBiometricReferenceRangesByIdResponses, PutApiBiometricResultsByIdData, PutApiBiometricResultsByIdErrors, PutApiBiometricResultsByIdResponses, PutApiBiometricsByIdData, PutApiBiometricsByIdErrors, PutApiBiometricsByIdResponses, PutApiBloodTestPackagesByIdData, PutApiBloodTestPackagesByIdErrors, PutApiBloodTestPackagesByIdResponses, PutApiCategoriesByIdData, PutApiCategoriesByIdErrors, PutApiCategoriesByIdResponses, PutApiCompaniesByIdData, PutApiCompaniesByIdErrors, PutApiCompaniesByIdResponses, PutApiConsultationNotesByIdData, PutApiConsultationNotesByIdErrors, PutApiConsultationNotesByIdResponses, PutApiCrmUserByIdData, PutApiCrmUserByIdErrors, PutApiCrmUserByIdResponses, PutApiFeatureFlagsByIdData, PutApiFeatureFlagsByIdErrors, PutApiFeatureFlagsByIdResponses, PutApiFeedbackByIdData, PutApiFeedbackByIdErrors, PutApiFeedbackByIdResponses, PutApiFurstAnalysisHistoryByIdData, PutApiFurstAnalysisHistoryByIdErrors, PutApiFurstAnalysisHistoryByIdResponses, PutApiGarminBodyBatterySamplesByIdData, PutApiGarminBodyBatterySamplesByIdErrors, PutApiGarminBodyBatterySamplesByIdResponses, PutApiGarminDailySnapshotsByIdData, PutApiGarminDailySnapshotsByIdErrors, PutApiGarminDailySnapshotsByIdResponses, PutApiHealthDailySnapshotsByIdData, PutApiHealthDailySnapshotsByIdErrors, PutApiHealthDailySnapshotsByIdResponses, PutApiInternalNotesByIdData, PutApiInternalNotesByIdErrors, PutApiInternalNotesByIdResponses, PutApiInternalUserCommentsByIdData, PutApiInternalUserCommentsByIdErrors, PutApiInternalUserCommentsByIdResponses, PutApiInvoicesByIdData, PutApiInvoicesByIdErrors, PutApiInvoicesByIdResponses, PutApiJournalNotesByIdData, PutApiJournalNotesByIdErrors, PutApiJournalNotesByIdResponses, PutApiLabPricesByIdData, PutApiLabPricesByIdErrors, PutApiLabPricesByIdResponses, PutApiLabsByIdData, PutApiLabsByIdErrors, PutApiLabsByIdResponses, PutApiLabVisitRequisitionBiometricsByIdData, PutApiLabVisitRequisitionBiometricsByIdErrors, PutApiLabVisitRequisitionBiometricsByIdResponses, PutApiLabVisitRequisitionsByIdData, PutApiLabVisitRequisitionsByIdErrors, PutApiLabVisitRequisitionsByIdResponses, PutApiLabVisitsByIdData, PutApiLabVisitsByIdErrors, PutApiLabVisitsByIdResponses, PutApiLabVisitUserNotesByIdData, PutApiLabVisitUserNotesByIdErrors, PutApiLabVisitUserNotesByIdResponses, PutApiMarketingReferralsByIdData, PutApiMarketingReferralsByIdErrors, PutApiMarketingReferralsByIdResponses, PutApiMetricSourcePreferencesByIdData, PutApiMetricSourcePreferencesByIdErrors, PutApiMetricSourcePreferencesByIdResponses, PutApiOnboardingByIdData, PutApiOnboardingByIdErrors, PutApiOnboardingByIdResponses, PutApiPricesByIdData, PutApiPricesByIdErrors, PutApiPricesByIdResponses, PutApiQuestionAlternativesByIdData, PutApiQuestionAlternativesByIdErrors, PutApiQuestionAlternativesByIdResponses, PutApiQuestionCategoriesByIdData, PutApiQuestionCategoriesByIdErrors, PutApiQuestionCategoriesByIdResponses, PutApiQuestionNumericRulesByIdData, PutApiQuestionNumericRulesByIdErrors, PutApiQuestionNumericRulesByIdResponses, PutApiQuestionResponsesByIdData, PutApiQuestionResponsesByIdErrors, PutApiQuestionResponsesByIdResponses, PutApiQuestionsByIdData, PutApiQuestionsByIdErrors, PutApiQuestionsByIdResponses, PutApiRagDocumentsByIdData, PutApiRagDocumentsByIdErrors, PutApiRagDocumentsByIdResponses, PutApiRecruitmentCodesByIdData, PutApiRecruitmentCodesByIdErrors, PutApiRecruitmentCodesByIdResponses, PutApiSinglePaymentsByIdData, PutApiSinglePaymentsByIdErrors, PutApiSinglePaymentsByIdResponses, PutApiStatusHistoryByIdData, PutApiStatusHistoryByIdErrors, PutApiStatusHistoryByIdResponses, PutApiSubscriptionsByIdData, PutApiSubscriptionsByIdErrors, PutApiSubscriptionsByIdResponses, PutApiUserDevicePushTokensByIdData, PutApiUserDevicePushTokensByIdErrors, PutApiUserDevicePushTokensByIdResponses, PutApiUserFeatureFlagsByIdData, PutApiUserFeatureFlagsByIdErrors, PutApiUserFeatureFlagsByIdResponses, PutApiUserPlanActionProgressByIdData, PutApiUserPlanActionProgressByIdErrors, PutApiUserPlanActionProgressByIdResponses, PutApiUserPlanActionsByIdData, PutApiUserPlanActionsByIdErrors, PutApiUserPlanActionsByIdResponses, PutApiUserProfilesByIdData, PutApiUserProfilesByIdErrors, PutApiUserProfilesByIdResponses, PutApiUsersNeedingActionByIdData, PutApiUsersNeedingActionByIdErrors, PutApiUsersNeedingActionByIdResponses, PutApiUserUiSettingsByIdData, PutApiUserUiSettingsByIdErrors, PutApiUserUiSettingsByIdResponses, PutApiWearableSourcePreferencesByIdData, PutApiWearableSourcePreferencesByIdErrors, PutApiWearableSourcePreferencesByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class LabVisitsService {
    /**
     * Import lab results from Furst requisitions
     *
     * Fetches requisition details from Furst and imports lab results. Supports dry run mode for previewing results. Requires admin authentication and a valid FURST session cookie.
     */
    public static postApiAdminFurstImportImport<ThrowOnError extends boolean = false>(options: Options<PostApiAdminFurstImportImportData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/furst-import/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Search Furst patient history by date range
     *
     * Searches Furst patient history for a date range and enriches results with Amino user data. Requires admin authentication and a valid FURST session cookie.
     */
    public static postApiAdminFurstImportSearch<ThrowOnError extends boolean = false>(options: Options<PostApiAdminFurstImportSearchData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/furst-import/search',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Send supplementary requisition (etterrekvirering) to FURST
     *
     * Looks up patient history to find active prøve, then submits additional biomarkers as a supplementary requisition. Requires admin authentication and a valid FURST session cookie.
     */
    public static postApiAdminLabVisitRequisitionsByIdEtterrekvirering<ThrowOnError extends boolean = false>(options: Options<PostApiAdminLabVisitRequisitionsByIdEtterrekvireringData, ThrowOnError>): RequestResult<PostApiAdminLabVisitRequisitionsByIdEtterrekvireringResponses, PostApiAdminLabVisitRequisitionsByIdEtterrekvireringErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminLabVisitRequisitionsByIdEtterrekvireringResponses, PostApiAdminLabVisitRequisitionsByIdEtterrekvireringErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visit-requisitions/{id}/etterrekvirering',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Generate kliniske opplysninger for a helfo requisition
     *
     * Generates the clinical information (kliniske opplysninger) string from the user's health survey answers. The doctor sees this as an editable pre-fill when selecting biomarkers for a helfo requisition. Requires an impersonation token for that user.
     */
    public static getApiAdminLabVisitsHelfoComment<ThrowOnError extends boolean = false>(options: Options<GetApiAdminLabVisitsHelfoCommentData, ThrowOnError>): RequestResult<GetApiAdminLabVisitsHelfoCommentResponses, GetApiAdminLabVisitsHelfoCommentErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAdminLabVisitsHelfoCommentResponses, GetApiAdminLabVisitsHelfoCommentErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/helfo-comment',
            ...options
        });
    }
    
    /**
     * Get pending requisitions
     *
     * Returns all lab visits with status pendingRequisition. The clinicalInfo field contains the kliniske opplysninger set by the doctor when selecting biomarkers.
     */
    public static getApiAdminLabVisitsPendingRequisitions<ThrowOnError extends boolean = false>(options?: Options<GetApiAdminLabVisitsPendingRequisitionsData, ThrowOnError>): RequestResult<GetApiAdminLabVisitsPendingRequisitionsResponses, GetApiAdminLabVisitsPendingRequisitionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAdminLabVisitsPendingRequisitionsResponses, GetApiAdminLabVisitsPendingRequisitionsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/pending-requisitions',
            ...options
        });
    }
    
    /**
     * Get LLM-generated follow-up questions for a B2B consultation
     *
     * Returns three follow-up questions the doctor should ask the patient based on their health-survey responses (and any prior emphasized lab findings). Generates and caches on the first call; subsequent calls return the cached row. Use the regenerate endpoint to force a refresh. Requires an impersonation token for the visit's patient; any other visit is 404.
     */
    public static getApiAdminLabVisitsByIdFollowupSuggestions<ThrowOnError extends boolean = false>(options: Options<GetApiAdminLabVisitsByIdFollowupSuggestionsData, ThrowOnError>): RequestResult<GetApiAdminLabVisitsByIdFollowupSuggestionsResponses, GetApiAdminLabVisitsByIdFollowupSuggestionsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAdminLabVisitsByIdFollowupSuggestionsResponses, GetApiAdminLabVisitsByIdFollowupSuggestionsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/followup-suggestions',
            ...options
        });
    }
    
    /**
     * Regenerate follow-up question suggestions
     *
     * Forces a fresh LLM generation and upserts the cached row. Use when the cached suggestions are stale or unhelpful. Requires an impersonation token for the visit's patient.
     */
    public static postApiAdminLabVisitsByIdFollowupSuggestionsRegenerate<ThrowOnError extends boolean = false>(options: Options<PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateData, ThrowOnError>): RequestResult<PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateResponses, PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateResponses, PostApiAdminLabVisitsByIdFollowupSuggestionsRegenerateErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/followup-suggestions/regenerate',
            ...options
        });
    }
    
    /**
     * Trigger assessment generation for a lab visit
     *
     * Manually triggers assessment generation for a lab visit. Pipeline defaults to v1; v2 is opt-in with examples=none (B) or examples=retrieved (C). Regenerate replaces non-approved drafts atomically, preserving approved assessments. Returns 409 for incompatible approved/live pipelines or examples modes or an active generation run, before changing drafts. Requires clinician authentication; regeneration requires the clinician's patient-bound impersonation token.
     */
    public static postApiAdminLabVisitsByIdGenerateAssessments<ThrowOnError extends boolean = false>(options: Options<PostApiAdminLabVisitsByIdGenerateAssessmentsData, ThrowOnError>): RequestResult<PostApiAdminLabVisitsByIdGenerateAssessmentsResponses, PostApiAdminLabVisitsByIdGenerateAssessmentsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminLabVisitsByIdGenerateAssessmentsResponses, PostApiAdminLabVisitsByIdGenerateAssessmentsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/generate-assessments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Fake incoming lab results (dev/preview only)
     *
     * Synthesises the payload Fürst would POST to /liaison/webhook/svar_lab for this lab visit's requisitioned biomarkers, stores it in the liaison table and enqueues process-liaison — the same path a real delivery takes. mode='partial' sends half of each requisition's markers with content status 'S' (delsvar), driving requisitions to awaitingResults and the visit to awaitingResults; mode='all' sends the markers still missing a result with status 'F' (endelig), driving them to allResultsReceived / allBiometricResultsReceived. Split HELFO/non-HELFO visits get one svar per requisition in both modes, so each partition completes. Generated values sit inside the biomarker's reference range where one exists. Requires admin authentication and ALLOW_MOCK_LAB_RESULTS=true; always 404s when NODE_ENV=production.
     */
    public static postApiAdminLabVisitsByIdMockLabResults<ThrowOnError extends boolean = false>(options: Options<PostApiAdminLabVisitsByIdMockLabResultsData, ThrowOnError>): RequestResult<PostApiAdminLabVisitsByIdMockLabResultsResponses, PostApiAdminLabVisitsByIdMockLabResultsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminLabVisitsByIdMockLabResultsResponses, PostApiAdminLabVisitsByIdMockLabResultsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/mock-lab-results',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Send lab requisition to FURST
     *
     * Sends a lab requisition to FURST synchronously. Requires admin authentication and a valid FURST session cookie. Patient demographics come from FURST's own folkeregister lookup; pass addressOverride to correct individual address fields for this send only (e.g. a stale postnummer that FURST rejects). Omitted or empty fields fall through to folkeregister. Overridden values are normalized to folkeregister's format before sending — poststed is uppercased, and a postnummer that isn't exactly four digits is rejected with 422 before any FURST call.
     */
    public static postApiAdminLabVisitsByIdRequisition<ThrowOnError extends boolean = false>(options: Options<PostApiAdminLabVisitsByIdRequisitionData, ThrowOnError>): RequestResult<PostApiAdminLabVisitsByIdRequisitionResponses, PostApiAdminLabVisitsByIdRequisitionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminLabVisitsByIdRequisitionResponses, PostApiAdminLabVisitsByIdRequisitionErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/requisition',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Confirm a failed Fürst send was not received
     *
     * A doctor has checked Fürst and the given send attempt is not there. Clears the attempt so the requisition can be resent, edited or cancelled. Allowed when the send failed, or when it has had no outcome for 5 minutes (an interrupted send). Refused once Fürst has acknowledged receipt. The confirmation is recorded on the attempt.
     */
    public static postApiAdminLabVisitsByIdRequisitionFurstNotReceived<ThrowOnError extends boolean = false>(options: Options<PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedData, ThrowOnError>): RequestResult<PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedResponses, PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedResponses, PostApiAdminLabVisitsByIdRequisitionFurstNotReceivedErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/requisition/furst-not-received',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Revert lab visit status (admin only)
     *
     * Directly sets a lab visit status without going through the state machine. Used for admin corrections. No notifications are sent.
     */
    public static postApiAdminLabVisitsByIdRevertStatus<ThrowOnError extends boolean = false>(options: Options<PostApiAdminLabVisitsByIdRevertStatusData, ThrowOnError>): RequestResult<PostApiAdminLabVisitsByIdRevertStatusResponses, PostApiAdminLabVisitsByIdRevertStatusErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminLabVisitsByIdRevertStatusResponses, PostApiAdminLabVisitsByIdRevertStatusErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/revert-status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Structured wearable deltas for a lab visit
     *
     * Returns the structured wearable section that was (or would be) included in the AI input for this lab visit. Returns section=null when the section is omitted (no wearable connected or now-slice too sparse). Answers only the visit's owner, so staff need an impersonation token; any other visit is 404.
     */
    public static getApiAdminLabVisitsByIdWearableDeltas<ThrowOnError extends boolean = false>(options: Options<GetApiAdminLabVisitsByIdWearableDeltasData, ThrowOnError>): RequestResult<GetApiAdminLabVisitsByIdWearableDeltasResponses, GetApiAdminLabVisitsByIdWearableDeltasErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAdminLabVisitsByIdWearableDeltasResponses, GetApiAdminLabVisitsByIdWearableDeltasErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/wearable-deltas',
            ...options
        });
    }
    
    /**
     * Sync the HELFO and non-HELFO marker sets for a lab visit
     *
     * Atomically sets the biometric markers on each partition's draft requisition. Lazy-creates drafts on first touch. clinicalInfo attaches only to the HELFO draft. helfoReasons stamps the engine cluster id (or 'manual: …') per marker. Used by the backoffice marker-selection UI on every toggle.
     */
    public static putApiAdminLabVisitsByLabVisitIdMarkers<ThrowOnError extends boolean = false>(options: Options<PutApiAdminLabVisitsByLabVisitIdMarkersData, ThrowOnError>): RequestResult<PutApiAdminLabVisitsByLabVisitIdMarkersResponses, PutApiAdminLabVisitsByLabVisitIdMarkersErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAdminLabVisitsByLabVisitIdMarkersResponses, PutApiAdminLabVisitsByLabVisitIdMarkersErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{labVisitId}/markers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Current wearable data for a user
     *
     * Returns wearable deltas anchored to today as the now-slice, with the user's most recent lab visit as the comparison point. Returns section=null when the user has no wearable data or the now-slice is too sparse. Answers only that user's own token, so staff need an impersonation token.
     */
    public static getApiAdminUsersByAuthUserIdWearableCurrent<ThrowOnError extends boolean = false>(options: Options<GetApiAdminUsersByAuthUserIdWearableCurrentData, ThrowOnError>): RequestResult<GetApiAdminUsersByAuthUserIdWearableCurrentResponses, GetApiAdminUsersByAuthUserIdWearableCurrentErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAdminUsersByAuthUserIdWearableCurrentResponses, GetApiAdminUsersByAuthUserIdWearableCurrentErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/users/{authUserId}/wearable-current',
            ...options
        });
    }
    
    /**
     * List biometric-results
     */
    public static getApiBiometricResults<ThrowOnError extends boolean = false>(options?: Options<GetApiBiometricResultsData, ThrowOnError>): RequestResult<GetApiBiometricResultsResponses, GetApiBiometricResultsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBiometricResultsResponses, GetApiBiometricResultsErrors, ThrowOnError>({ url: '/api/biometric-results', ...options });
    }
    
    /**
     * Create BiometricResult
     */
    public static postApiBiometricResults<ThrowOnError extends boolean = false>(options: Options<PostApiBiometricResultsData, ThrowOnError>): RequestResult<PostApiBiometricResultsResponses, PostApiBiometricResultsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBiometricResultsResponses, PostApiBiometricResultsErrors, ThrowOnError>({
            url: '/api/biometric-results',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BiometricResult
     */
    public static deleteApiBiometricResultsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBiometricResultsByIdData, ThrowOnError>): RequestResult<DeleteApiBiometricResultsByIdResponses, DeleteApiBiometricResultsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBiometricResultsByIdResponses, DeleteApiBiometricResultsByIdErrors, ThrowOnError>({ url: '/api/biometric-results/{id}', ...options });
    }
    
    /**
     * Get BiometricResult by ID
     */
    public static getApiBiometricResultsById<ThrowOnError extends boolean = false>(options: Options<GetApiBiometricResultsByIdData, ThrowOnError>): RequestResult<GetApiBiometricResultsByIdResponses, GetApiBiometricResultsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBiometricResultsByIdResponses, GetApiBiometricResultsByIdErrors, ThrowOnError>({ url: '/api/biometric-results/{id}', ...options });
    }
    
    /**
     * Update BiometricResult
     */
    public static putApiBiometricResultsById<ThrowOnError extends boolean = false>(options: Options<PutApiBiometricResultsByIdData, ThrowOnError>): RequestResult<PutApiBiometricResultsByIdResponses, PutApiBiometricResultsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBiometricResultsByIdResponses, PutApiBiometricResultsByIdErrors, ThrowOnError>({
            url: '/api/biometric-results/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List consultation-notes
     */
    public static getApiConsultationNotes<ThrowOnError extends boolean = false>(options?: Options<GetApiConsultationNotesData, ThrowOnError>): RequestResult<GetApiConsultationNotesResponses, GetApiConsultationNotesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiConsultationNotesResponses, GetApiConsultationNotesErrors, ThrowOnError>({ url: '/api/consultation-notes', ...options });
    }
    
    /**
     * Create ConsultationNote
     */
    public static postApiConsultationNotes<ThrowOnError extends boolean = false>(options: Options<PostApiConsultationNotesData, ThrowOnError>): RequestResult<PostApiConsultationNotesResponses, PostApiConsultationNotesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiConsultationNotesResponses, PostApiConsultationNotesErrors, ThrowOnError>({
            url: '/api/consultation-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete ConsultationNote
     */
    public static deleteApiConsultationNotesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiConsultationNotesByIdData, ThrowOnError>): RequestResult<DeleteApiConsultationNotesByIdResponses, DeleteApiConsultationNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiConsultationNotesByIdResponses, DeleteApiConsultationNotesByIdErrors, ThrowOnError>({ url: '/api/consultation-notes/{id}', ...options });
    }
    
    /**
     * Get ConsultationNote by ID
     */
    public static getApiConsultationNotesById<ThrowOnError extends boolean = false>(options: Options<GetApiConsultationNotesByIdData, ThrowOnError>): RequestResult<GetApiConsultationNotesByIdResponses, GetApiConsultationNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiConsultationNotesByIdResponses, GetApiConsultationNotesByIdErrors, ThrowOnError>({ url: '/api/consultation-notes/{id}', ...options });
    }
    
    /**
     * Update ConsultationNote
     */
    public static putApiConsultationNotesById<ThrowOnError extends boolean = false>(options: Options<PutApiConsultationNotesByIdData, ThrowOnError>): RequestResult<PutApiConsultationNotesByIdResponses, PutApiConsultationNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiConsultationNotesByIdResponses, PutApiConsultationNotesByIdErrors, ThrowOnError>({
            url: '/api/consultation-notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List furst-analysis-history
     */
    public static getApiFurstAnalysisHistory<ThrowOnError extends boolean = false>(options?: Options<GetApiFurstAnalysisHistoryData, ThrowOnError>): RequestResult<GetApiFurstAnalysisHistoryResponses, GetApiFurstAnalysisHistoryErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiFurstAnalysisHistoryResponses, GetApiFurstAnalysisHistoryErrors, ThrowOnError>({ url: '/api/furst-analysis-history', ...options });
    }
    
    /**
     * Create FurstAnalysisHistory
     */
    public static postApiFurstAnalysisHistory<ThrowOnError extends boolean = false>(options: Options<PostApiFurstAnalysisHistoryData, ThrowOnError>): RequestResult<PostApiFurstAnalysisHistoryResponses, PostApiFurstAnalysisHistoryErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiFurstAnalysisHistoryResponses, PostApiFurstAnalysisHistoryErrors, ThrowOnError>({
            url: '/api/furst-analysis-history',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete FurstAnalysisHistory
     */
    public static deleteApiFurstAnalysisHistoryById<ThrowOnError extends boolean = false>(options: Options<DeleteApiFurstAnalysisHistoryByIdData, ThrowOnError>): RequestResult<DeleteApiFurstAnalysisHistoryByIdResponses, DeleteApiFurstAnalysisHistoryByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiFurstAnalysisHistoryByIdResponses, DeleteApiFurstAnalysisHistoryByIdErrors, ThrowOnError>({ url: '/api/furst-analysis-history/{id}', ...options });
    }
    
    /**
     * Get FurstAnalysisHistory by ID
     */
    public static getApiFurstAnalysisHistoryById<ThrowOnError extends boolean = false>(options: Options<GetApiFurstAnalysisHistoryByIdData, ThrowOnError>): RequestResult<GetApiFurstAnalysisHistoryByIdResponses, GetApiFurstAnalysisHistoryByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiFurstAnalysisHistoryByIdResponses, GetApiFurstAnalysisHistoryByIdErrors, ThrowOnError>({ url: '/api/furst-analysis-history/{id}', ...options });
    }
    
    /**
     * Update FurstAnalysisHistory
     */
    public static putApiFurstAnalysisHistoryById<ThrowOnError extends boolean = false>(options: Options<PutApiFurstAnalysisHistoryByIdData, ThrowOnError>): RequestResult<PutApiFurstAnalysisHistoryByIdResponses, PutApiFurstAnalysisHistoryByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiFurstAnalysisHistoryByIdResponses, PutApiFurstAnalysisHistoryByIdErrors, ThrowOnError>({
            url: '/api/furst-analysis-history/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List internal-notes
     */
    public static getApiInternalNotes<ThrowOnError extends boolean = false>(options?: Options<GetApiInternalNotesData, ThrowOnError>): RequestResult<GetApiInternalNotesResponses, GetApiInternalNotesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiInternalNotesResponses, GetApiInternalNotesErrors, ThrowOnError>({ url: '/api/internal-notes', ...options });
    }
    
    /**
     * Create InternalNote
     */
    public static postApiInternalNotes<ThrowOnError extends boolean = false>(options: Options<PostApiInternalNotesData, ThrowOnError>): RequestResult<PostApiInternalNotesResponses, PostApiInternalNotesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiInternalNotesResponses, PostApiInternalNotesErrors, ThrowOnError>({
            url: '/api/internal-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete InternalNote
     */
    public static deleteApiInternalNotesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiInternalNotesByIdData, ThrowOnError>): RequestResult<DeleteApiInternalNotesByIdResponses, DeleteApiInternalNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiInternalNotesByIdResponses, DeleteApiInternalNotesByIdErrors, ThrowOnError>({ url: '/api/internal-notes/{id}', ...options });
    }
    
    /**
     * Get InternalNote by ID
     */
    public static getApiInternalNotesById<ThrowOnError extends boolean = false>(options: Options<GetApiInternalNotesByIdData, ThrowOnError>): RequestResult<GetApiInternalNotesByIdResponses, GetApiInternalNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiInternalNotesByIdResponses, GetApiInternalNotesByIdErrors, ThrowOnError>({ url: '/api/internal-notes/{id}', ...options });
    }
    
    /**
     * Update InternalNote
     */
    public static putApiInternalNotesById<ThrowOnError extends boolean = false>(options: Options<PutApiInternalNotesByIdData, ThrowOnError>): RequestResult<PutApiInternalNotesByIdResponses, PutApiInternalNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiInternalNotesByIdResponses, PutApiInternalNotesByIdErrors, ThrowOnError>({
            url: '/api/internal-notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List lab-visit-requisition-biometrics
     */
    public static getApiLabVisitRequisitionBiometrics<ThrowOnError extends boolean = false>(options?: Options<GetApiLabVisitRequisitionBiometricsData, ThrowOnError>): RequestResult<GetApiLabVisitRequisitionBiometricsResponses, GetApiLabVisitRequisitionBiometricsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiLabVisitRequisitionBiometricsResponses, GetApiLabVisitRequisitionBiometricsErrors, ThrowOnError>({ url: '/api/lab-visit-requisition-biometrics', ...options });
    }
    
    /**
     * Create LabVisitRequisitionBiometric
     */
    public static postApiLabVisitRequisitionBiometrics<ThrowOnError extends boolean = false>(options: Options<PostApiLabVisitRequisitionBiometricsData, ThrowOnError>): RequestResult<PostApiLabVisitRequisitionBiometricsResponses, PostApiLabVisitRequisitionBiometricsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiLabVisitRequisitionBiometricsResponses, PostApiLabVisitRequisitionBiometricsErrors, ThrowOnError>({
            url: '/api/lab-visit-requisition-biometrics',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete LabVisitRequisitionBiometric
     */
    public static deleteApiLabVisitRequisitionBiometricsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiLabVisitRequisitionBiometricsByIdData, ThrowOnError>): RequestResult<DeleteApiLabVisitRequisitionBiometricsByIdResponses, DeleteApiLabVisitRequisitionBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiLabVisitRequisitionBiometricsByIdResponses, DeleteApiLabVisitRequisitionBiometricsByIdErrors, ThrowOnError>({ url: '/api/lab-visit-requisition-biometrics/{id}', ...options });
    }
    
    /**
     * Get LabVisitRequisitionBiometric by ID
     */
    public static getApiLabVisitRequisitionBiometricsById<ThrowOnError extends boolean = false>(options: Options<GetApiLabVisitRequisitionBiometricsByIdData, ThrowOnError>): RequestResult<GetApiLabVisitRequisitionBiometricsByIdResponses, GetApiLabVisitRequisitionBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabVisitRequisitionBiometricsByIdResponses, GetApiLabVisitRequisitionBiometricsByIdErrors, ThrowOnError>({ url: '/api/lab-visit-requisition-biometrics/{id}', ...options });
    }
    
    /**
     * Update LabVisitRequisitionBiometric
     */
    public static putApiLabVisitRequisitionBiometricsById<ThrowOnError extends boolean = false>(options: Options<PutApiLabVisitRequisitionBiometricsByIdData, ThrowOnError>): RequestResult<PutApiLabVisitRequisitionBiometricsByIdResponses, PutApiLabVisitRequisitionBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiLabVisitRequisitionBiometricsByIdResponses, PutApiLabVisitRequisitionBiometricsByIdErrors, ThrowOnError>({
            url: '/api/lab-visit-requisition-biometrics/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List lab-visit-requisitions
     */
    public static getApiLabVisitRequisitions<ThrowOnError extends boolean = false>(options?: Options<GetApiLabVisitRequisitionsData, ThrowOnError>): RequestResult<GetApiLabVisitRequisitionsResponses, GetApiLabVisitRequisitionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiLabVisitRequisitionsResponses, GetApiLabVisitRequisitionsErrors, ThrowOnError>({ url: '/api/lab-visit-requisitions', ...options });
    }
    
    /**
     * Create LabVisitRequisition
     */
    public static postApiLabVisitRequisitions<ThrowOnError extends boolean = false>(options: Options<PostApiLabVisitRequisitionsData, ThrowOnError>): RequestResult<PostApiLabVisitRequisitionsResponses, PostApiLabVisitRequisitionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiLabVisitRequisitionsResponses, PostApiLabVisitRequisitionsErrors, ThrowOnError>({
            url: '/api/lab-visit-requisitions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete LabVisitRequisition
     */
    public static deleteApiLabVisitRequisitionsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiLabVisitRequisitionsByIdData, ThrowOnError>): RequestResult<DeleteApiLabVisitRequisitionsByIdResponses, DeleteApiLabVisitRequisitionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiLabVisitRequisitionsByIdResponses, DeleteApiLabVisitRequisitionsByIdErrors, ThrowOnError>({ url: '/api/lab-visit-requisitions/{id}', ...options });
    }
    
    /**
     * Get LabVisitRequisition by ID
     */
    public static getApiLabVisitRequisitionsById<ThrowOnError extends boolean = false>(options: Options<GetApiLabVisitRequisitionsByIdData, ThrowOnError>): RequestResult<GetApiLabVisitRequisitionsByIdResponses, GetApiLabVisitRequisitionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabVisitRequisitionsByIdResponses, GetApiLabVisitRequisitionsByIdErrors, ThrowOnError>({ url: '/api/lab-visit-requisitions/{id}', ...options });
    }
    
    /**
     * Update LabVisitRequisition
     */
    public static putApiLabVisitRequisitionsById<ThrowOnError extends boolean = false>(options: Options<PutApiLabVisitRequisitionsByIdData, ThrowOnError>): RequestResult<PutApiLabVisitRequisitionsByIdResponses, PutApiLabVisitRequisitionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiLabVisitRequisitionsByIdResponses, PutApiLabVisitRequisitionsByIdErrors, ThrowOnError>({
            url: '/api/lab-visit-requisitions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List lab-visit-user-notes
     */
    public static getApiLabVisitUserNotes<ThrowOnError extends boolean = false>(options?: Options<GetApiLabVisitUserNotesData, ThrowOnError>): RequestResult<GetApiLabVisitUserNotesResponses, GetApiLabVisitUserNotesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiLabVisitUserNotesResponses, GetApiLabVisitUserNotesErrors, ThrowOnError>({ url: '/api/lab-visit-user-notes', ...options });
    }
    
    /**
     * Create LabVisitUserNote
     */
    public static postApiLabVisitUserNotes<ThrowOnError extends boolean = false>(options: Options<PostApiLabVisitUserNotesData, ThrowOnError>): RequestResult<PostApiLabVisitUserNotesResponses, PostApiLabVisitUserNotesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiLabVisitUserNotesResponses, PostApiLabVisitUserNotesErrors, ThrowOnError>({
            url: '/api/lab-visit-user-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete LabVisitUserNote
     */
    public static deleteApiLabVisitUserNotesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiLabVisitUserNotesByIdData, ThrowOnError>): RequestResult<DeleteApiLabVisitUserNotesByIdResponses, DeleteApiLabVisitUserNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiLabVisitUserNotesByIdResponses, DeleteApiLabVisitUserNotesByIdErrors, ThrowOnError>({ url: '/api/lab-visit-user-notes/{id}', ...options });
    }
    
    /**
     * Get LabVisitUserNote by ID
     */
    public static getApiLabVisitUserNotesById<ThrowOnError extends boolean = false>(options: Options<GetApiLabVisitUserNotesByIdData, ThrowOnError>): RequestResult<GetApiLabVisitUserNotesByIdResponses, GetApiLabVisitUserNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabVisitUserNotesByIdResponses, GetApiLabVisitUserNotesByIdErrors, ThrowOnError>({ url: '/api/lab-visit-user-notes/{id}', ...options });
    }
    
    /**
     * Update LabVisitUserNote
     */
    public static putApiLabVisitUserNotesById<ThrowOnError extends boolean = false>(options: Options<PutApiLabVisitUserNotesByIdData, ThrowOnError>): RequestResult<PutApiLabVisitUserNotesByIdResponses, PutApiLabVisitUserNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiLabVisitUserNotesByIdResponses, PutApiLabVisitUserNotesByIdErrors, ThrowOnError>({
            url: '/api/lab-visit-user-notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List lab-visits
     */
    public static getApiLabVisits<ThrowOnError extends boolean = false>(options?: Options<GetApiLabVisitsData, ThrowOnError>): RequestResult<GetApiLabVisitsResponses, GetApiLabVisitsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiLabVisitsResponses, GetApiLabVisitsErrors, ThrowOnError>({ url: '/api/lab-visits', ...options });
    }
    
    /**
     * Create LabVisit
     */
    public static postApiLabVisits<ThrowOnError extends boolean = false>(options: Options<PostApiLabVisitsData, ThrowOnError>): RequestResult<PostApiLabVisitsResponses, PostApiLabVisitsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiLabVisitsResponses, PostApiLabVisitsErrors, ThrowOnError>({
            url: '/api/lab-visits',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete LabVisit
     */
    public static deleteApiLabVisitsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiLabVisitsByIdData, ThrowOnError>): RequestResult<DeleteApiLabVisitsByIdResponses, DeleteApiLabVisitsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiLabVisitsByIdResponses, DeleteApiLabVisitsByIdErrors, ThrowOnError>({ url: '/api/lab-visits/{id}', ...options });
    }
    
    /**
     * Get LabVisit by ID
     */
    public static getApiLabVisitsById<ThrowOnError extends boolean = false>(options: Options<GetApiLabVisitsByIdData, ThrowOnError>): RequestResult<GetApiLabVisitsByIdResponses, GetApiLabVisitsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabVisitsByIdResponses, GetApiLabVisitsByIdErrors, ThrowOnError>({ url: '/api/lab-visits/{id}', ...options });
    }
    
    /**
     * Update LabVisit
     */
    public static putApiLabVisitsById<ThrowOnError extends boolean = false>(options: Options<PutApiLabVisitsByIdData, ThrowOnError>): RequestResult<PutApiLabVisitsByIdResponses, PutApiLabVisitsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiLabVisitsByIdResponses, PutApiLabVisitsByIdErrors, ThrowOnError>({
            url: '/api/lab-visits/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Download lab visit analysis as PDF
     *
     * Generates a PDF of the doctor-approved analysis (summary, emphasized biomarkers, domain assessments and recommendations) for a lab visit. Returns 404 if the visit has no doctor-approved assessments.
     */
    public static getApiLabVisitsByIdAnalysisPdf<ThrowOnError extends boolean = false>(options: Options<GetApiLabVisitsByIdAnalysisPdfData, ThrowOnError>): RequestResult<GetApiLabVisitsByIdAnalysisPdfResponses, GetApiLabVisitsByIdAnalysisPdfErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabVisitsByIdAnalysisPdfResponses, GetApiLabVisitsByIdAnalysisPdfErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/lab-visits/{id}/analysis-pdf',
            ...options
        });
    }
    
    /**
     * Download lab visit results as PDF
     */
    public static getApiLabVisitsByIdPdf<ThrowOnError extends boolean = false>(options: Options<GetApiLabVisitsByIdPdfData, ThrowOnError>): RequestResult<GetApiLabVisitsByIdPdfResponses, GetApiLabVisitsByIdPdfErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabVisitsByIdPdfResponses, GetApiLabVisitsByIdPdfErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/lab-visits/{id}/pdf',
            ...options
        });
    }
    
    /**
     * List status-history
     */
    public static getApiStatusHistory<ThrowOnError extends boolean = false>(options?: Options<GetApiStatusHistoryData, ThrowOnError>): RequestResult<GetApiStatusHistoryResponses, GetApiStatusHistoryErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiStatusHistoryResponses, GetApiStatusHistoryErrors, ThrowOnError>({ url: '/api/status-history', ...options });
    }
    
    /**
     * Create StatusHistory
     */
    public static postApiStatusHistory<ThrowOnError extends boolean = false>(options: Options<PostApiStatusHistoryData, ThrowOnError>): RequestResult<PostApiStatusHistoryResponses, PostApiStatusHistoryErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiStatusHistoryResponses, PostApiStatusHistoryErrors, ThrowOnError>({
            url: '/api/status-history',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete StatusHistory
     */
    public static deleteApiStatusHistoryById<ThrowOnError extends boolean = false>(options: Options<DeleteApiStatusHistoryByIdData, ThrowOnError>): RequestResult<DeleteApiStatusHistoryByIdResponses, DeleteApiStatusHistoryByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiStatusHistoryByIdResponses, DeleteApiStatusHistoryByIdErrors, ThrowOnError>({ url: '/api/status-history/{id}', ...options });
    }
    
    /**
     * Get StatusHistory by ID
     */
    public static getApiStatusHistoryById<ThrowOnError extends boolean = false>(options: Options<GetApiStatusHistoryByIdData, ThrowOnError>): RequestResult<GetApiStatusHistoryByIdResponses, GetApiStatusHistoryByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiStatusHistoryByIdResponses, GetApiStatusHistoryByIdErrors, ThrowOnError>({ url: '/api/status-history/{id}', ...options });
    }
    
    /**
     * Update StatusHistory
     */
    public static putApiStatusHistoryById<ThrowOnError extends boolean = false>(options: Options<PutApiStatusHistoryByIdData, ThrowOnError>): RequestResult<PutApiStatusHistoryByIdResponses, PutApiStatusHistoryByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiStatusHistoryByIdResponses, PutApiStatusHistoryByIdErrors, ThrowOnError>({
            url: '/api/status-history/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class HelfoEngineService {
    /**
     * List engine biomarker-slug → Amino biometric mappings
     *
     * Returns each engine slug joined to its Amino biometric row (name, unit, NLK, Furst id). Entries with biometricId=null are engine slugs whose biometric isn't yet in Amino's catalog.
     */
    public static getApiAdminHelfoEngineBiometricMap<ThrowOnError extends boolean = false>(options?: Options<GetApiAdminHelfoEngineBiometricMapData, ThrowOnError>): RequestResult<GetApiAdminHelfoEngineBiometricMapResponses, GetApiAdminHelfoEngineBiometricMapErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAdminHelfoEngineBiometricMapResponses, GetApiAdminHelfoEngineBiometricMapErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/helfo-engine/biometric-map',
            ...options
        });
    }
    
    /**
     * Evaluate engine on supplied responses (no DB lookup)
     *
     * Pure engine evaluation: caller posts an AminoResponse[] plus optional adapter overrides, server returns the full EvaluateResult shape. Used by the backoffice test page to render engine output for fake survey inputs.
     */
    public static postApiAdminHelfoEngineEvaluate<ThrowOnError extends boolean = false>(options: Options<PostApiAdminHelfoEngineEvaluateData, ThrowOnError>): RequestResult<PostApiAdminHelfoEngineEvaluateResponses, PostApiAdminHelfoEngineEvaluateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminHelfoEngineEvaluateResponses, PostApiAdminHelfoEngineEvaluateErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/helfo-engine/evaluate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List medication keyword fallback map
     *
     * Returns the engine drug-slug → Norwegian keyword list used to scrape the free-text 'Medisiner' field when the structured medications question isn't wired up.
     */
    public static getApiAdminHelfoEngineMedicationKeywords<ThrowOnError extends boolean = false>(options?: Options<GetApiAdminHelfoEngineMedicationKeywordsData, ThrowOnError>): RequestResult<GetApiAdminHelfoEngineMedicationKeywordsResponses, GetApiAdminHelfoEngineMedicationKeywordsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAdminHelfoEngineMedicationKeywordsResponses, GetApiAdminHelfoEngineMedicationKeywordsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/helfo-engine/medication-keywords',
            ...options
        });
    }
    
    /**
     * Validate kliniske opplysninger text against HELFO policy
     *
     * Runs the engine's clinical-info validator (max length + forbidden HELFO phrases) on caller-supplied text. Used by the doctor-edit flow to surface violations live as kliniske opplysninger is edited.
     */
    public static postApiAdminHelfoEngineValidateClinicalInfo<ThrowOnError extends boolean = false>(options: Options<PostApiAdminHelfoEngineValidateClinicalInfoData, ThrowOnError>): RequestResult<PostApiAdminHelfoEngineValidateClinicalInfoResponses, PostApiAdminHelfoEngineValidateClinicalInfoErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAdminHelfoEngineValidateClinicalInfoResponses, PostApiAdminHelfoEngineValidateClinicalInfoErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/helfo-engine/validate-clinical-info',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Evaluate engine against a lab visit's owning user
     *
     * Looks up the lab visit, pulls the patient's question_responses + biometric history via buildEngineSurvey, runs evaluate(), and returns the EvaluateResult. `rules=v2` runs HELFO rules v2 and returns the markers its known conditions keep off HELFO. Output is not persisted — recompute when needed.
     */
    public static getApiAdminLabVisitsByIdHelfoEvaluation<ThrowOnError extends boolean = false>(options: Options<GetApiAdminLabVisitsByIdHelfoEvaluationData, ThrowOnError>): RequestResult<GetApiAdminLabVisitsByIdHelfoEvaluationResponses, GetApiAdminLabVisitsByIdHelfoEvaluationErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAdminLabVisitsByIdHelfoEvaluationResponses, GetApiAdminLabVisitsByIdHelfoEvaluationErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/admin/lab-visits/{id}/helfo-evaluation',
            ...options
        });
    }
}

export class AiService {
    /**
     * List ai-knowledge-chunks
     */
    public static getApiAiKnowledgeChunks<ThrowOnError extends boolean = false>(options?: Options<GetApiAiKnowledgeChunksData, ThrowOnError>): RequestResult<GetApiAiKnowledgeChunksResponses, GetApiAiKnowledgeChunksErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAiKnowledgeChunksResponses, GetApiAiKnowledgeChunksErrors, ThrowOnError>({ url: '/api/ai-knowledge-chunks', ...options });
    }
    
    /**
     * Create AiKnowledgeChunk
     */
    public static postApiAiKnowledgeChunks<ThrowOnError extends boolean = false>(options: Options<PostApiAiKnowledgeChunksData, ThrowOnError>): RequestResult<PostApiAiKnowledgeChunksResponses, PostApiAiKnowledgeChunksErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAiKnowledgeChunksResponses, PostApiAiKnowledgeChunksErrors, ThrowOnError>({
            url: '/api/ai-knowledge-chunks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AiKnowledgeChunk
     */
    public static deleteApiAiKnowledgeChunksById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAiKnowledgeChunksByIdData, ThrowOnError>): RequestResult<DeleteApiAiKnowledgeChunksByIdResponses, DeleteApiAiKnowledgeChunksByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAiKnowledgeChunksByIdResponses, DeleteApiAiKnowledgeChunksByIdErrors, ThrowOnError>({ url: '/api/ai-knowledge-chunks/{id}', ...options });
    }
    
    /**
     * Get AiKnowledgeChunk by ID
     */
    public static getApiAiKnowledgeChunksById<ThrowOnError extends boolean = false>(options: Options<GetApiAiKnowledgeChunksByIdData, ThrowOnError>): RequestResult<GetApiAiKnowledgeChunksByIdResponses, GetApiAiKnowledgeChunksByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAiKnowledgeChunksByIdResponses, GetApiAiKnowledgeChunksByIdErrors, ThrowOnError>({ url: '/api/ai-knowledge-chunks/{id}', ...options });
    }
    
    /**
     * Update AiKnowledgeChunk
     */
    public static putApiAiKnowledgeChunksById<ThrowOnError extends boolean = false>(options: Options<PutApiAiKnowledgeChunksByIdData, ThrowOnError>): RequestResult<PutApiAiKnowledgeChunksByIdResponses, PutApiAiKnowledgeChunksByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAiKnowledgeChunksByIdResponses, PutApiAiKnowledgeChunksByIdErrors, ThrowOnError>({
            url: '/api/ai-knowledge-chunks/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List rag-documents
     */
    public static getApiRagDocuments<ThrowOnError extends boolean = false>(options?: Options<GetApiRagDocumentsData, ThrowOnError>): RequestResult<GetApiRagDocumentsResponses, GetApiRagDocumentsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiRagDocumentsResponses, GetApiRagDocumentsErrors, ThrowOnError>({ url: '/api/rag-documents', ...options });
    }
    
    /**
     * Create RagDocument
     */
    public static postApiRagDocuments<ThrowOnError extends boolean = false>(options: Options<PostApiRagDocumentsData, ThrowOnError>): RequestResult<PostApiRagDocumentsResponses, PostApiRagDocumentsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiRagDocumentsResponses, PostApiRagDocumentsErrors, ThrowOnError>({
            url: '/api/rag-documents',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete RagDocument
     */
    public static deleteApiRagDocumentsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiRagDocumentsByIdData, ThrowOnError>): RequestResult<DeleteApiRagDocumentsByIdResponses, DeleteApiRagDocumentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiRagDocumentsByIdResponses, DeleteApiRagDocumentsByIdErrors, ThrowOnError>({ url: '/api/rag-documents/{id}', ...options });
    }
    
    /**
     * Get RagDocument by ID
     */
    public static getApiRagDocumentsById<ThrowOnError extends boolean = false>(options: Options<GetApiRagDocumentsByIdData, ThrowOnError>): RequestResult<GetApiRagDocumentsByIdResponses, GetApiRagDocumentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiRagDocumentsByIdResponses, GetApiRagDocumentsByIdErrors, ThrowOnError>({ url: '/api/rag-documents/{id}', ...options });
    }
    
    /**
     * Update RagDocument
     */
    public static putApiRagDocumentsById<ThrowOnError extends boolean = false>(options: Options<PutApiRagDocumentsByIdData, ThrowOnError>): RequestResult<PutApiRagDocumentsByIdResponses, PutApiRagDocumentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiRagDocumentsByIdResponses, PutApiRagDocumentsByIdErrors, ThrowOnError>({
            url: '/api/rag-documents/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AminoAgeService {
    /**
     * Get live Amino Age calculation
     *
     * Computes Amino Age in real-time from the user's most recent lab visit and 90-day Garmin averages.
     */
    public static getApiAminoAge<ThrowOnError extends boolean = false>(options?: Options<GetApiAminoAgeData, ThrowOnError>): RequestResult<GetApiAminoAgeResponses, GetApiAminoAgeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAminoAgeResponses, GetApiAminoAgeErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/amino-age',
            ...options
        });
    }
    
    /**
     * List amino-age-correlation-configs
     */
    public static getApiAminoAgeCorrelationConfigs<ThrowOnError extends boolean = false>(options?: Options<GetApiAminoAgeCorrelationConfigsData, ThrowOnError>): RequestResult<GetApiAminoAgeCorrelationConfigsResponses, GetApiAminoAgeCorrelationConfigsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAminoAgeCorrelationConfigsResponses, GetApiAminoAgeCorrelationConfigsErrors, ThrowOnError>({ url: '/api/amino-age-correlation-configs', ...options });
    }
    
    /**
     * Create AminoAgeCorrelationConfig
     */
    public static postApiAminoAgeCorrelationConfigs<ThrowOnError extends boolean = false>(options: Options<PostApiAminoAgeCorrelationConfigsData, ThrowOnError>): RequestResult<PostApiAminoAgeCorrelationConfigsResponses, PostApiAminoAgeCorrelationConfigsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAminoAgeCorrelationConfigsResponses, PostApiAminoAgeCorrelationConfigsErrors, ThrowOnError>({
            url: '/api/amino-age-correlation-configs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AminoAgeCorrelationConfig
     */
    public static deleteApiAminoAgeCorrelationConfigsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAminoAgeCorrelationConfigsByIdData, ThrowOnError>): RequestResult<DeleteApiAminoAgeCorrelationConfigsByIdResponses, DeleteApiAminoAgeCorrelationConfigsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAminoAgeCorrelationConfigsByIdResponses, DeleteApiAminoAgeCorrelationConfigsByIdErrors, ThrowOnError>({ url: '/api/amino-age-correlation-configs/{id}', ...options });
    }
    
    /**
     * Get AminoAgeCorrelationConfig by ID
     */
    public static getApiAminoAgeCorrelationConfigsById<ThrowOnError extends boolean = false>(options: Options<GetApiAminoAgeCorrelationConfigsByIdData, ThrowOnError>): RequestResult<GetApiAminoAgeCorrelationConfigsByIdResponses, GetApiAminoAgeCorrelationConfigsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAminoAgeCorrelationConfigsByIdResponses, GetApiAminoAgeCorrelationConfigsByIdErrors, ThrowOnError>({ url: '/api/amino-age-correlation-configs/{id}', ...options });
    }
    
    /**
     * Update AminoAgeCorrelationConfig
     */
    public static putApiAminoAgeCorrelationConfigsById<ThrowOnError extends boolean = false>(options: Options<PutApiAminoAgeCorrelationConfigsByIdData, ThrowOnError>): RequestResult<PutApiAminoAgeCorrelationConfigsByIdResponses, PutApiAminoAgeCorrelationConfigsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAminoAgeCorrelationConfigsByIdResponses, PutApiAminoAgeCorrelationConfigsByIdErrors, ThrowOnError>({
            url: '/api/amino-age-correlation-configs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Activate a correlation config
     *
     * Atomically deactivates all other configs and activates the specified one. Admin only.
     */
    public static postApiAminoAgeCorrelationConfigsByIdActivate<ThrowOnError extends boolean = false>(options: Options<PostApiAminoAgeCorrelationConfigsByIdActivateData, ThrowOnError>): RequestResult<PostApiAminoAgeCorrelationConfigsByIdActivateResponses, PostApiAminoAgeCorrelationConfigsByIdActivateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAminoAgeCorrelationConfigsByIdActivateResponses, PostApiAminoAgeCorrelationConfigsByIdActivateErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/amino-age-correlation-configs/{id}/activate',
            ...options
        });
    }
    
    /**
     * List amino-age-snapshots
     */
    public static getApiAminoAgeSnapshots<ThrowOnError extends boolean = false>(options?: Options<GetApiAminoAgeSnapshotsData, ThrowOnError>): RequestResult<GetApiAminoAgeSnapshotsResponses, GetApiAminoAgeSnapshotsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAminoAgeSnapshotsResponses, GetApiAminoAgeSnapshotsErrors, ThrowOnError>({ url: '/api/amino-age-snapshots', ...options });
    }
    
    /**
     * Create AminoAgeSnapshot
     */
    public static postApiAminoAgeSnapshots<ThrowOnError extends boolean = false>(options: Options<PostApiAminoAgeSnapshotsData, ThrowOnError>): RequestResult<PostApiAminoAgeSnapshotsResponses, PostApiAminoAgeSnapshotsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAminoAgeSnapshotsResponses, PostApiAminoAgeSnapshotsErrors, ThrowOnError>({
            url: '/api/amino-age-snapshots',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AminoAgeSnapshot
     */
    public static deleteApiAminoAgeSnapshotsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAminoAgeSnapshotsByIdData, ThrowOnError>): RequestResult<DeleteApiAminoAgeSnapshotsByIdResponses, DeleteApiAminoAgeSnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAminoAgeSnapshotsByIdResponses, DeleteApiAminoAgeSnapshotsByIdErrors, ThrowOnError>({ url: '/api/amino-age-snapshots/{id}', ...options });
    }
    
    /**
     * Get AminoAgeSnapshot by ID
     */
    public static getApiAminoAgeSnapshotsById<ThrowOnError extends boolean = false>(options: Options<GetApiAminoAgeSnapshotsByIdData, ThrowOnError>): RequestResult<GetApiAminoAgeSnapshotsByIdResponses, GetApiAminoAgeSnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAminoAgeSnapshotsByIdResponses, GetApiAminoAgeSnapshotsByIdErrors, ThrowOnError>({ url: '/api/amino-age-snapshots/{id}', ...options });
    }
    
    /**
     * Update AminoAgeSnapshot
     */
    public static putApiAminoAgeSnapshotsById<ThrowOnError extends boolean = false>(options: Options<PutApiAminoAgeSnapshotsByIdData, ThrowOnError>): RequestResult<PutApiAminoAgeSnapshotsByIdResponses, PutApiAminoAgeSnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAminoAgeSnapshotsByIdResponses, PutApiAminoAgeSnapshotsByIdErrors, ThrowOnError>({
            url: '/api/amino-age-snapshots/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List amino-age-trend-assessments
     */
    public static getApiAminoAgeTrendAssessments<ThrowOnError extends boolean = false>(options?: Options<GetApiAminoAgeTrendAssessmentsData, ThrowOnError>): RequestResult<GetApiAminoAgeTrendAssessmentsResponses, GetApiAminoAgeTrendAssessmentsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAminoAgeTrendAssessmentsResponses, GetApiAminoAgeTrendAssessmentsErrors, ThrowOnError>({ url: '/api/amino-age-trend-assessments', ...options });
    }
    
    /**
     * Create AminoAgeTrendAssessment
     */
    public static postApiAminoAgeTrendAssessments<ThrowOnError extends boolean = false>(options: Options<PostApiAminoAgeTrendAssessmentsData, ThrowOnError>): RequestResult<PostApiAminoAgeTrendAssessmentsResponses, PostApiAminoAgeTrendAssessmentsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAminoAgeTrendAssessmentsResponses, PostApiAminoAgeTrendAssessmentsErrors, ThrowOnError>({
            url: '/api/amino-age-trend-assessments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AminoAgeTrendAssessment
     */
    public static deleteApiAminoAgeTrendAssessmentsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAminoAgeTrendAssessmentsByIdData, ThrowOnError>): RequestResult<DeleteApiAminoAgeTrendAssessmentsByIdResponses, DeleteApiAminoAgeTrendAssessmentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAminoAgeTrendAssessmentsByIdResponses, DeleteApiAminoAgeTrendAssessmentsByIdErrors, ThrowOnError>({ url: '/api/amino-age-trend-assessments/{id}', ...options });
    }
    
    /**
     * Get AminoAgeTrendAssessment by ID
     */
    public static getApiAminoAgeTrendAssessmentsById<ThrowOnError extends boolean = false>(options: Options<GetApiAminoAgeTrendAssessmentsByIdData, ThrowOnError>): RequestResult<GetApiAminoAgeTrendAssessmentsByIdResponses, GetApiAminoAgeTrendAssessmentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAminoAgeTrendAssessmentsByIdResponses, GetApiAminoAgeTrendAssessmentsByIdErrors, ThrowOnError>({ url: '/api/amino-age-trend-assessments/{id}', ...options });
    }
    
    /**
     * Update AminoAgeTrendAssessment
     */
    public static putApiAminoAgeTrendAssessmentsById<ThrowOnError extends boolean = false>(options: Options<PutApiAminoAgeTrendAssessmentsByIdData, ThrowOnError>): RequestResult<PutApiAminoAgeTrendAssessmentsByIdResponses, PutApiAminoAgeTrendAssessmentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAminoAgeTrendAssessmentsByIdResponses, PutApiAminoAgeTrendAssessmentsByIdErrors, ThrowOnError>({
            url: '/api/amino-age-trend-assessments/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reassess Amino Age trends
     *
     * Manually triggers regeneration of all Amino Age trend assessments for the authenticated user. Beta testers only.
     */
    public static postApiAminoAgeAnalyze<ThrowOnError extends boolean = false>(options?: Options<PostApiAminoAgeAnalyzeData, ThrowOnError>): RequestResult<PostApiAminoAgeAnalyzeResponses, PostApiAminoAgeAnalyzeErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostApiAminoAgeAnalyzeResponses, PostApiAminoAgeAnalyzeErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/amino-age/analyze',
            ...options
        });
    }
    
    /**
     * Preview amino age for eligible users (paginated)
     *
     * Admin-only. Computes amino age live, one page at a time, using the specified (or active) correlation config. Each user costs several queries, so the page size is capped at 100; use offset and total to walk the list.
     */
    public static getApiAminoAgePreview<ThrowOnError extends boolean = false>(options?: Options<GetApiAminoAgePreviewData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/amino-age/preview',
            ...options
        });
    }
    
    /**
     * Refresh a single category trend
     *
     * Triggers a fresh LLM trend analysis for a specific category if stale (>24h old). At most once per day. Categories without a trend (e.g. blodprover) return ready without enqueuing anything.
     */
    public static postApiAminoAgeRefreshCategoryTrend<ThrowOnError extends boolean = false>(options: Options<PostApiAminoAgeRefreshCategoryTrendData, ThrowOnError>): RequestResult<PostApiAminoAgeRefreshCategoryTrendResponses, PostApiAminoAgeRefreshCategoryTrendErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAminoAgeRefreshCategoryTrendResponses, PostApiAminoAgeRefreshCategoryTrendErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/amino-age/refresh-category-trend',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Refresh amino age trends
     *
     * Triggers a fresh LLM trend analysis if trends are stale (>24h old). At most once per day, and never between midnight and 06:00 UTC. Returns the current generation state.
     */
    public static postApiAminoAgeRefreshTrends<ThrowOnError extends boolean = false>(options?: Options<PostApiAminoAgeRefreshTrendsData, ThrowOnError>): RequestResult<PostApiAminoAgeRefreshTrendsResponses, PostApiAminoAgeRefreshTrendsErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostApiAminoAgeRefreshTrendsResponses, PostApiAminoAgeRefreshTrendsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/amino-age/refresh-trends',
            ...options
        });
    }
    
    /**
     * Check own trend generation completion
     */
    public static getApiAminoAgeTrendGenerationStatus<ThrowOnError extends boolean = false>(options: Options<GetApiAminoAgeTrendGenerationStatusData, ThrowOnError>): RequestResult<GetApiAminoAgeTrendGenerationStatusResponses, GetApiAminoAgeTrendGenerationStatusErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAminoAgeTrendGenerationStatusResponses, GetApiAminoAgeTrendGenerationStatusErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/amino-age/trend-generation-status',
            ...options
        });
    }
}

export class AnalyticsService {
    /**
     * List analytics datasets
     *
     * Datasets in the hourly pseudonymised snapshot, and the rules that apply to queries on them.
     */
    public static getApiAnalyticsDatasets<ThrowOnError extends boolean = false>(options?: Options<GetApiAnalyticsDatasetsData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
            security: [{
                    key: 'apiKey',
                    scheme: 'bearer',
                    type: 'http'
                }, {
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/analytics/datasets',
            ...options
        });
    }
    
    /**
     * Describe an analytics dataset
     *
     * Columns (own and through relations), measures and relations of one dataset.
     */
    public static getApiAnalyticsDatasetsByName<ThrowOnError extends boolean = false>(options: Options<GetApiAnalyticsDatasetsByNameData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).get<unknown, unknown, ThrowOnError>({
            security: [{
                    key: 'apiKey',
                    scheme: 'bearer',
                    type: 'http'
                }, {
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/analytics/datasets/{name}',
            ...options
        });
    }
    
    /**
     * Query an analytics dataset
     *
     * Aggregates over a fact dataset (groups of fewer than 5 people are left out), or plain rows of a reference dataset.
     */
    public static postApiAnalyticsQuery<ThrowOnError extends boolean = false>(options: Options<PostApiAnalyticsQueryData, ThrowOnError>): RequestResult<PostApiAnalyticsQueryResponses, PostApiAnalyticsQueryErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAnalyticsQueryResponses, PostApiAnalyticsQueryErrors, ThrowOnError>({
            security: [{
                    key: 'apiKey',
                    scheme: 'bearer',
                    type: 'http'
                }, {
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/analytics/query',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AssessmentsService {
    /**
     * List assessment-ai-metadata
     */
    public static getApiAssessmentAiMetadata<ThrowOnError extends boolean = false>(options?: Options<GetApiAssessmentAiMetadataData, ThrowOnError>): RequestResult<GetApiAssessmentAiMetadataResponses, GetApiAssessmentAiMetadataErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAssessmentAiMetadataResponses, GetApiAssessmentAiMetadataErrors, ThrowOnError>({ url: '/api/assessment-ai-metadata', ...options });
    }
    
    /**
     * Create AssessmentAiMetadata
     */
    public static postApiAssessmentAiMetadata<ThrowOnError extends boolean = false>(options: Options<PostApiAssessmentAiMetadataData, ThrowOnError>): RequestResult<PostApiAssessmentAiMetadataResponses, PostApiAssessmentAiMetadataErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAssessmentAiMetadataResponses, PostApiAssessmentAiMetadataErrors, ThrowOnError>({
            url: '/api/assessment-ai-metadata',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AssessmentAiMetadata
     */
    public static deleteApiAssessmentAiMetadataById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAssessmentAiMetadataByIdData, ThrowOnError>): RequestResult<DeleteApiAssessmentAiMetadataByIdResponses, DeleteApiAssessmentAiMetadataByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAssessmentAiMetadataByIdResponses, DeleteApiAssessmentAiMetadataByIdErrors, ThrowOnError>({ url: '/api/assessment-ai-metadata/{id}', ...options });
    }
    
    /**
     * Get AssessmentAiMetadata by ID
     */
    public static getApiAssessmentAiMetadataById<ThrowOnError extends boolean = false>(options: Options<GetApiAssessmentAiMetadataByIdData, ThrowOnError>): RequestResult<GetApiAssessmentAiMetadataByIdResponses, GetApiAssessmentAiMetadataByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAssessmentAiMetadataByIdResponses, GetApiAssessmentAiMetadataByIdErrors, ThrowOnError>({ url: '/api/assessment-ai-metadata/{id}', ...options });
    }
    
    /**
     * Update AssessmentAiMetadata
     */
    public static putApiAssessmentAiMetadataById<ThrowOnError extends boolean = false>(options: Options<PutApiAssessmentAiMetadataByIdData, ThrowOnError>): RequestResult<PutApiAssessmentAiMetadataByIdResponses, PutApiAssessmentAiMetadataByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAssessmentAiMetadataByIdResponses, PutApiAssessmentAiMetadataByIdErrors, ThrowOnError>({
            url: '/api/assessment-ai-metadata/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List assessment-emphasized-biometrics
     */
    public static getApiAssessmentEmphasizedBiometrics<ThrowOnError extends boolean = false>(options?: Options<GetApiAssessmentEmphasizedBiometricsData, ThrowOnError>): RequestResult<GetApiAssessmentEmphasizedBiometricsResponses, GetApiAssessmentEmphasizedBiometricsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAssessmentEmphasizedBiometricsResponses, GetApiAssessmentEmphasizedBiometricsErrors, ThrowOnError>({ url: '/api/assessment-emphasized-biometrics', ...options });
    }
    
    /**
     * Create AssessmentEmphasizedBiometric
     */
    public static postApiAssessmentEmphasizedBiometrics<ThrowOnError extends boolean = false>(options: Options<PostApiAssessmentEmphasizedBiometricsData, ThrowOnError>): RequestResult<PostApiAssessmentEmphasizedBiometricsResponses, PostApiAssessmentEmphasizedBiometricsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAssessmentEmphasizedBiometricsResponses, PostApiAssessmentEmphasizedBiometricsErrors, ThrowOnError>({
            url: '/api/assessment-emphasized-biometrics',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AssessmentEmphasizedBiometric
     */
    public static deleteApiAssessmentEmphasizedBiometricsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAssessmentEmphasizedBiometricsByIdData, ThrowOnError>): RequestResult<DeleteApiAssessmentEmphasizedBiometricsByIdResponses, DeleteApiAssessmentEmphasizedBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAssessmentEmphasizedBiometricsByIdResponses, DeleteApiAssessmentEmphasizedBiometricsByIdErrors, ThrowOnError>({ url: '/api/assessment-emphasized-biometrics/{id}', ...options });
    }
    
    /**
     * Get AssessmentEmphasizedBiometric by ID
     */
    public static getApiAssessmentEmphasizedBiometricsById<ThrowOnError extends boolean = false>(options: Options<GetApiAssessmentEmphasizedBiometricsByIdData, ThrowOnError>): RequestResult<GetApiAssessmentEmphasizedBiometricsByIdResponses, GetApiAssessmentEmphasizedBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAssessmentEmphasizedBiometricsByIdResponses, GetApiAssessmentEmphasizedBiometricsByIdErrors, ThrowOnError>({ url: '/api/assessment-emphasized-biometrics/{id}', ...options });
    }
    
    /**
     * Update AssessmentEmphasizedBiometric
     */
    public static putApiAssessmentEmphasizedBiometricsById<ThrowOnError extends boolean = false>(options: Options<PutApiAssessmentEmphasizedBiometricsByIdData, ThrowOnError>): RequestResult<PutApiAssessmentEmphasizedBiometricsByIdResponses, PutApiAssessmentEmphasizedBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAssessmentEmphasizedBiometricsByIdResponses, PutApiAssessmentEmphasizedBiometricsByIdErrors, ThrowOnError>({
            url: '/api/assessment-emphasized-biometrics/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List assessment-recommendation-progress
     */
    public static getApiAssessmentRecommendationProgress<ThrowOnError extends boolean = false>(options?: Options<GetApiAssessmentRecommendationProgressData, ThrowOnError>): RequestResult<GetApiAssessmentRecommendationProgressResponses, GetApiAssessmentRecommendationProgressErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAssessmentRecommendationProgressResponses, GetApiAssessmentRecommendationProgressErrors, ThrowOnError>({ url: '/api/assessment-recommendation-progress', ...options });
    }
    
    /**
     * Create AssessmentRecommendationProgress
     */
    public static postApiAssessmentRecommendationProgress<ThrowOnError extends boolean = false>(options: Options<PostApiAssessmentRecommendationProgressData, ThrowOnError>): RequestResult<PostApiAssessmentRecommendationProgressResponses, PostApiAssessmentRecommendationProgressErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAssessmentRecommendationProgressResponses, PostApiAssessmentRecommendationProgressErrors, ThrowOnError>({
            url: '/api/assessment-recommendation-progress',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AssessmentRecommendationProgress
     */
    public static deleteApiAssessmentRecommendationProgressById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAssessmentRecommendationProgressByIdData, ThrowOnError>): RequestResult<DeleteApiAssessmentRecommendationProgressByIdResponses, DeleteApiAssessmentRecommendationProgressByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAssessmentRecommendationProgressByIdResponses, DeleteApiAssessmentRecommendationProgressByIdErrors, ThrowOnError>({ url: '/api/assessment-recommendation-progress/{id}', ...options });
    }
    
    /**
     * Get AssessmentRecommendationProgress by ID
     */
    public static getApiAssessmentRecommendationProgressById<ThrowOnError extends boolean = false>(options: Options<GetApiAssessmentRecommendationProgressByIdData, ThrowOnError>): RequestResult<GetApiAssessmentRecommendationProgressByIdResponses, GetApiAssessmentRecommendationProgressByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAssessmentRecommendationProgressByIdResponses, GetApiAssessmentRecommendationProgressByIdErrors, ThrowOnError>({ url: '/api/assessment-recommendation-progress/{id}', ...options });
    }
    
    /**
     * Update AssessmentRecommendationProgress
     */
    public static putApiAssessmentRecommendationProgressById<ThrowOnError extends boolean = false>(options: Options<PutApiAssessmentRecommendationProgressByIdData, ThrowOnError>): RequestResult<PutApiAssessmentRecommendationProgressByIdResponses, PutApiAssessmentRecommendationProgressByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAssessmentRecommendationProgressByIdResponses, PutApiAssessmentRecommendationProgressByIdErrors, ThrowOnError>({
            url: '/api/assessment-recommendation-progress/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List assessment-recommendations
     */
    public static getApiAssessmentRecommendations<ThrowOnError extends boolean = false>(options?: Options<GetApiAssessmentRecommendationsData, ThrowOnError>): RequestResult<GetApiAssessmentRecommendationsResponses, GetApiAssessmentRecommendationsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAssessmentRecommendationsResponses, GetApiAssessmentRecommendationsErrors, ThrowOnError>({ url: '/api/assessment-recommendations', ...options });
    }
    
    /**
     * Create AssessmentRecommendation
     */
    public static postApiAssessmentRecommendations<ThrowOnError extends boolean = false>(options: Options<PostApiAssessmentRecommendationsData, ThrowOnError>): RequestResult<PostApiAssessmentRecommendationsResponses, PostApiAssessmentRecommendationsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAssessmentRecommendationsResponses, PostApiAssessmentRecommendationsErrors, ThrowOnError>({
            url: '/api/assessment-recommendations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AssessmentRecommendation
     */
    public static deleteApiAssessmentRecommendationsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAssessmentRecommendationsByIdData, ThrowOnError>): RequestResult<DeleteApiAssessmentRecommendationsByIdResponses, DeleteApiAssessmentRecommendationsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAssessmentRecommendationsByIdResponses, DeleteApiAssessmentRecommendationsByIdErrors, ThrowOnError>({ url: '/api/assessment-recommendations/{id}', ...options });
    }
    
    /**
     * Get AssessmentRecommendation by ID
     */
    public static getApiAssessmentRecommendationsById<ThrowOnError extends boolean = false>(options: Options<GetApiAssessmentRecommendationsByIdData, ThrowOnError>): RequestResult<GetApiAssessmentRecommendationsByIdResponses, GetApiAssessmentRecommendationsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAssessmentRecommendationsByIdResponses, GetApiAssessmentRecommendationsByIdErrors, ThrowOnError>({ url: '/api/assessment-recommendations/{id}', ...options });
    }
    
    /**
     * Update AssessmentRecommendation
     */
    public static putApiAssessmentRecommendationsById<ThrowOnError extends boolean = false>(options: Options<PutApiAssessmentRecommendationsByIdData, ThrowOnError>): RequestResult<PutApiAssessmentRecommendationsByIdResponses, PutApiAssessmentRecommendationsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAssessmentRecommendationsByIdResponses, PutApiAssessmentRecommendationsByIdErrors, ThrowOnError>({
            url: '/api/assessment-recommendations/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List assessment-variant-metadata
     */
    public static getApiAssessmentVariantMetadata<ThrowOnError extends boolean = false>(options?: Options<GetApiAssessmentVariantMetadataData, ThrowOnError>): RequestResult<GetApiAssessmentVariantMetadataResponses, GetApiAssessmentVariantMetadataErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAssessmentVariantMetadataResponses, GetApiAssessmentVariantMetadataErrors, ThrowOnError>({ url: '/api/assessment-variant-metadata', ...options });
    }
    
    /**
     * Create AssessmentVariantMetadata
     */
    public static postApiAssessmentVariantMetadata<ThrowOnError extends boolean = false>(options: Options<PostApiAssessmentVariantMetadataData, ThrowOnError>): RequestResult<PostApiAssessmentVariantMetadataResponses, PostApiAssessmentVariantMetadataErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAssessmentVariantMetadataResponses, PostApiAssessmentVariantMetadataErrors, ThrowOnError>({
            url: '/api/assessment-variant-metadata',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AssessmentVariantMetadata
     */
    public static deleteApiAssessmentVariantMetadataById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAssessmentVariantMetadataByIdData, ThrowOnError>): RequestResult<DeleteApiAssessmentVariantMetadataByIdResponses, DeleteApiAssessmentVariantMetadataByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAssessmentVariantMetadataByIdResponses, DeleteApiAssessmentVariantMetadataByIdErrors, ThrowOnError>({ url: '/api/assessment-variant-metadata/{id}', ...options });
    }
    
    /**
     * Get AssessmentVariantMetadata by ID
     */
    public static getApiAssessmentVariantMetadataById<ThrowOnError extends boolean = false>(options: Options<GetApiAssessmentVariantMetadataByIdData, ThrowOnError>): RequestResult<GetApiAssessmentVariantMetadataByIdResponses, GetApiAssessmentVariantMetadataByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAssessmentVariantMetadataByIdResponses, GetApiAssessmentVariantMetadataByIdErrors, ThrowOnError>({ url: '/api/assessment-variant-metadata/{id}', ...options });
    }
    
    /**
     * Update AssessmentVariantMetadata
     */
    public static putApiAssessmentVariantMetadataById<ThrowOnError extends boolean = false>(options: Options<PutApiAssessmentVariantMetadataByIdData, ThrowOnError>): RequestResult<PutApiAssessmentVariantMetadataByIdResponses, PutApiAssessmentVariantMetadataByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAssessmentVariantMetadataByIdResponses, PutApiAssessmentVariantMetadataByIdErrors, ThrowOnError>({
            url: '/api/assessment-variant-metadata/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List assessment-variants
     */
    public static getApiAssessmentVariants<ThrowOnError extends boolean = false>(options?: Options<GetApiAssessmentVariantsData, ThrowOnError>): RequestResult<GetApiAssessmentVariantsResponses, GetApiAssessmentVariantsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAssessmentVariantsResponses, GetApiAssessmentVariantsErrors, ThrowOnError>({ url: '/api/assessment-variants', ...options });
    }
    
    /**
     * Create AssessmentVariant
     */
    public static postApiAssessmentVariants<ThrowOnError extends boolean = false>(options: Options<PostApiAssessmentVariantsData, ThrowOnError>): RequestResult<PostApiAssessmentVariantsResponses, PostApiAssessmentVariantsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAssessmentVariantsResponses, PostApiAssessmentVariantsErrors, ThrowOnError>({
            url: '/api/assessment-variants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete AssessmentVariant
     */
    public static deleteApiAssessmentVariantsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAssessmentVariantsByIdData, ThrowOnError>): RequestResult<DeleteApiAssessmentVariantsByIdResponses, DeleteApiAssessmentVariantsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAssessmentVariantsByIdResponses, DeleteApiAssessmentVariantsByIdErrors, ThrowOnError>({ url: '/api/assessment-variants/{id}', ...options });
    }
    
    /**
     * Get AssessmentVariant by ID
     */
    public static getApiAssessmentVariantsById<ThrowOnError extends boolean = false>(options: Options<GetApiAssessmentVariantsByIdData, ThrowOnError>): RequestResult<GetApiAssessmentVariantsByIdResponses, GetApiAssessmentVariantsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAssessmentVariantsByIdResponses, GetApiAssessmentVariantsByIdErrors, ThrowOnError>({ url: '/api/assessment-variants/{id}', ...options });
    }
    
    /**
     * Update AssessmentVariant
     */
    public static putApiAssessmentVariantsById<ThrowOnError extends boolean = false>(options: Options<PutApiAssessmentVariantsByIdData, ThrowOnError>): RequestResult<PutApiAssessmentVariantsByIdResponses, PutApiAssessmentVariantsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAssessmentVariantsByIdResponses, PutApiAssessmentVariantsByIdErrors, ThrowOnError>({
            url: '/api/assessment-variants/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List assessments
     */
    public static getApiAssessments<ThrowOnError extends boolean = false>(options?: Options<GetApiAssessmentsData, ThrowOnError>): RequestResult<GetApiAssessmentsResponses, GetApiAssessmentsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAssessmentsResponses, GetApiAssessmentsErrors, ThrowOnError>({ url: '/api/assessments', ...options });
    }
    
    /**
     * Create Assessment
     */
    public static postApiAssessments<ThrowOnError extends boolean = false>(options: Options<PostApiAssessmentsData, ThrowOnError>): RequestResult<PostApiAssessmentsResponses, PostApiAssessmentsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAssessmentsResponses, PostApiAssessmentsErrors, ThrowOnError>({
            url: '/api/assessments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Assessment
     */
    public static deleteApiAssessmentsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAssessmentsByIdData, ThrowOnError>): RequestResult<DeleteApiAssessmentsByIdResponses, DeleteApiAssessmentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAssessmentsByIdResponses, DeleteApiAssessmentsByIdErrors, ThrowOnError>({ url: '/api/assessments/{id}', ...options });
    }
    
    /**
     * Get Assessment by ID
     */
    public static getApiAssessmentsById<ThrowOnError extends boolean = false>(options: Options<GetApiAssessmentsByIdData, ThrowOnError>): RequestResult<GetApiAssessmentsByIdResponses, GetApiAssessmentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAssessmentsByIdResponses, GetApiAssessmentsByIdErrors, ThrowOnError>({ url: '/api/assessments/{id}', ...options });
    }
    
    /**
     * Update Assessment
     */
    public static putApiAssessmentsById<ThrowOnError extends boolean = false>(options: Options<PutApiAssessmentsByIdData, ThrowOnError>): RequestResult<PutApiAssessmentsByIdResponses, PutApiAssessmentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAssessmentsByIdResponses, PutApiAssessmentsByIdErrors, ThrowOnError>({
            url: '/api/assessments/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuditService {
    /**
     * List audit-logs
     */
    public static getApiAuditLogs<ThrowOnError extends boolean = false>(options?: Options<GetApiAuditLogsData, ThrowOnError>): RequestResult<GetApiAuditLogsResponses, GetApiAuditLogsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAuditLogsResponses, GetApiAuditLogsErrors, ThrowOnError>({ url: '/api/audit-logs', ...options });
    }
    
    /**
     * Create AuditLog
     */
    public static postApiAuditLogs<ThrowOnError extends boolean = false>(options: Options<PostApiAuditLogsData, ThrowOnError>): RequestResult<PostApiAuditLogsResponses, PostApiAuditLogsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuditLogsResponses, PostApiAuditLogsErrors, ThrowOnError>({
            url: '/api/audit-logs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Latest viewer per patient (all patients)
     */
    public static getApiAuditLogsImpersonators<ThrowOnError extends boolean = false>(options?: Options<GetApiAuditLogsImpersonatorsData, ThrowOnError>): RequestResult<GetApiAuditLogsImpersonatorsResponses, GetApiAuditLogsImpersonatorsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAuditLogsImpersonatorsResponses, GetApiAuditLogsImpersonatorsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/audit-logs/impersonators',
            ...options
        });
    }
    
    /**
     * All viewers for a specific patient, latest per doctor
     */
    public static getApiAuditLogsImpersonatorsByPatientUserId<ThrowOnError extends boolean = false>(options: Options<GetApiAuditLogsImpersonatorsByPatientUserIdData, ThrowOnError>): RequestResult<GetApiAuditLogsImpersonatorsByPatientUserIdResponses, GetApiAuditLogsImpersonatorsByPatientUserIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAuditLogsImpersonatorsByPatientUserIdResponses, GetApiAuditLogsImpersonatorsByPatientUserIdErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/audit-logs/impersonators/{patientUserId}',
            ...options
        });
    }
    
    /**
     * Delete AuditLog
     */
    public static deleteApiAuditLogsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAuditLogsByIdData, ThrowOnError>): RequestResult<DeleteApiAuditLogsByIdResponses, DeleteApiAuditLogsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAuditLogsByIdResponses, DeleteApiAuditLogsByIdErrors, ThrowOnError>({ url: '/api/audit-logs/{id}', ...options });
    }
    
    /**
     * Get AuditLog by ID
     */
    public static getApiAuditLogsById<ThrowOnError extends boolean = false>(options: Options<GetApiAuditLogsByIdData, ThrowOnError>): RequestResult<GetApiAuditLogsByIdResponses, GetApiAuditLogsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAuditLogsByIdResponses, GetApiAuditLogsByIdErrors, ThrowOnError>({ url: '/api/audit-logs/{id}', ...options });
    }
    
    /**
     * Update AuditLog
     */
    public static putApiAuditLogsById<ThrowOnError extends boolean = false>(options: Options<PutApiAuditLogsByIdData, ThrowOnError>): RequestResult<PutApiAuditLogsByIdResponses, PutApiAuditLogsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAuditLogsByIdResponses, PutApiAuditLogsByIdErrors, ThrowOnError>({
            url: '/api/audit-logs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthService {
    /**
     * Create a fresh dev user and return an access token (dev only)
     */
    public static postApiAuthDevNewUser<ThrowOnError extends boolean = false>(options: Options<PostApiAuthDevNewUserData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/auth/dev-new-user',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List available dev test users (dev only)
     */
    public static getApiAuthDevUsers<ThrowOnError extends boolean = false>(options?: Options<GetApiAuthDevUsersData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/auth/dev-users', ...options });
    }
    
    /**
     * Exchange OIDC ID token (or NIN in dev) for API access token
     */
    public static postApiAuthMintToken<ThrowOnError extends boolean = false>(options: Options<PostApiAuthMintTokenData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/auth/mint-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Refresh a user access token
     *
     * Re-mints a still-valid user token with a fresh expiry (24 hours on web, 30 days in the app) until the session reaches its absolute limit (7 days on web, 90 days in the app) counted from the original BankID login. After that the user must log in again.
     */
    public static postApiAuthRefreshToken<ThrowOnError extends boolean = false>(options: Options<PostApiAuthRefreshTokenData, ThrowOnError>): RequestResult<PostApiAuthRefreshTokenResponses, PostApiAuthRefreshTokenErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthRefreshTokenResponses, PostApiAuthRefreshTokenErrors, ThrowOnError>({
            url: '/api/auth/refresh-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuthorizationService {
    /**
     * Create a one-time impersonation code
     *
     * Generates a short-lived code that can be exchanged for a user token. Used by the backoffice to open the frontend as a specific user. Requires admin or doctor role, and a non-empty reason, which is written to the audit log as the grunnlag for the access. Every staff member, admins included, may open at most 40 distinct patients per 24 hours (429 past that) until another admin or superuser resets them.
     */
    public static postApiAuthorizationCreateImpersonationCode<ThrowOnError extends boolean = false>(options: Options<PostApiAuthorizationCreateImpersonationCodeData, ThrowOnError>): RequestResult<PostApiAuthorizationCreateImpersonationCodeResponses, PostApiAuthorizationCreateImpersonationCodeErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthorizationCreateImpersonationCodeResponses, PostApiAuthorizationCreateImpersonationCodeErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/authorization/create-impersonation-code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List staff at the daily patient limit
     *
     * Staff members who have opened 40 distinct patients since 24 hours ago or their latest reset, whichever is later. Requires the admin or superuser role.
     */
    public static getApiAuthorizationDailyPatientLimit<ThrowOnError extends boolean = false>(options?: Options<GetApiAuthorizationDailyPatientLimitData, ThrowOnError>): RequestResult<GetApiAuthorizationDailyPatientLimitResponses, GetApiAuthorizationDailyPatientLimitErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAuthorizationDailyPatientLimitResponses, GetApiAuthorizationDailyPatientLimitErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/authorization/daily-patient-limit',
            ...options
        });
    }
    
    /**
     * Reset a staff member's daily patient limit
     *
     * Restarts the staff member's count of opened patients from now. Requires the admin or superuser role, and refuses a reset of the caller's own limit. The reset is written to the audit log with its reason.
     */
    public static postApiAuthorizationDailyPatientLimitReset<ThrowOnError extends boolean = false>(options: Options<PostApiAuthorizationDailyPatientLimitResetData, ThrowOnError>): RequestResult<PostApiAuthorizationDailyPatientLimitResetResponses, PostApiAuthorizationDailyPatientLimitResetErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthorizationDailyPatientLimitResetResponses, PostApiAuthorizationDailyPatientLimitResetErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/authorization/daily-patient-limit/reset',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Exchange an impersonation code for a token
     *
     * Exchanges a one-time impersonation code for a short-lived user JWT. No authentication required — the code is the credential.
     */
    public static postApiAuthorizationExchangeImpersonationCode<ThrowOnError extends boolean = false>(options: Options<PostApiAuthorizationExchangeImpersonationCodeData, ThrowOnError>): RequestResult<PostApiAuthorizationExchangeImpersonationCodeResponses, PostApiAuthorizationExchangeImpersonationCodeErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthorizationExchangeImpersonationCodeResponses, PostApiAuthorizationExchangeImpersonationCodeErrors, ThrowOnError>({
            url: '/api/authorization/exchange-impersonation-code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Impersonate a user
     *
     * Mints a short-lived JWT for the target user. Requires the caller to have an admin or doctor role, and a non-empty reason, which is written to the audit log as the grunnlag for the access. Every staff member, admins included, may open at most 40 distinct patients per 24 hours (429 past that) until another admin or superuser resets them.
     */
    public static postApiAuthorizationImpersonate<ThrowOnError extends boolean = false>(options: Options<PostApiAuthorizationImpersonateData, ThrowOnError>): RequestResult<PostApiAuthorizationImpersonateResponses, PostApiAuthorizationImpersonateErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthorizationImpersonateResponses, PostApiAuthorizationImpersonateErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/authorization/impersonate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Exchange OIDC ID token for admin access token
     *
     * Verifies a Criipto OIDC ID token (or NIN in dev mode), checks the user has an admin or doctor role, and returns a JWT valid for 4 hours. Tokens are automatically refreshed on each request via /api/authorization/refresh-token.
     */
    public static postApiAuthorizationMintAdminToken<ThrowOnError extends boolean = false>(options: Options<PostApiAuthorizationMintAdminTokenData, ThrowOnError>): RequestResult<PostApiAuthorizationMintAdminTokenResponses, PostApiAuthorizationMintAdminTokenErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthorizationMintAdminTokenResponses, PostApiAuthorizationMintAdminTokenErrors, ThrowOnError>({
            url: '/api/authorization/mint-admin-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Refresh admin/doctor access token
     *
     * Extends the expiry of a valid admin or doctor token by 4 hours. Used for silent token refresh during active sessions.
     */
    public static postApiAuthorizationRefreshToken<ThrowOnError extends boolean = false>(options: Options<PostApiAuthorizationRefreshTokenData, ThrowOnError>): RequestResult<PostApiAuthorizationRefreshTokenResponses, PostApiAuthorizationRefreshTokenErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthorizationRefreshTokenResponses, PostApiAuthorizationRefreshTokenErrors, ThrowOnError>({
            url: '/api/authorization/refresh-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List user-roles
     */
    public static getApiAuthorizationUserRoles<ThrowOnError extends boolean = false>(options?: Options<GetApiAuthorizationUserRolesData, ThrowOnError>): RequestResult<GetApiAuthorizationUserRolesResponses, GetApiAuthorizationUserRolesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiAuthorizationUserRolesResponses, GetApiAuthorizationUserRolesErrors, ThrowOnError>({ url: '/api/authorization/user-roles', ...options });
    }
    
    /**
     * Create UserRole
     */
    public static postApiAuthorizationUserRoles<ThrowOnError extends boolean = false>(options: Options<PostApiAuthorizationUserRolesData, ThrowOnError>): RequestResult<PostApiAuthorizationUserRolesResponses, PostApiAuthorizationUserRolesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiAuthorizationUserRolesResponses, PostApiAuthorizationUserRolesErrors, ThrowOnError>({
            url: '/api/authorization/user-roles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UserRole
     */
    public static deleteApiAuthorizationUserRolesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiAuthorizationUserRolesByIdData, ThrowOnError>): RequestResult<DeleteApiAuthorizationUserRolesByIdResponses, DeleteApiAuthorizationUserRolesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiAuthorizationUserRolesByIdResponses, DeleteApiAuthorizationUserRolesByIdErrors, ThrowOnError>({ url: '/api/authorization/user-roles/{id}', ...options });
    }
    
    /**
     * Get UserRole by ID
     */
    public static getApiAuthorizationUserRolesById<ThrowOnError extends boolean = false>(options: Options<GetApiAuthorizationUserRolesByIdData, ThrowOnError>): RequestResult<GetApiAuthorizationUserRolesByIdResponses, GetApiAuthorizationUserRolesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiAuthorizationUserRolesByIdResponses, GetApiAuthorizationUserRolesByIdErrors, ThrowOnError>({ url: '/api/authorization/user-roles/{id}', ...options });
    }
    
    /**
     * Update UserRole
     */
    public static putApiAuthorizationUserRolesById<ThrowOnError extends boolean = false>(options: Options<PutApiAuthorizationUserRolesByIdData, ThrowOnError>): RequestResult<PutApiAuthorizationUserRolesByIdResponses, PutApiAuthorizationUserRolesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiAuthorizationUserRolesByIdResponses, PutApiAuthorizationUserRolesByIdErrors, ThrowOnError>({
            url: '/api/authorization/user-roles/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class MarketingService {
    /**
     * Submit a contact form inquiry
     *
     * Public endpoint protected by API key. Sends email + Slack notifications to the team.
     */
    public static postApiBedriftContact<ThrowOnError extends boolean = false>(options: Options<PostApiBedriftContactData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/bedrift-contact',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List marketing-referrals
     */
    public static getApiMarketingReferrals<ThrowOnError extends boolean = false>(options?: Options<GetApiMarketingReferralsData, ThrowOnError>): RequestResult<GetApiMarketingReferralsResponses, GetApiMarketingReferralsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiMarketingReferralsResponses, GetApiMarketingReferralsErrors, ThrowOnError>({ url: '/api/marketing-referrals', ...options });
    }
    
    /**
     * Create MarketingReferral
     */
    public static postApiMarketingReferrals<ThrowOnError extends boolean = false>(options: Options<PostApiMarketingReferralsData, ThrowOnError>): RequestResult<PostApiMarketingReferralsResponses, PostApiMarketingReferralsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiMarketingReferralsResponses, PostApiMarketingReferralsErrors, ThrowOnError>({
            url: '/api/marketing-referrals',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete MarketingReferral
     */
    public static deleteApiMarketingReferralsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiMarketingReferralsByIdData, ThrowOnError>): RequestResult<DeleteApiMarketingReferralsByIdResponses, DeleteApiMarketingReferralsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiMarketingReferralsByIdResponses, DeleteApiMarketingReferralsByIdErrors, ThrowOnError>({ url: '/api/marketing-referrals/{id}', ...options });
    }
    
    /**
     * Get MarketingReferral by ID
     */
    public static getApiMarketingReferralsById<ThrowOnError extends boolean = false>(options: Options<GetApiMarketingReferralsByIdData, ThrowOnError>): RequestResult<GetApiMarketingReferralsByIdResponses, GetApiMarketingReferralsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiMarketingReferralsByIdResponses, GetApiMarketingReferralsByIdErrors, ThrowOnError>({ url: '/api/marketing-referrals/{id}', ...options });
    }
    
    /**
     * Update MarketingReferral
     */
    public static putApiMarketingReferralsById<ThrowOnError extends boolean = false>(options: Options<PutApiMarketingReferralsByIdData, ThrowOnError>): RequestResult<PutApiMarketingReferralsByIdResponses, PutApiMarketingReferralsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiMarketingReferralsByIdResponses, PutApiMarketingReferralsByIdErrors, ThrowOnError>({
            url: '/api/marketing-referrals/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List onboarding
     */
    public static getApiOnboarding<ThrowOnError extends boolean = false>(options?: Options<GetApiOnboardingData, ThrowOnError>): RequestResult<GetApiOnboardingResponses, GetApiOnboardingErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiOnboardingResponses, GetApiOnboardingErrors, ThrowOnError>({ url: '/api/onboarding', ...options });
    }
    
    /**
     * Create Onboarding
     */
    public static postApiOnboarding<ThrowOnError extends boolean = false>(options: Options<PostApiOnboardingData, ThrowOnError>): RequestResult<PostApiOnboardingResponses, PostApiOnboardingErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiOnboardingResponses, PostApiOnboardingErrors, ThrowOnError>({
            url: '/api/onboarding',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Onboarding
     */
    public static deleteApiOnboardingById<ThrowOnError extends boolean = false>(options: Options<DeleteApiOnboardingByIdData, ThrowOnError>): RequestResult<DeleteApiOnboardingByIdResponses, DeleteApiOnboardingByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiOnboardingByIdResponses, DeleteApiOnboardingByIdErrors, ThrowOnError>({ url: '/api/onboarding/{id}', ...options });
    }
    
    /**
     * Get Onboarding by ID
     */
    public static getApiOnboardingById<ThrowOnError extends boolean = false>(options: Options<GetApiOnboardingByIdData, ThrowOnError>): RequestResult<GetApiOnboardingByIdResponses, GetApiOnboardingByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiOnboardingByIdResponses, GetApiOnboardingByIdErrors, ThrowOnError>({ url: '/api/onboarding/{id}', ...options });
    }
    
    /**
     * Update Onboarding
     */
    public static putApiOnboardingById<ThrowOnError extends boolean = false>(options: Options<PutApiOnboardingByIdData, ThrowOnError>): RequestResult<PutApiOnboardingByIdResponses, PutApiOnboardingByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiOnboardingByIdResponses, PutApiOnboardingByIdErrors, ThrowOnError>({
            url: '/api/onboarding/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update consent on a pre-auth onboarding row
     *
     * Public endpoint scoped to the onboarding UUID. Used by the onboarding consent screen before the user has authenticated. When adTrackingConsent flips false → true, any awaiting_consent conversion events tied to this onboarding row are replayed.
     */
    public static postApiOnboardingByIdConsent<ThrowOnError extends boolean = false>(options: Options<PostApiOnboardingByIdConsentData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/onboarding/{id}/consent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class BhtSurveysService {
    /**
     * List bht-question-alternatives
     */
    public static getApiBhtQuestionAlternatives<ThrowOnError extends boolean = false>(options?: Options<GetApiBhtQuestionAlternativesData, ThrowOnError>): RequestResult<GetApiBhtQuestionAlternativesResponses, GetApiBhtQuestionAlternativesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBhtQuestionAlternativesResponses, GetApiBhtQuestionAlternativesErrors, ThrowOnError>({ url: '/api/bht-question-alternatives', ...options });
    }
    
    /**
     * Create BhtQuestionAlternative
     */
    public static postApiBhtQuestionAlternatives<ThrowOnError extends boolean = false>(options: Options<PostApiBhtQuestionAlternativesData, ThrowOnError>): RequestResult<PostApiBhtQuestionAlternativesResponses, PostApiBhtQuestionAlternativesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBhtQuestionAlternativesResponses, PostApiBhtQuestionAlternativesErrors, ThrowOnError>({
            url: '/api/bht-question-alternatives',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BhtQuestionAlternative
     */
    public static deleteApiBhtQuestionAlternativesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBhtQuestionAlternativesByIdData, ThrowOnError>): RequestResult<DeleteApiBhtQuestionAlternativesByIdResponses, DeleteApiBhtQuestionAlternativesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBhtQuestionAlternativesByIdResponses, DeleteApiBhtQuestionAlternativesByIdErrors, ThrowOnError>({ url: '/api/bht-question-alternatives/{id}', ...options });
    }
    
    /**
     * Get BhtQuestionAlternative by ID
     */
    public static getApiBhtQuestionAlternativesById<ThrowOnError extends boolean = false>(options: Options<GetApiBhtQuestionAlternativesByIdData, ThrowOnError>): RequestResult<GetApiBhtQuestionAlternativesByIdResponses, GetApiBhtQuestionAlternativesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBhtQuestionAlternativesByIdResponses, GetApiBhtQuestionAlternativesByIdErrors, ThrowOnError>({ url: '/api/bht-question-alternatives/{id}', ...options });
    }
    
    /**
     * Update BhtQuestionAlternative
     */
    public static putApiBhtQuestionAlternativesById<ThrowOnError extends boolean = false>(options: Options<PutApiBhtQuestionAlternativesByIdData, ThrowOnError>): RequestResult<PutApiBhtQuestionAlternativesByIdResponses, PutApiBhtQuestionAlternativesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBhtQuestionAlternativesByIdResponses, PutApiBhtQuestionAlternativesByIdErrors, ThrowOnError>({
            url: '/api/bht-question-alternatives/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List bht-question-responses
     */
    public static getApiBhtQuestionResponses<ThrowOnError extends boolean = false>(options?: Options<GetApiBhtQuestionResponsesData, ThrowOnError>): RequestResult<GetApiBhtQuestionResponsesResponses, GetApiBhtQuestionResponsesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBhtQuestionResponsesResponses, GetApiBhtQuestionResponsesErrors, ThrowOnError>({ url: '/api/bht-question-responses', ...options });
    }
    
    /**
     * Create BhtQuestionRespons
     */
    public static postApiBhtQuestionResponses<ThrowOnError extends boolean = false>(options: Options<PostApiBhtQuestionResponsesData, ThrowOnError>): RequestResult<PostApiBhtQuestionResponsesResponses, PostApiBhtQuestionResponsesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBhtQuestionResponsesResponses, PostApiBhtQuestionResponsesErrors, ThrowOnError>({
            url: '/api/bht-question-responses',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BhtQuestionRespons
     */
    public static deleteApiBhtQuestionResponsesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBhtQuestionResponsesByIdData, ThrowOnError>): RequestResult<DeleteApiBhtQuestionResponsesByIdResponses, DeleteApiBhtQuestionResponsesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBhtQuestionResponsesByIdResponses, DeleteApiBhtQuestionResponsesByIdErrors, ThrowOnError>({ url: '/api/bht-question-responses/{id}', ...options });
    }
    
    /**
     * Get BhtQuestionRespons by ID
     */
    public static getApiBhtQuestionResponsesById<ThrowOnError extends boolean = false>(options: Options<GetApiBhtQuestionResponsesByIdData, ThrowOnError>): RequestResult<GetApiBhtQuestionResponsesByIdResponses, GetApiBhtQuestionResponsesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBhtQuestionResponsesByIdResponses, GetApiBhtQuestionResponsesByIdErrors, ThrowOnError>({ url: '/api/bht-question-responses/{id}', ...options });
    }
    
    /**
     * Update BhtQuestionRespons
     */
    public static putApiBhtQuestionResponsesById<ThrowOnError extends boolean = false>(options: Options<PutApiBhtQuestionResponsesByIdData, ThrowOnError>): RequestResult<PutApiBhtQuestionResponsesByIdResponses, PutApiBhtQuestionResponsesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBhtQuestionResponsesByIdResponses, PutApiBhtQuestionResponsesByIdErrors, ThrowOnError>({
            url: '/api/bht-question-responses/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List bht-questions
     */
    public static getApiBhtQuestions<ThrowOnError extends boolean = false>(options?: Options<GetApiBhtQuestionsData, ThrowOnError>): RequestResult<GetApiBhtQuestionsResponses, GetApiBhtQuestionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBhtQuestionsResponses, GetApiBhtQuestionsErrors, ThrowOnError>({ url: '/api/bht-questions', ...options });
    }
    
    /**
     * Create BhtQuestion
     */
    public static postApiBhtQuestions<ThrowOnError extends boolean = false>(options: Options<PostApiBhtQuestionsData, ThrowOnError>): RequestResult<PostApiBhtQuestionsResponses, PostApiBhtQuestionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBhtQuestionsResponses, PostApiBhtQuestionsErrors, ThrowOnError>({
            url: '/api/bht-questions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BhtQuestion
     */
    public static deleteApiBhtQuestionsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBhtQuestionsByIdData, ThrowOnError>): RequestResult<DeleteApiBhtQuestionsByIdResponses, DeleteApiBhtQuestionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBhtQuestionsByIdResponses, DeleteApiBhtQuestionsByIdErrors, ThrowOnError>({ url: '/api/bht-questions/{id}', ...options });
    }
    
    /**
     * Get BhtQuestion by ID
     */
    public static getApiBhtQuestionsById<ThrowOnError extends boolean = false>(options: Options<GetApiBhtQuestionsByIdData, ThrowOnError>): RequestResult<GetApiBhtQuestionsByIdResponses, GetApiBhtQuestionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBhtQuestionsByIdResponses, GetApiBhtQuestionsByIdErrors, ThrowOnError>({ url: '/api/bht-questions/{id}', ...options });
    }
    
    /**
     * Update BhtQuestion
     */
    public static putApiBhtQuestionsById<ThrowOnError extends boolean = false>(options: Options<PutApiBhtQuestionsByIdData, ThrowOnError>): RequestResult<PutApiBhtQuestionsByIdResponses, PutApiBhtQuestionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBhtQuestionsByIdResponses, PutApiBhtQuestionsByIdErrors, ThrowOnError>({
            url: '/api/bht-questions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class BillingService {
    /**
     * Cancel a subscription
     *
     * Cancels an active subscription via Periode and queues a poll to sync the final status.
     */
    public static postApiBillingCancelSubscription<ThrowOnError extends boolean = false>(options: Options<PostApiBillingCancelSubscriptionData, ThrowOnError>): RequestResult<PostApiBillingCancelSubscriptionResponses, PostApiBillingCancelSubscriptionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingCancelSubscriptionResponses, PostApiBillingCancelSubscriptionErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/cancel-subscription',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Check discount code validity
     *
     * Checks campaign codes, active subscription IDs, then custom recruitment codes linked to the owner's latest active subscription.
     */
    public static postApiBillingCheckDiscount<ThrowOnError extends boolean = false>(options: Options<PostApiBillingCheckDiscountData, ThrowOnError>): RequestResult<PostApiBillingCheckDiscountResponses, PostApiBillingCheckDiscountErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingCheckDiscountResponses, PostApiBillingCheckDiscountErrors, ThrowOnError>({
            url: '/api/billing/check-discount',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a draft subscription
     *
     * Creates a new draft subscription via Periode and returns the payment URL for the frontend to redirect the user.
     */
    public static postApiBillingCreateDraft<ThrowOnError extends boolean = false>(options: Options<PostApiBillingCreateDraftData, ThrowOnError>): RequestResult<PostApiBillingCreateDraftResponses, PostApiBillingCreateDraftErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingCreateDraftResponses, PostApiBillingCreateDraftErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/create-draft',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a single payment
     *
     * Creates a one-time payment via Periode and returns the payment URL. Use kind='one_lab_visit' for a single lab visit purchase.
     */
    public static postApiBillingCreateSinglePayment<ThrowOnError extends boolean = false>(options: Options<PostApiBillingCreateSinglePaymentData, ThrowOnError>): RequestResult<PostApiBillingCreateSinglePaymentResponses, PostApiBillingCreateSinglePaymentErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingCreateSinglePaymentResponses, PostApiBillingCreateSinglePaymentErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/create-single-payment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a paid tier upgrade payment
     *
     * Starts a Periode checkout for the price difference of a tier upgrade (kind upgrade_1_to_2 | upgrade_2_to_4 | upgrade_1_to_4). On payment the extra lab visits are granted and the tier changes from the next charge.
     */
    public static postApiBillingCreateUpgradePayment<ThrowOnError extends boolean = false>(options: Options<PostApiBillingCreateUpgradePaymentData, ThrowOnError>): RequestResult<PostApiBillingCreateUpgradePaymentResponses, PostApiBillingCreateUpgradePaymentErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingCreateUpgradePaymentResponses, PostApiBillingCreateUpgradePaymentErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/create-upgrade-payment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Poll single payment status
     *
     * Queues a poll-single-payment worker to sync payment status from Periode. Returns current status from database.
     */
    public static postApiBillingPollSinglePaymentStatus<ThrowOnError extends boolean = false>(options: Options<PostApiBillingPollSinglePaymentStatusData, ThrowOnError>): RequestResult<PostApiBillingPollSinglePaymentStatusResponses, PostApiBillingPollSinglePaymentStatusErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingPollSinglePaymentStatusResponses, PostApiBillingPollSinglePaymentStatusErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/poll-single-payment-status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Queue subscription status poll
     *
     * Queues a poll-subscription worker to sync subscription status from Periode. Returns current status from database.
     */
    public static postApiBillingPollSubscriptionStatus<ThrowOnError extends boolean = false>(options: Options<PostApiBillingPollSubscriptionStatusData, ThrowOnError>): RequestResult<PostApiBillingPollSubscriptionStatusResponses, PostApiBillingPollSubscriptionStatusErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingPollSubscriptionStatusResponses, PostApiBillingPollSubscriptionStatusErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/poll-subscription-status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get predicted income by month
     *
     * Returns predicted income aggregated by month for a given date range. Fetches PENDING invoices from Periode for each whole calendar month in the range and sums item amounts times quantities (øre). Includes subscription tier (under the product dimension key) and customer demographic/source/tenure breakdowns, distinct matched customer counts and unavailable-month flags. Successful upstream months are cached for up to 5 minutes; customer attributes are read afresh. The date range must be in the future and within 1 year from today.
     */
    public static getApiBillingPredictedIncome<ThrowOnError extends boolean = false>(options: Options<GetApiBillingPredictedIncomeData, ThrowOnError>): RequestResult<GetApiBillingPredictedIncomeResponses, GetApiBillingPredictedIncomeErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBillingPredictedIncomeResponses, GetApiBillingPredictedIncomeErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/predicted-income',
            ...options
        });
    }
    
    /**
     * Recruitment stats for the current user
     *
     * How many distinct customers this user has recruited and each recruitment activation time. Recruited customers' identities are never returned.
     */
    public static getApiBillingRecruitmentStats<ThrowOnError extends boolean = false>(options?: Options<GetApiBillingRecruitmentStatsData, ThrowOnError>): RequestResult<GetApiBillingRecruitmentStatsResponses, GetApiBillingRecruitmentStatsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBillingRecruitmentStatsResponses, GetApiBillingRecruitmentStatsErrors, ThrowOnError>({ url: '/api/billing/recruitment-stats', ...options });
    }
    
    /**
     * Refresh a subscription from Periode
     *
     * Fetches the subscription from Periode and syncs it before returning, unlike poll-subscription-status which only queues a background poll. The subscription screen calls this on open so the next charge — and any discount applied to it in Periode — is current.
     */
    public static postApiBillingRefreshSubscription<ThrowOnError extends boolean = false>(options: Options<PostApiBillingRefreshSubscriptionData, ThrowOnError>): RequestResult<PostApiBillingRefreshSubscriptionResponses, PostApiBillingRefreshSubscriptionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingRefreshSubscriptionResponses, PostApiBillingRefreshSubscriptionErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/refresh-subscription',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Undo a pending cancellation
     *
     * Reverses a pending cancellation in Periode before the expire date, then queues a poll to sync.
     */
    public static postApiBillingUndoCancelSubscription<ThrowOnError extends boolean = false>(options: Options<PostApiBillingUndoCancelSubscriptionData, ThrowOnError>): RequestResult<PostApiBillingUndoCancelSubscriptionResponses, PostApiBillingUndoCancelSubscriptionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingUndoCancelSubscriptionResponses, PostApiBillingUndoCancelSubscriptionErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/undo-cancel-subscription',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update subscription tier
     *
     * Updates the tier/plan of an existing subscription via Periode, then polls to sync status.
     */
    public static postApiBillingUpdateSubscription<ThrowOnError extends boolean = false>(options: Options<PostApiBillingUpdateSubscriptionData, ThrowOnError>): RequestResult<PostApiBillingUpdateSubscriptionResponses, PostApiBillingUpdateSubscriptionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBillingUpdateSubscriptionResponses, PostApiBillingUpdateSubscriptionErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/billing/update-subscription',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List invoices
     */
    public static getApiInvoices<ThrowOnError extends boolean = false>(options?: Options<GetApiInvoicesData, ThrowOnError>): RequestResult<GetApiInvoicesResponses, GetApiInvoicesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiInvoicesResponses, GetApiInvoicesErrors, ThrowOnError>({ url: '/api/invoices', ...options });
    }
    
    /**
     * Create Invoice
     */
    public static postApiInvoices<ThrowOnError extends boolean = false>(options: Options<PostApiInvoicesData, ThrowOnError>): RequestResult<PostApiInvoicesResponses, PostApiInvoicesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiInvoicesResponses, PostApiInvoicesErrors, ThrowOnError>({
            url: '/api/invoices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Invoice
     */
    public static deleteApiInvoicesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiInvoicesByIdData, ThrowOnError>): RequestResult<DeleteApiInvoicesByIdResponses, DeleteApiInvoicesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiInvoicesByIdResponses, DeleteApiInvoicesByIdErrors, ThrowOnError>({ url: '/api/invoices/{id}', ...options });
    }
    
    /**
     * Get Invoice by ID
     */
    public static getApiInvoicesById<ThrowOnError extends boolean = false>(options: Options<GetApiInvoicesByIdData, ThrowOnError>): RequestResult<GetApiInvoicesByIdResponses, GetApiInvoicesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiInvoicesByIdResponses, GetApiInvoicesByIdErrors, ThrowOnError>({ url: '/api/invoices/{id}', ...options });
    }
    
    /**
     * Update Invoice
     */
    public static putApiInvoicesById<ThrowOnError extends boolean = false>(options: Options<PutApiInvoicesByIdData, ThrowOnError>): RequestResult<PutApiInvoicesByIdResponses, PutApiInvoicesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiInvoicesByIdResponses, PutApiInvoicesByIdErrors, ThrowOnError>({
            url: '/api/invoices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List recruitment-codes
     */
    public static getApiRecruitmentCodes<ThrowOnError extends boolean = false>(options?: Options<GetApiRecruitmentCodesData, ThrowOnError>): RequestResult<GetApiRecruitmentCodesResponses, GetApiRecruitmentCodesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiRecruitmentCodesResponses, GetApiRecruitmentCodesErrors, ThrowOnError>({ url: '/api/recruitment-codes', ...options });
    }
    
    /**
     * Create RecruitmentCode
     */
    public static postApiRecruitmentCodes<ThrowOnError extends boolean = false>(options: Options<PostApiRecruitmentCodesData, ThrowOnError>): RequestResult<PostApiRecruitmentCodesResponses, PostApiRecruitmentCodesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiRecruitmentCodesResponses, PostApiRecruitmentCodesErrors, ThrowOnError>({
            url: '/api/recruitment-codes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete RecruitmentCode
     */
    public static deleteApiRecruitmentCodesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiRecruitmentCodesByIdData, ThrowOnError>): RequestResult<DeleteApiRecruitmentCodesByIdResponses, DeleteApiRecruitmentCodesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiRecruitmentCodesByIdResponses, DeleteApiRecruitmentCodesByIdErrors, ThrowOnError>({ url: '/api/recruitment-codes/{id}', ...options });
    }
    
    /**
     * Get RecruitmentCode by ID
     */
    public static getApiRecruitmentCodesById<ThrowOnError extends boolean = false>(options: Options<GetApiRecruitmentCodesByIdData, ThrowOnError>): RequestResult<GetApiRecruitmentCodesByIdResponses, GetApiRecruitmentCodesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiRecruitmentCodesByIdResponses, GetApiRecruitmentCodesByIdErrors, ThrowOnError>({ url: '/api/recruitment-codes/{id}', ...options });
    }
    
    /**
     * Update RecruitmentCode
     */
    public static putApiRecruitmentCodesById<ThrowOnError extends boolean = false>(options: Options<PutApiRecruitmentCodesByIdData, ThrowOnError>): RequestResult<PutApiRecruitmentCodesByIdResponses, PutApiRecruitmentCodesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiRecruitmentCodesByIdResponses, PutApiRecruitmentCodesByIdErrors, ThrowOnError>({
            url: '/api/recruitment-codes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List single-payments
     */
    public static getApiSinglePayments<ThrowOnError extends boolean = false>(options?: Options<GetApiSinglePaymentsData, ThrowOnError>): RequestResult<GetApiSinglePaymentsResponses, GetApiSinglePaymentsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSinglePaymentsResponses, GetApiSinglePaymentsErrors, ThrowOnError>({ url: '/api/single-payments', ...options });
    }
    
    /**
     * Create SinglePayment
     */
    public static postApiSinglePayments<ThrowOnError extends boolean = false>(options: Options<PostApiSinglePaymentsData, ThrowOnError>): RequestResult<PostApiSinglePaymentsResponses, PostApiSinglePaymentsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSinglePaymentsResponses, PostApiSinglePaymentsErrors, ThrowOnError>({
            url: '/api/single-payments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete SinglePayment
     */
    public static deleteApiSinglePaymentsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiSinglePaymentsByIdData, ThrowOnError>): RequestResult<DeleteApiSinglePaymentsByIdResponses, DeleteApiSinglePaymentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiSinglePaymentsByIdResponses, DeleteApiSinglePaymentsByIdErrors, ThrowOnError>({ url: '/api/single-payments/{id}', ...options });
    }
    
    /**
     * Get SinglePayment by ID
     */
    public static getApiSinglePaymentsById<ThrowOnError extends boolean = false>(options: Options<GetApiSinglePaymentsByIdData, ThrowOnError>): RequestResult<GetApiSinglePaymentsByIdResponses, GetApiSinglePaymentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiSinglePaymentsByIdResponses, GetApiSinglePaymentsByIdErrors, ThrowOnError>({ url: '/api/single-payments/{id}', ...options });
    }
    
    /**
     * Update SinglePayment
     */
    public static putApiSinglePaymentsById<ThrowOnError extends boolean = false>(options: Options<PutApiSinglePaymentsByIdData, ThrowOnError>): RequestResult<PutApiSinglePaymentsByIdResponses, PutApiSinglePaymentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiSinglePaymentsByIdResponses, PutApiSinglePaymentsByIdErrors, ThrowOnError>({
            url: '/api/single-payments/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List subscriptions
     */
    public static getApiSubscriptions<ThrowOnError extends boolean = false>(options?: Options<GetApiSubscriptionsData, ThrowOnError>): RequestResult<GetApiSubscriptionsResponses, GetApiSubscriptionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSubscriptionsResponses, GetApiSubscriptionsErrors, ThrowOnError>({ url: '/api/subscriptions', ...options });
    }
    
    /**
     * Create Subscription
     */
    public static postApiSubscriptions<ThrowOnError extends boolean = false>(options: Options<PostApiSubscriptionsData, ThrowOnError>): RequestResult<PostApiSubscriptionsResponses, PostApiSubscriptionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSubscriptionsResponses, PostApiSubscriptionsErrors, ThrowOnError>({
            url: '/api/subscriptions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Subscription
     */
    public static deleteApiSubscriptionsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiSubscriptionsByIdData, ThrowOnError>): RequestResult<DeleteApiSubscriptionsByIdResponses, DeleteApiSubscriptionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiSubscriptionsByIdResponses, DeleteApiSubscriptionsByIdErrors, ThrowOnError>({ url: '/api/subscriptions/{id}', ...options });
    }
    
    /**
     * Get Subscription by ID
     */
    public static getApiSubscriptionsById<ThrowOnError extends boolean = false>(options: Options<GetApiSubscriptionsByIdData, ThrowOnError>): RequestResult<GetApiSubscriptionsByIdResponses, GetApiSubscriptionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiSubscriptionsByIdResponses, GetApiSubscriptionsByIdErrors, ThrowOnError>({ url: '/api/subscriptions/{id}', ...options });
    }
    
    /**
     * Update Subscription
     */
    public static putApiSubscriptionsById<ThrowOnError extends boolean = false>(options: Options<PutApiSubscriptionsByIdData, ThrowOnError>): RequestResult<PutApiSubscriptionsByIdResponses, PutApiSubscriptionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiSubscriptionsByIdResponses, PutApiSubscriptionsByIdErrors, ThrowOnError>({
            url: '/api/subscriptions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class BiometricCatalogService {
    /**
     * List biometric-categories
     */
    public static getApiBiometricCategories<ThrowOnError extends boolean = false>(options?: Options<GetApiBiometricCategoriesData, ThrowOnError>): RequestResult<GetApiBiometricCategoriesResponses, GetApiBiometricCategoriesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBiometricCategoriesResponses, GetApiBiometricCategoriesErrors, ThrowOnError>({ url: '/api/biometric-categories', ...options });
    }
    
    /**
     * Create BiometricCategory
     */
    public static postApiBiometricCategories<ThrowOnError extends boolean = false>(options: Options<PostApiBiometricCategoriesData, ThrowOnError>): RequestResult<PostApiBiometricCategoriesResponses, PostApiBiometricCategoriesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBiometricCategoriesResponses, PostApiBiometricCategoriesErrors, ThrowOnError>({
            url: '/api/biometric-categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BiometricCategory
     */
    public static deleteApiBiometricCategoriesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBiometricCategoriesByIdData, ThrowOnError>): RequestResult<DeleteApiBiometricCategoriesByIdResponses, DeleteApiBiometricCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBiometricCategoriesByIdResponses, DeleteApiBiometricCategoriesByIdErrors, ThrowOnError>({ url: '/api/biometric-categories/{id}', ...options });
    }
    
    /**
     * Get BiometricCategory by ID
     */
    public static getApiBiometricCategoriesById<ThrowOnError extends boolean = false>(options: Options<GetApiBiometricCategoriesByIdData, ThrowOnError>): RequestResult<GetApiBiometricCategoriesByIdResponses, GetApiBiometricCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBiometricCategoriesByIdResponses, GetApiBiometricCategoriesByIdErrors, ThrowOnError>({ url: '/api/biometric-categories/{id}', ...options });
    }
    
    /**
     * Update BiometricCategory
     */
    public static putApiBiometricCategoriesById<ThrowOnError extends boolean = false>(options: Options<PutApiBiometricCategoriesByIdData, ThrowOnError>): RequestResult<PutApiBiometricCategoriesByIdResponses, PutApiBiometricCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBiometricCategoriesByIdResponses, PutApiBiometricCategoriesByIdErrors, ThrowOnError>({
            url: '/api/biometric-categories/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List biometric-prices
     */
    public static getApiBiometricPrices<ThrowOnError extends boolean = false>(options?: Options<GetApiBiometricPricesData, ThrowOnError>): RequestResult<GetApiBiometricPricesResponses, GetApiBiometricPricesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBiometricPricesResponses, GetApiBiometricPricesErrors, ThrowOnError>({ url: '/api/biometric-prices', ...options });
    }
    
    /**
     * Create BiometricPrice
     */
    public static postApiBiometricPrices<ThrowOnError extends boolean = false>(options: Options<PostApiBiometricPricesData, ThrowOnError>): RequestResult<PostApiBiometricPricesResponses, PostApiBiometricPricesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBiometricPricesResponses, PostApiBiometricPricesErrors, ThrowOnError>({
            url: '/api/biometric-prices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BiometricPrice
     */
    public static deleteApiBiometricPricesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBiometricPricesByIdData, ThrowOnError>): RequestResult<DeleteApiBiometricPricesByIdResponses, DeleteApiBiometricPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBiometricPricesByIdResponses, DeleteApiBiometricPricesByIdErrors, ThrowOnError>({ url: '/api/biometric-prices/{id}', ...options });
    }
    
    /**
     * Get BiometricPrice by ID
     */
    public static getApiBiometricPricesById<ThrowOnError extends boolean = false>(options: Options<GetApiBiometricPricesByIdData, ThrowOnError>): RequestResult<GetApiBiometricPricesByIdResponses, GetApiBiometricPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBiometricPricesByIdResponses, GetApiBiometricPricesByIdErrors, ThrowOnError>({ url: '/api/biometric-prices/{id}', ...options });
    }
    
    /**
     * Update BiometricPrice
     */
    public static putApiBiometricPricesById<ThrowOnError extends boolean = false>(options: Options<PutApiBiometricPricesByIdData, ThrowOnError>): RequestResult<PutApiBiometricPricesByIdResponses, PutApiBiometricPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBiometricPricesByIdResponses, PutApiBiometricPricesByIdErrors, ThrowOnError>({
            url: '/api/biometric-prices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List biometric-reference-ranges
     */
    public static getApiBiometricReferenceRanges<ThrowOnError extends boolean = false>(options?: Options<GetApiBiometricReferenceRangesData, ThrowOnError>): RequestResult<GetApiBiometricReferenceRangesResponses, GetApiBiometricReferenceRangesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBiometricReferenceRangesResponses, GetApiBiometricReferenceRangesErrors, ThrowOnError>({ url: '/api/biometric-reference-ranges', ...options });
    }
    
    /**
     * Create BiometricReferenceRange
     */
    public static postApiBiometricReferenceRanges<ThrowOnError extends boolean = false>(options: Options<PostApiBiometricReferenceRangesData, ThrowOnError>): RequestResult<PostApiBiometricReferenceRangesResponses, PostApiBiometricReferenceRangesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBiometricReferenceRangesResponses, PostApiBiometricReferenceRangesErrors, ThrowOnError>({
            url: '/api/biometric-reference-ranges',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BiometricReferenceRange
     */
    public static deleteApiBiometricReferenceRangesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBiometricReferenceRangesByIdData, ThrowOnError>): RequestResult<DeleteApiBiometricReferenceRangesByIdResponses, DeleteApiBiometricReferenceRangesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBiometricReferenceRangesByIdResponses, DeleteApiBiometricReferenceRangesByIdErrors, ThrowOnError>({ url: '/api/biometric-reference-ranges/{id}', ...options });
    }
    
    /**
     * Get BiometricReferenceRange by ID
     */
    public static getApiBiometricReferenceRangesById<ThrowOnError extends boolean = false>(options: Options<GetApiBiometricReferenceRangesByIdData, ThrowOnError>): RequestResult<GetApiBiometricReferenceRangesByIdResponses, GetApiBiometricReferenceRangesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBiometricReferenceRangesByIdResponses, GetApiBiometricReferenceRangesByIdErrors, ThrowOnError>({ url: '/api/biometric-reference-ranges/{id}', ...options });
    }
    
    /**
     * Update BiometricReferenceRange
     */
    public static putApiBiometricReferenceRangesById<ThrowOnError extends boolean = false>(options: Options<PutApiBiometricReferenceRangesByIdData, ThrowOnError>): RequestResult<PutApiBiometricReferenceRangesByIdResponses, PutApiBiometricReferenceRangesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBiometricReferenceRangesByIdResponses, PutApiBiometricReferenceRangesByIdErrors, ThrowOnError>({
            url: '/api/biometric-reference-ranges/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List biometrics
     */
    public static getApiBiometrics<ThrowOnError extends boolean = false>(options?: Options<GetApiBiometricsData, ThrowOnError>): RequestResult<GetApiBiometricsResponses, GetApiBiometricsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBiometricsResponses, GetApiBiometricsErrors, ThrowOnError>({ url: '/api/biometrics', ...options });
    }
    
    /**
     * Create Biometric
     */
    public static postApiBiometrics<ThrowOnError extends boolean = false>(options: Options<PostApiBiometricsData, ThrowOnError>): RequestResult<PostApiBiometricsResponses, PostApiBiometricsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBiometricsResponses, PostApiBiometricsErrors, ThrowOnError>({
            url: '/api/biometrics',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Biometric
     */
    public static deleteApiBiometricsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBiometricsByIdData, ThrowOnError>): RequestResult<DeleteApiBiometricsByIdResponses, DeleteApiBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBiometricsByIdResponses, DeleteApiBiometricsByIdErrors, ThrowOnError>({ url: '/api/biometrics/{id}', ...options });
    }
    
    /**
     * Get Biometric by ID
     */
    public static getApiBiometricsById<ThrowOnError extends boolean = false>(options: Options<GetApiBiometricsByIdData, ThrowOnError>): RequestResult<GetApiBiometricsByIdResponses, GetApiBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBiometricsByIdResponses, GetApiBiometricsByIdErrors, ThrowOnError>({ url: '/api/biometrics/{id}', ...options });
    }
    
    /**
     * Update Biometric
     */
    public static putApiBiometricsById<ThrowOnError extends boolean = false>(options: Options<PutApiBiometricsByIdData, ThrowOnError>): RequestResult<PutApiBiometricsByIdResponses, PutApiBiometricsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBiometricsByIdResponses, PutApiBiometricsByIdErrors, ThrowOnError>({
            url: '/api/biometrics/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List blood-test-packages
     */
    public static getApiBloodTestPackages<ThrowOnError extends boolean = false>(options?: Options<GetApiBloodTestPackagesData, ThrowOnError>): RequestResult<GetApiBloodTestPackagesResponses, GetApiBloodTestPackagesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiBloodTestPackagesResponses, GetApiBloodTestPackagesErrors, ThrowOnError>({ url: '/api/blood-test-packages', ...options });
    }
    
    /**
     * Create BloodTestPackage
     */
    public static postApiBloodTestPackages<ThrowOnError extends boolean = false>(options: Options<PostApiBloodTestPackagesData, ThrowOnError>): RequestResult<PostApiBloodTestPackagesResponses, PostApiBloodTestPackagesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiBloodTestPackagesResponses, PostApiBloodTestPackagesErrors, ThrowOnError>({
            url: '/api/blood-test-packages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete BloodTestPackage
     */
    public static deleteApiBloodTestPackagesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiBloodTestPackagesByIdData, ThrowOnError>): RequestResult<DeleteApiBloodTestPackagesByIdResponses, DeleteApiBloodTestPackagesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiBloodTestPackagesByIdResponses, DeleteApiBloodTestPackagesByIdErrors, ThrowOnError>({ url: '/api/blood-test-packages/{id}', ...options });
    }
    
    /**
     * Get BloodTestPackage by ID
     */
    public static getApiBloodTestPackagesById<ThrowOnError extends boolean = false>(options: Options<GetApiBloodTestPackagesByIdData, ThrowOnError>): RequestResult<GetApiBloodTestPackagesByIdResponses, GetApiBloodTestPackagesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiBloodTestPackagesByIdResponses, GetApiBloodTestPackagesByIdErrors, ThrowOnError>({ url: '/api/blood-test-packages/{id}', ...options });
    }
    
    /**
     * Update BloodTestPackage
     */
    public static putApiBloodTestPackagesById<ThrowOnError extends boolean = false>(options: Options<PutApiBloodTestPackagesByIdData, ThrowOnError>): RequestResult<PutApiBloodTestPackagesByIdResponses, PutApiBloodTestPackagesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiBloodTestPackagesByIdResponses, PutApiBloodTestPackagesByIdErrors, ThrowOnError>({
            url: '/api/blood-test-packages/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List categories
     */
    public static getApiCategories<ThrowOnError extends boolean = false>(options?: Options<GetApiCategoriesData, ThrowOnError>): RequestResult<GetApiCategoriesResponses, GetApiCategoriesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiCategoriesResponses, GetApiCategoriesErrors, ThrowOnError>({ url: '/api/categories', ...options });
    }
    
    /**
     * Create Category
     */
    public static postApiCategories<ThrowOnError extends boolean = false>(options: Options<PostApiCategoriesData, ThrowOnError>): RequestResult<PostApiCategoriesResponses, PostApiCategoriesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiCategoriesResponses, PostApiCategoriesErrors, ThrowOnError>({
            url: '/api/categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Category
     */
    public static deleteApiCategoriesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiCategoriesByIdData, ThrowOnError>): RequestResult<DeleteApiCategoriesByIdResponses, DeleteApiCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiCategoriesByIdResponses, DeleteApiCategoriesByIdErrors, ThrowOnError>({ url: '/api/categories/{id}', ...options });
    }
    
    /**
     * Get Category by ID
     */
    public static getApiCategoriesById<ThrowOnError extends boolean = false>(options: Options<GetApiCategoriesByIdData, ThrowOnError>): RequestResult<GetApiCategoriesByIdResponses, GetApiCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiCategoriesByIdResponses, GetApiCategoriesByIdErrors, ThrowOnError>({ url: '/api/categories/{id}', ...options });
    }
    
    /**
     * Update Category
     */
    public static putApiCategoriesById<ThrowOnError extends boolean = false>(options: Options<PutApiCategoriesByIdData, ThrowOnError>): RequestResult<PutApiCategoriesByIdResponses, PutApiCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiCategoriesByIdResponses, PutApiCategoriesByIdErrors, ThrowOnError>({
            url: '/api/categories/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CompaniesService {
    /**
     * List companies
     */
    public static getApiCompanies<ThrowOnError extends boolean = false>(options?: Options<GetApiCompaniesData, ThrowOnError>): RequestResult<GetApiCompaniesResponses, GetApiCompaniesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiCompaniesResponses, GetApiCompaniesErrors, ThrowOnError>({ url: '/api/companies', ...options });
    }
    
    /**
     * Create Company
     */
    public static postApiCompanies<ThrowOnError extends boolean = false>(options: Options<PostApiCompaniesData, ThrowOnError>): RequestResult<PostApiCompaniesResponses, PostApiCompaniesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiCompaniesResponses, PostApiCompaniesErrors, ThrowOnError>({
            url: '/api/companies',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Look up company by slug or ID (public)
     *
     * Public endpoint returning limited company data. Accepts a company slug or UUID. Used by the login page and frontend B2B flow.
     */
    public static getApiCompaniesLookupByLookup<ThrowOnError extends boolean = false>(options: Options<GetApiCompaniesLookupByLookupData, ThrowOnError>): RequestResult<GetApiCompaniesLookupByLookupResponses, GetApiCompaniesLookupByLookupErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiCompaniesLookupByLookupResponses, GetApiCompaniesLookupByLookupErrors, ThrowOnError>({ url: '/api/companies/lookup/{lookup}', ...options });
    }
    
    /**
     * Delete Company
     */
    public static deleteApiCompaniesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiCompaniesByIdData, ThrowOnError>): RequestResult<DeleteApiCompaniesByIdResponses, DeleteApiCompaniesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiCompaniesByIdResponses, DeleteApiCompaniesByIdErrors, ThrowOnError>({ url: '/api/companies/{id}', ...options });
    }
    
    /**
     * Get Company by ID
     */
    public static getApiCompaniesById<ThrowOnError extends boolean = false>(options: Options<GetApiCompaniesByIdData, ThrowOnError>): RequestResult<GetApiCompaniesByIdResponses, GetApiCompaniesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiCompaniesByIdResponses, GetApiCompaniesByIdErrors, ThrowOnError>({ url: '/api/companies/{id}', ...options });
    }
    
    /**
     * Update Company
     */
    public static putApiCompaniesById<ThrowOnError extends boolean = false>(options: Options<PutApiCompaniesByIdData, ThrowOnError>): RequestResult<PutApiCompaniesByIdResponses, PutApiCompaniesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiCompaniesByIdResponses, PutApiCompaniesByIdErrors, ThrowOnError>({
            url: '/api/companies/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CrmService {
    /**
     * Look up a customer for support
     *
     * Finds customers by email (exact, case-insensitive, profile or verified contact email) or, when the email finds nobody, by name tokens in either order. Returns subscriptions, payments (NOK), lab visits and requisition statuses. Leaves out results, which biometrics were requisitioned, the HELFO flag and the national identity number. Authenticated with an API key from System → API-nøkler.
     */
    public static getApiCrmLookup<ThrowOnError extends boolean = false>(options?: Options<GetApiCrmLookupData, ThrowOnError>): RequestResult<GetApiCrmLookupResponses, GetApiCrmLookupErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiCrmLookupResponses, GetApiCrmLookupErrors, ThrowOnError>({
            security: [{
                    key: 'apiKey',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/crm-lookup',
            ...options
        });
    }
}

export class AdminViewsService {
    /**
     * Get detailed CRM period breakdown
     *
     * Returns monthly series, payment breakdown, discount details, and lab breakdown for a date range.
     */
    public static getApiCrmPeriodDetails<ThrowOnError extends boolean = false>(options: Options<GetApiCrmPeriodDetailsData, ThrowOnError>): RequestResult<GetApiCrmPeriodDetailsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetApiCrmPeriodDetailsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/crm-period-details',
            ...options
        });
    }
    
    /**
     * Get CRM period statistics
     *
     * Returns aggregate CRM stats for a date range: new subscribers, payments, lab visits, revenue, and discount codes used.
     */
    public static getApiCrmPeriodStats<ThrowOnError extends boolean = false>(options: Options<GetApiCrmPeriodStatsData, ThrowOnError>): RequestResult<GetApiCrmPeriodStatsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetApiCrmPeriodStatsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/crm-period-stats',
            ...options
        });
    }
    
    /**
     * Stored subscription types for CRM filters
     */
    public static getApiCrmSubscriptionTiers<ThrowOnError extends boolean = false>(options?: Options<GetApiCrmSubscriptionTiersData, ThrowOnError>): RequestResult<GetApiCrmSubscriptionTiersResponses, GetApiCrmSubscriptionTiersErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiCrmSubscriptionTiersResponses, GetApiCrmSubscriptionTiersErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/crm-subscription-tiers',
            ...options
        });
    }
    
    /**
     * List crm-user
     */
    public static getApiCrmUser<ThrowOnError extends boolean = false>(options?: Options<GetApiCrmUserData, ThrowOnError>): RequestResult<GetApiCrmUserResponses, GetApiCrmUserErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiCrmUserResponses, GetApiCrmUserErrors, ThrowOnError>({ url: '/api/crm-user', ...options });
    }
    
    /**
     * Create CrmUser
     */
    public static postApiCrmUser<ThrowOnError extends boolean = false>(options: Options<PostApiCrmUserData, ThrowOnError>): RequestResult<PostApiCrmUserResponses, PostApiCrmUserErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiCrmUserResponses, PostApiCrmUserErrors, ThrowOnError>({
            url: '/api/crm-user',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Number of users in the CRM roster
     */
    public static getApiCrmUserCount<ThrowOnError extends boolean = false>(options?: Options<GetApiCrmUserCountData, ThrowOnError>): RequestResult<GetApiCrmUserCountResponses, GetApiCrmUserCountErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiCrmUserCountResponses, GetApiCrmUserCountErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/crm-user-count',
            ...options
        });
    }
    
    /**
     * Delete CrmUser
     */
    public static deleteApiCrmUserById<ThrowOnError extends boolean = false>(options: Options<DeleteApiCrmUserByIdData, ThrowOnError>): RequestResult<DeleteApiCrmUserByIdResponses, DeleteApiCrmUserByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiCrmUserByIdResponses, DeleteApiCrmUserByIdErrors, ThrowOnError>({ url: '/api/crm-user/{id}', ...options });
    }
    
    /**
     * Get CrmUser by ID
     */
    public static getApiCrmUserById<ThrowOnError extends boolean = false>(options: Options<GetApiCrmUserByIdData, ThrowOnError>): RequestResult<GetApiCrmUserByIdResponses, GetApiCrmUserByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiCrmUserByIdResponses, GetApiCrmUserByIdErrors, ThrowOnError>({ url: '/api/crm-user/{id}', ...options });
    }
    
    /**
     * Update CrmUser
     */
    public static putApiCrmUserById<ThrowOnError extends boolean = false>(options: Options<PutApiCrmUserByIdData, ThrowOnError>): RequestResult<PutApiCrmUserByIdResponses, PutApiCrmUserByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiCrmUserByIdResponses, PutApiCrmUserByIdErrors, ThrowOnError>({
            url: '/api/crm-user/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read one patient's national identity number
     *
     * Returns the NIN for a single patient and records the read in the audit log (action `read_nin`). Admin only.
     */
    public static getApiCrmUserByIdNin<ThrowOnError extends boolean = false>(options: Options<GetApiCrmUserByIdNinData, ThrowOnError>): RequestResult<GetApiCrmUserByIdNinResponses, GetApiCrmUserByIdNinErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiCrmUserByIdNinResponses, GetApiCrmUserByIdNinErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/crm-user/{id}/nin',
            ...options
        });
    }
    
    /**
     * Get available lab price sources
     *
     * Returns distinct price sources from the lab_prices table.
     */
    public static getApiLabPriceSources<ThrowOnError extends boolean = false>(options?: Options<GetApiLabPriceSourcesData, ThrowOnError>): RequestResult<GetApiLabPriceSourcesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiLabPriceSourcesResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/lab-price-sources',
            ...options
        });
    }
    
    /**
     * Get lab visit cost breakdown
     *
     * Returns per-biometric cost breakdown for a lab visit, deduplicated by furstId. Lists the same rows the CRM period stats charge — standard-requisition markers plus unrequisitioned results — with everything the CRM does not charge listed at 0.
     */
    public static getApiLabVisitCostBreakdownById<ThrowOnError extends boolean = false>(options: Options<GetApiLabVisitCostBreakdownByIdData, ThrowOnError>): RequestResult<GetApiLabVisitCostBreakdownByIdResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabVisitCostBreakdownByIdResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/lab-visit-cost-breakdown/{id}',
            ...options
        });
    }
    
    /**
     * List users-needing-action
     */
    public static getApiUsersNeedingAction<ThrowOnError extends boolean = false>(options?: Options<GetApiUsersNeedingActionData, ThrowOnError>): RequestResult<GetApiUsersNeedingActionResponses, GetApiUsersNeedingActionErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUsersNeedingActionResponses, GetApiUsersNeedingActionErrors, ThrowOnError>({ url: '/api/users-needing-action', ...options });
    }
    
    /**
     * Create UsersNeedingAction
     */
    public static postApiUsersNeedingAction<ThrowOnError extends boolean = false>(options: Options<PostApiUsersNeedingActionData, ThrowOnError>): RequestResult<PostApiUsersNeedingActionResponses, PostApiUsersNeedingActionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUsersNeedingActionResponses, PostApiUsersNeedingActionErrors, ThrowOnError>({
            url: '/api/users-needing-action',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UsersNeedingAction
     */
    public static deleteApiUsersNeedingActionById<ThrowOnError extends boolean = false>(options: Options<DeleteApiUsersNeedingActionByIdData, ThrowOnError>): RequestResult<DeleteApiUsersNeedingActionByIdResponses, DeleteApiUsersNeedingActionByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiUsersNeedingActionByIdResponses, DeleteApiUsersNeedingActionByIdErrors, ThrowOnError>({ url: '/api/users-needing-action/{id}', ...options });
    }
    
    /**
     * Get UsersNeedingAction by ID
     */
    public static getApiUsersNeedingActionById<ThrowOnError extends boolean = false>(options: Options<GetApiUsersNeedingActionByIdData, ThrowOnError>): RequestResult<GetApiUsersNeedingActionByIdResponses, GetApiUsersNeedingActionByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiUsersNeedingActionByIdResponses, GetApiUsersNeedingActionByIdErrors, ThrowOnError>({ url: '/api/users-needing-action/{id}', ...options });
    }
    
    /**
     * Update UsersNeedingAction
     */
    public static putApiUsersNeedingActionById<ThrowOnError extends boolean = false>(options: Options<PutApiUsersNeedingActionByIdData, ThrowOnError>): RequestResult<PutApiUsersNeedingActionByIdResponses, PutApiUsersNeedingActionByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiUsersNeedingActionByIdResponses, PutApiUsersNeedingActionByIdErrors, ThrowOnError>({
            url: '/api/users-needing-action/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DashboardsService {
    /**
     * List available dashboards and their charts
     */
    public static getApiDashboards<ThrowOnError extends boolean = false>(options?: Options<GetApiDashboardsData, ThrowOnError>): RequestResult<GetApiDashboardsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiDashboardsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/',
            ...options
        });
    }
    
    /**
     * Bedrift — Lønnsomhet — Per bedrift
     *
     * Samme regnestykke per bedrift. income_per_visit er inntekt per ansatt delt på blodprøver per år — det én levert helsesjekk er verdt. Null betyr at ingen har lagt den inn, ikke at den er null.
     */
    public static postApiDashboardsB2bEconomicsCompanyEconomicsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bEconomicsCompanyEconomicsRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bEconomicsCompanyEconomicsRunResponses, PostApiDashboardsB2bEconomicsCompanyEconomicsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bEconomicsCompanyEconomicsRunResponses, PostApiDashboardsB2bEconomicsCompanyEconomicsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-economics/company-economics/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bedrift — Lønnsomhet — Markører — privat vs. Helfo
     *
     * Hvor mange ganger hver markør ble tatt på levert helsesjekk, delt på privat (vi betaler) og Helfo (staten betaler). Én rad = én Furst-analysekode, ikke én katalogmarkør: flere markører deler kode (009 dekker Leukocytter m/diff med differensialtelling) og faktureres én gang, så raden rapporteres under den dyreste markøren i koden.
     */
    public static postApiDashboardsB2bEconomicsMarkerUsageRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bEconomicsMarkerUsageRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bEconomicsMarkerUsageRunResponses, PostApiDashboardsB2bEconomicsMarkerUsageRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bEconomicsMarkerUsageRunResponses, PostApiDashboardsB2bEconomicsMarkerUsageRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-economics/marker-usage/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bedrift — Lønnsomhet — Per produkt
     *
     * Inntekt og de tre kostnadsbøttene per bedriftsprodukt, for helsesjekker levert i perioden. Inntekt, margin og resultat dekker bare bedrifter der inntekt per ansatt er lagt inn — companies_missing_income teller resten.
     */
    public static postApiDashboardsB2bEconomicsProductEconomicsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bEconomicsProductEconomicsRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bEconomicsProductEconomicsRunResponses, PostApiDashboardsB2bEconomicsProductEconomicsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bEconomicsProductEconomicsRunResponses, PostApiDashboardsB2bEconomicsProductEconomicsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-economics/product-economics/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bedrift — Lønnsomhet — Kost prøvetakning
     *
     * Hva én blodprøve koster å ta, og hvor tallet kommer fra. Én rad per lab som tok blod i perioden, med prisen fra lab_prices. En lab har normalt én pris; har den flere er de alternativer for ulike kunder, og da settes ingen pris i stedet for å legge dem sammen. Summen av «Kostnad» er prøvetakningen i «Per bedrift».
     */
    public static postApiDashboardsB2bEconomicsSamplingRatesRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bEconomicsSamplingRatesRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bEconomicsSamplingRatesRunResponses, PostApiDashboardsB2bEconomicsSamplingRatesRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bEconomicsSamplingRatesRunResponses, PostApiDashboardsB2bEconomicsSamplingRatesRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-economics/sampling-rates/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bedrift — Labbesok — Totaler per bedrift
     *
     * Påbegynte og gjennomførte besøk, unike ansatte (av påbegynte), og statusfordeling per bedrift.
     */
    public static postApiDashboardsB2bLabVisitsCompanyTotalsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bLabVisitsCompanyTotalsRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bLabVisitsCompanyTotalsRunResponses, PostApiDashboardsB2bLabVisitsCompanyTotalsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bLabVisitsCompanyTotalsRunResponses, PostApiDashboardsB2bLabVisitsCompanyTotalsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-lab-visits/company-totals/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bedrift — Labbesok — Ansatte for bedrift
     *
     * Liste over ansatte som har påbegynt labbesok i perioden. Filtrer på companyIds for valgte bedrifter.
     */
    public static postApiDashboardsB2bLabVisitsEmployeesForCompanyRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunResponses, PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunResponses, PostApiDashboardsB2bLabVisitsEmployeesForCompanyRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-lab-visits/employees-for-company/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bedrift — Labbesok — Statusfordeling
     *
     * Antall B2B-labbesok per status (kohort: påbegynt i perioden).
     */
    public static postApiDashboardsB2bLabVisitsStatusBreakdownRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bLabVisitsStatusBreakdownRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bLabVisitsStatusBreakdownRunResponses, PostApiDashboardsB2bLabVisitsStatusBreakdownRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bLabVisitsStatusBreakdownRunResponses, PostApiDashboardsB2bLabVisitsStatusBreakdownRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-lab-visits/status-breakdown/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bedrift — Labbesok — Besok over tid
     *
     * Påbegynte (created_at) og gjennomførte (visit_date) B2B-besøk per dag.
     */
    public static postApiDashboardsB2bLabVisitsVisitsOverTimeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsB2bLabVisitsVisitsOverTimeRunData, ThrowOnError>): RequestResult<PostApiDashboardsB2bLabVisitsVisitsOverTimeRunResponses, PostApiDashboardsB2bLabVisitsVisitsOverTimeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsB2bLabVisitsVisitsOverTimeRunResponses, PostApiDashboardsB2bLabVisitsVisitsOverTimeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/b2b-lab-visits/visits-over-time/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Churn — Betalende medlemmer over tid
     *
     * Antall betalende medlemmer ved slutten av hver måned i perioden. En bruker telles som betalende på dato D dersom de har et abonnement som startet ≤ D og enten ikke har churnet eller churnet > D.
     */
    public static postApiDashboardsChurnActiveTrendRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsChurnActiveTrendRunData, ThrowOnError>): RequestResult<PostApiDashboardsChurnActiveTrendRunResponses, PostApiDashboardsChurnActiveTrendRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsChurnActiveTrendRunResponses, PostApiDashboardsChurnActiveTrendRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/churn/active-trend/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Churn — Tilgjengelige abonnementsnivå
     *
     * Distinkte tier-verdier på siste abonnement til alle churnede brukere. Brukes til å bygge filter-chipsene for tid-til-churn-charten.
     */
    public static postApiDashboardsChurnAvailableTiersRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsChurnAvailableTiersRunData, ThrowOnError>): RequestResult<PostApiDashboardsChurnAvailableTiersRunResponses, PostApiDashboardsChurnAvailableTiersRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsChurnAvailableTiersRunResponses, PostApiDashboardsChurnAvailableTiersRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/churn/available-tiers/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Churn — Betalende medlemmer akkurat nå
     *
     * Betalende nå, oppsigelser under behandling (pendingCancel), og brukere som reaktiverte abonnementet sitt denne måneden.
     */
    public static postApiDashboardsChurnHeadlineRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsChurnHeadlineRunData, ThrowOnError>): RequestResult<PostApiDashboardsChurnHeadlineRunResponses, PostApiDashboardsChurnHeadlineRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsChurnHeadlineRunResponses, PostApiDashboardsChurnHeadlineRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/churn/headline/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Churn — Hvor lenge varer medlemskapet
     *
     * Fordeling av antall måneder mellom første aktive abonnement og siste utløp, for brukere som er klassifisert som churnet i dag.
     */
    public static postApiDashboardsChurnTimeToChurnRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsChurnTimeToChurnRunData, ThrowOnError>): RequestResult<PostApiDashboardsChurnTimeToChurnRunResponses, PostApiDashboardsChurnTimeToChurnRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsChurnTimeToChurnRunResponses, PostApiDashboardsChurnTimeToChurnRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/churn/time-to-churn/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Churn — Retensjon per signup-måned
     *
     * Per signup-måned: andelen av kohorten som fortsatt er aktive medlemmer i dag. Brukere som churnet og kom tilbake telles som aktive. En bruker hører til kohorten der de først ble aktive.
     */
    public static postApiDashboardsChurnYoyRetentionRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsChurnYoyRetentionRunData, ThrowOnError>): RequestResult<PostApiDashboardsChurnYoyRetentionRunResponses, PostApiDashboardsChurnYoyRetentionRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsChurnYoyRetentionRunResponses, PostApiDashboardsChurnYoyRetentionRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/churn/yoy-retention/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Kohortkonvertering — Kohortgrid
     *
     * Antall signups og andel konverterte per kohort og akkvisisjonskanal. Konverteringstall er ikke-kumulative (konverterte i akkurat den måneden).
     */
    public static postApiDashboardsCohortConversionCohortGridRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsCohortConversionCohortGridRunData, ThrowOnError>): RequestResult<PostApiDashboardsCohortConversionCohortGridRunResponses, PostApiDashboardsCohortConversionCohortGridRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsCohortConversionCohortGridRunResponses, PostApiDashboardsCohortConversionCohortGridRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/cohort-conversion/cohort-grid/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Kohortkonvertering — Konvertering per aldersgruppe
     *
     * Konverteringsrate per aldersgruppe.
     */
    public static postApiDashboardsCohortConversionDemographicAgeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsCohortConversionDemographicAgeRunData, ThrowOnError>): RequestResult<PostApiDashboardsCohortConversionDemographicAgeRunResponses, PostApiDashboardsCohortConversionDemographicAgeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsCohortConversionDemographicAgeRunResponses, PostApiDashboardsCohortConversionDemographicAgeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/cohort-conversion/demographic-age/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Kohortkonvertering — Konvertering per kjønn
     *
     * Konverteringsrate per kjønn.
     */
    public static postApiDashboardsCohortConversionDemographicGenderRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsCohortConversionDemographicGenderRunData, ThrowOnError>): RequestResult<PostApiDashboardsCohortConversionDemographicGenderRunResponses, PostApiDashboardsCohortConversionDemographicGenderRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsCohortConversionDemographicGenderRunResponses, PostApiDashboardsCohortConversionDemographicGenderRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/cohort-conversion/demographic-gender/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Kohortkonvertering — Nøkkeltall
     *
     * Konverteringsrate (BankID → betalt), median dager til konvertering, e-poster som ikke har gjennomført BankID, og beste kanal i perioden.
     */
    public static postApiDashboardsCohortConversionKpisRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsCohortConversionKpisRunData, ThrowOnError>): RequestResult<PostApiDashboardsCohortConversionKpisRunResponses, PostApiDashboardsCohortConversionKpisRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsCohortConversionKpisRunResponses, PostApiDashboardsCohortConversionKpisRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/cohort-conversion/kpis/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Kohortkonvertering — Tid til konvertering
     *
     * Fordeling av dager fra signup til første abonnement. Viser bare brukere som faktisk har konvertert.
     */
    public static postApiDashboardsCohortConversionTimeToConvertRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsCohortConversionTimeToConvertRunData, ThrowOnError>): RequestResult<PostApiDashboardsCohortConversionTimeToConvertRunResponses, PostApiDashboardsCohortConversionTimeToConvertRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsCohortConversionTimeToConvertRunResponses, PostApiDashboardsCohortConversionTimeToConvertRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/cohort-conversion/time-to-convert/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Kundekilder og aktive medlemmer — Kundekilder
     *
     * Én rad per kilde og variant. Kunder telles én gang per rad, og aktive medlemmer har minst ett abonnement med status aktiv akkurat nå.
     */
    public static postApiDashboardsCustomerAttributionSourcesRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsCustomerAttributionSourcesRunData, ThrowOnError>): RequestResult<PostApiDashboardsCustomerAttributionSourcesRunResponses, PostApiDashboardsCustomerAttributionSourcesRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsCustomerAttributionSourcesRunResponses, PostApiDashboardsCustomerAttributionSourcesRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/customer-attribution/sources/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Kundebilde — Kundebilde
     *
     * Aggregert og personvernskjermet kundebilde. Ingen identifiserbare kundedata eller fritekst.
     */
    public static postApiDashboardsCustomerPortraitSnapshotRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsCustomerPortraitSnapshotRunData, ThrowOnError>): RequestResult<PostApiDashboardsCustomerPortraitSnapshotRunResponses, PostApiDashboardsCustomerPortraitSnapshotRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsCustomerPortraitSnapshotRunResponses, PostApiDashboardsCustomerPortraitSnapshotRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/customer-portrait/snapshot/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Rabattkoder — Totaler per kode
     *
     * Antall bruk, antall unike brukere, og brutto omsetning per kode. Recruiter/Recruited-koder slås sammen til familien.
     */
    public static postApiDashboardsDiscountCodesCodeTotalsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsDiscountCodesCodeTotalsRunData, ThrowOnError>): RequestResult<PostApiDashboardsDiscountCodesCodeTotalsRunResponses, PostApiDashboardsDiscountCodesCodeTotalsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsDiscountCodesCodeTotalsRunResponses, PostApiDashboardsDiscountCodesCodeTotalsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/discount-codes/code-totals/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Rabattkoder — Bruk over tid
     *
     * Antall fakturaer med rabattkode per dag, og brutto omsetning på dem.
     */
    public static postApiDashboardsDiscountCodesUsageOverTimeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsDiscountCodesUsageOverTimeRunData, ThrowOnError>): RequestResult<PostApiDashboardsDiscountCodesUsageOverTimeRunResponses, PostApiDashboardsDiscountCodesUsageOverTimeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsDiscountCodesUsageOverTimeRunResponses, PostApiDashboardsDiscountCodesUsageOverTimeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/discount-codes/usage-over-time/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Rabattkoder — Brukere for kode
     *
     * Liste over brukere som har brukt en gitt kode i perioden. Viser den fulle koden (inkl. unik referrer-id) for fakturering.
     */
    public static postApiDashboardsDiscountCodesUsersForCodeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsDiscountCodesUsersForCodeRunData, ThrowOnError>): RequestResult<PostApiDashboardsDiscountCodesUsersForCodeRunResponses, PostApiDashboardsDiscountCodesUsersForCodeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsDiscountCodesUsersForCodeRunResponses, PostApiDashboardsDiscountCodesUsersForCodeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/discount-codes/users-for-code/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * App-feedback — Negative tilbakemeldinger
     *
     * Alle negative tilbakemeldinger i valgt periode med tekst og bruker (navn/e-post), nyeste først. Maks 500 rader.
     */
    public static postApiDashboardsFeedbackNegativeFeedbackRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsFeedbackNegativeFeedbackRunData, ThrowOnError>): RequestResult<PostApiDashboardsFeedbackNegativeFeedbackRunResponses, PostApiDashboardsFeedbackNegativeFeedbackRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsFeedbackNegativeFeedbackRunResponses, PostApiDashboardsFeedbackNegativeFeedbackRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/feedback/negative-feedback/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * App-feedback — Per plattform
     *
     * Positive og negative tilbakemeldinger per plattform i valgt periode.
     */
    public static postApiDashboardsFeedbackPlatformSplitRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsFeedbackPlatformSplitRunData, ThrowOnError>): RequestResult<PostApiDashboardsFeedbackPlatformSplitRunResponses, PostApiDashboardsFeedbackPlatformSplitRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsFeedbackPlatformSplitRunResponses, PostApiDashboardsFeedbackPlatformSplitRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/feedback/platform-split/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * App-feedback — Nøkkeltall
     *
     * Totaler for valgt periode, pluss forrige periode av samme lengde for å vise endring i positiv andel.
     */
    public static postApiDashboardsFeedbackSummaryRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsFeedbackSummaryRunData, ThrowOnError>): RequestResult<PostApiDashboardsFeedbackSummaryRunResponses, PostApiDashboardsFeedbackSummaryRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsFeedbackSummaryRunResponses, PostApiDashboardsFeedbackSummaryRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/feedback/summary/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * App-feedback — Per flate
     *
     * Totaler, positiv andel og negative med tekst per flate i valgt periode.
     */
    public static postApiDashboardsFeedbackSurfaceSummaryRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsFeedbackSurfaceSummaryRunData, ThrowOnError>): RequestResult<PostApiDashboardsFeedbackSurfaceSummaryRunResponses, PostApiDashboardsFeedbackSurfaceSummaryRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsFeedbackSurfaceSummaryRunResponses, PostApiDashboardsFeedbackSurfaceSummaryRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/feedback/surface-summary/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * App-feedback — Per uke og flate
     *
     * Antall tilbakemeldinger og antall positive per uke per flate. Grunnlag for både positiv-andel-linjene og volumsøylene.
     */
    public static postApiDashboardsFeedbackWeeklyRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsFeedbackWeeklyRunData, ThrowOnError>): RequestResult<PostApiDashboardsFeedbackWeeklyRunResponses, PostApiDashboardsFeedbackWeeklyRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsFeedbackWeeklyRunResponses, PostApiDashboardsFeedbackWeeklyRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/feedback/weekly/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Helseutvikling — Filtervalg og definisjoner
     */
    public static postApiDashboardsHealthOutcomesOptionsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsHealthOutcomesOptionsRunData, ThrowOnError>): RequestResult<PostApiDashboardsHealthOutcomesOptionsRunResponses, PostApiDashboardsHealthOutcomesOptionsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsHealthOutcomesOptionsRunResponses, PostApiDashboardsHealthOutcomesOptionsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/health-outcomes/options/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Helseutvikling — Helseutvikling
     */
    public static postApiDashboardsHealthOutcomesSnapshotRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsHealthOutcomesSnapshotRunData, ThrowOnError>): RequestResult<PostApiDashboardsHealthOutcomesSnapshotRunResponses, PostApiDashboardsHealthOutcomesSnapshotRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsHealthOutcomesSnapshotRunResponses, PostApiDashboardsHealthOutcomesSnapshotRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/health-outcomes/snapshot/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * HELFO-regelendring — Dagens regler mot nye regler
     *
     * Hvert besøk spilles av på nytt med anamnese og prøvehistorikk slik de var da rekvisisjonen ble laget. Tall fra 1 til 4 vises som «<5».
     */
    public static postApiDashboardsHelfoRulesV2ComparisonRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsHelfoRulesV2ComparisonRunData, ThrowOnError>): RequestResult<PostApiDashboardsHelfoRulesV2ComparisonRunResponses, PostApiDashboardsHelfoRulesV2ComparisonRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsHelfoRulesV2ComparisonRunResponses, PostApiDashboardsHelfoRulesV2ComparisonRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/helfo-rules-v2/comparison/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Laboratorier — Bruk over tid — Totaler per lab
     *
     * Gjennomførte og rekvirerte besøk per laboratorium i perioden. lab_id er null for besøk uten lab.
     */
    public static postApiDashboardsLabUsageLabTotalsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLabUsageLabTotalsRunData, ThrowOnError>): RequestResult<PostApiDashboardsLabUsageLabTotalsRunResponses, PostApiDashboardsLabUsageLabTotalsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLabUsageLabTotalsRunResponses, PostApiDashboardsLabUsageLabTotalsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/lab-usage/lab-totals/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Laboratorier — Bruk over tid — Besøk per lab over tid
     *
     * Gjennomførte og rekvirerte besøk per måned eller dag og laboratorium. lab_id og lab_name er null for besøk uten lab.
     */
    public static postApiDashboardsLabUsageVisitsOverTimeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLabUsageVisitsOverTimeRunData, ThrowOnError>): RequestResult<PostApiDashboardsLabUsageVisitsOverTimeRunResponses, PostApiDashboardsLabUsageVisitsOverTimeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLabUsageVisitsOverTimeRunResponses, PostApiDashboardsLabUsageVisitsOverTimeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/lab-usage/visits-over-time/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Avbrutt betaling
     *
     * Startet et abonnement som aldri ble belastet — avvist kort eller avbrutt hos Periode — og har aldri betalt på annen måte. Aktivitetsdato = da abonnementsraden ble opprettet. Forsøk fra før august 2025 har ingen aktivitetsdato: en migrering overskrev created_at, og for et abonnement som aldri ble belastet finnes det ingen betalingsdato å gjenopprette den fra. De vises med «—» og faller utenfor når du filtrerer på aktivitetsdato.
     */
    public static postApiDashboardsLeadsAbandonedCheckoutRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsAbandonedCheckoutRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsAbandonedCheckoutRunResponses, PostApiDashboardsLeadsAbandonedCheckoutRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsAbandonedCheckoutRunResponses, PostApiDashboardsLeadsAbandonedCheckoutRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/abandoned-checkout/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — B2B-ansatt uten eget kjøp
     *
     * Har fått labbesøk betalt av arbeidsgiver (lab_visits.company_id), men har aldri kjøpt noe selv. Oppsalgsliste. Brukere som har både bedriftsbetalte og egenbetalte besøk faller ut — de er allerede private kunder. Aktivitetsdato = første bedriftsbetalte besøk.
     */
    public static postApiDashboardsLeadsB2bNoPersonalPurchaseRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsB2bNoPersonalPurchaseRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsB2bNoPersonalPurchaseRunResponses, PostApiDashboardsLeadsB2bNoPersonalPurchaseRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsB2bNoPersonalPurchaseRunResponses, PostApiDashboardsLeadsB2bNoPersonalPurchaseRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/b2b-no-personal-purchase/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Opprettet bruker med BankID, ikke betalt
     *
     * Har opprettet en BankID-bruker (Criipto), men verken brukeren eller en arbeidsgiver har betalt. Inkluderer også dem som ikke har fylt ut profil, svart på spørsmål eller valgt abonnement. Kun selvrapporterte labbesøk teller ikke som kjøp. Registrert- og aktivitetsdato = da BankID-brukeren ble opprettet.
     */
    public static postApiDashboardsLeadsBankidNoPurchaseRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsBankidNoPurchaseRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsBankidNoPurchaseRunResponses, PostApiDashboardsLeadsBankidNoPurchaseRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsBankidNoPurchaseRunResponses, PostApiDashboardsLeadsBankidNoPurchaseRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/bankid-no-purchase/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Churnede abonnenter
     *
     * Har betalt for et abonnement tidligere, men har ingen aktivt abonnement nå. Dette segmentet ekskluderer bevisst ikke betalende — det er per definisjon folk som har betalt. Aktivitetsdato = churn-dato.
     */
    public static postApiDashboardsLeadsChurnedSubscribersRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsChurnedSubscribersRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsChurnedSubscribersRunResponses, PostApiDashboardsLeadsChurnedSubscribersRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsChurnedSubscribersRunResponses, PostApiDashboardsLeadsChurnedSubscribersRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/churned-subscribers/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Registrert e-post, uten BankID-bruker
     *
     * Har registrert e-post, men ingen tilknyttet bruker er funnet via registreringen eller e-postadressen. Nyeste registrering per normaliserte e-postadresse brukes, også for samtykke. Registrert- og aktivitetsdato = denne e-postregistreringen. Bruker-ID og profilopplysninger er tomme fordi det ikke finnes en bruker ennå.
     */
    public static postApiDashboardsLeadsEmailNoBankidRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsEmailNoBankidRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsEmailNoBankidRunResponses, PostApiDashboardsLeadsEmailNoBankidRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsEmailNoBankidRunResponses, PostApiDashboardsLeadsEmailNoBankidRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/email-no-bankid/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Hvem er filtrert bort
     *
     * For et gitt segment: hvor mange som gjorde handlingen, hvor mange som ble med, og hvorfor resten falt fra — egenbetalende, bedriftsbetalte (B2B), eller en annen grunn.
     */
    public static postApiDashboardsLeadsExclusionsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsExclusionsRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsExclusionsRunResponses, PostApiDashboardsLeadsExclusionsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsExclusionsRunResponses, PostApiDashboardsLeadsExclusionsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/exclusions/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Har svart på spørsmål, men ikke betalende
     *
     * Har svart på minst ett spørsmål i helseundersøkelsen, men har aldri betalt. Aktivitetsdato = første svar.
     */
    public static postApiDashboardsLeadsSurveyAnsweredNoPurchaseRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyAnsweredNoPurchaseRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/survey-answered-no-purchase/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Fullført helseundersøkelse, men ikke betalende
     *
     * health_survey_completed = true, men har aldri betalt. Sterkeste intensjonssignalet uten kjøp. Aktivitetsdato = siste svar.
     */
    public static postApiDashboardsLeadsSurveyCompletedNoPurchaseRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyCompletedNoPurchaseRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/survey-completed-no-purchase/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Sist aktiv i undersøkelsen, men ikke betalende
     *
     * Har svart på minst ett spørsmål i helseundersøkelsen, men har aldri betalt. Samme gruppe som «Har svart på spørsmål», men datert på siste svar i stedet for første — aktivitetsfilteret finner altså de som fortsatt svarte i perioden, uansett når de begynte.
     */
    public static postApiDashboardsLeadsSurveyLastAnswerNoPurchaseRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunResponses, PostApiDashboardsLeadsSurveyLastAnswerNoPurchaseRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/survey-last-answer-no-purchase/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Påbegynt, men ikke fullført undersøkelse
     *
     * Har svart på minst ett spørsmål, men health_survey_completed = false. Uavhengig av om de har betalt. Aktivitetsdato = siste svar.
     */
    public static postApiDashboardsLeadsSurveyStartedNotFinishedRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsSurveyStartedNotFinishedRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsSurveyStartedNotFinishedRunResponses, PostApiDashboardsLeadsSurveyStartedNotFinishedRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsSurveyStartedNotFinishedRunResponses, PostApiDashboardsLeadsSurveyStartedNotFinishedRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/survey-started-not-finished/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Valgte abonnement, men ikke betalende
     *
     * Har sett abonnementssiden og valgt et abonnement (membership_tier_selected_at er satt), men har aldri betalt. Engasjement = valgte abonnement; kvalifisering = ikke betalende kunde (notPayingCustomer), som eksitter både personlige og bedriftsbetalte labbesøk. Dette svarer til starten av send-payment-nudge-worker, men bruker leads-dashbordets labbesøksbaserte 'har betalt'-definisjon i stedet for workerens hasPaid() (som også sjekker aktiv subskrypsjon). Aktivitetsdato = da abonnementet ble valgt.
     */
    public static postApiDashboardsLeadsTierSelectedNoPurchaseRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsTierSelectedNoPurchaseRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsTierSelectedNoPurchaseRunResponses, PostApiDashboardsLeadsTierSelectedNoPurchaseRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsTierSelectedNoPurchaseRunResponses, PostApiDashboardsLeadsTierSelectedNoPurchaseRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/tier-selected-no-purchase/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Leads — Wearable, men ikke betalende
     *
     * Har data fra Garmin eller Apple Health, men har aldri betalt. Aktivitetsdato = første synk.
     */
    public static postApiDashboardsLeadsWearableNoPurchaseRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsLeadsWearableNoPurchaseRunData, ThrowOnError>): RequestResult<PostApiDashboardsLeadsWearableNoPurchaseRunResponses, PostApiDashboardsLeadsWearableNoPurchaseRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsLeadsWearableNoPurchaseRunResponses, PostApiDashboardsLeadsWearableNoPurchaseRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/leads/wearable-no-purchase/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Vervinger — Hvem verver og hvem blir vervet?
     *
     * Unike personer per periode, fordelt på alder ved vervingen, registrert kjønn og abonnementstype. Ververe telles ved sin første verving i hver periode.
     */
    public static postApiDashboardsReferralsDemographicsOverTimeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsReferralsDemographicsOverTimeRunData, ThrowOnError>): RequestResult<PostApiDashboardsReferralsDemographicsOverTimeRunResponses, PostApiDashboardsReferralsDemographicsOverTimeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsReferralsDemographicsOverTimeRunResponses, PostApiDashboardsReferralsDemographicsOverTimeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/referrals/demographics-over-time/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Vervinger — Abonnementstyper i perioden
     *
     * Tilgjengelige abonnementstyper for valgt filterrolle. Andre kundefiltre begrenser ikke valgene.
     */
    public static postApiDashboardsReferralsFilterOptionsRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsReferralsFilterOptionsRunData, ThrowOnError>): RequestResult<PostApiDashboardsReferralsFilterOptionsRunResponses, PostApiDashboardsReferralsFilterOptionsRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsReferralsFilterOptionsRunResponses, PostApiDashboardsReferralsFilterOptionsRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/referrals/filter-options/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Vervinger — Vervinger over tid
     *
     * Antall vervede kunder per år, måned, uke (mandag–søndag) eller dag, datert på starten av deres første betalte abonnement.
     */
    public static postApiDashboardsReferralsReferralsOverTimeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsReferralsReferralsOverTimeRunData, ThrowOnError>): RequestResult<PostApiDashboardsReferralsReferralsOverTimeRunResponses, PostApiDashboardsReferralsReferralsOverTimeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsReferralsReferralsOverTimeRunResponses, PostApiDashboardsReferralsReferralsOverTimeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/referrals/referrals-over-time/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Vervinger — Ververe
     *
     * Alle som har vervet minst én kunde i perioden, sortert på antall vervede, med hvem de vervet.
     */
    public static postApiDashboardsReferralsReferrersRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsReferralsReferrersRunData, ThrowOnError>): RequestResult<PostApiDashboardsReferralsReferrersRunResponses, PostApiDashboardsReferralsReferrersRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsReferralsReferrersRunResponses, PostApiDashboardsReferralsReferrersRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/referrals/referrers/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Vervinger — VERVET-kode uten kjent verver
     *
     * Kunder som brukte rabattkoden VERVET uten å være koblet til en verver, per år, måned, uke eller dag, datert på starten av deres første betalte abonnement.
     */
    public static postApiDashboardsReferralsVervetCodeOverTimeRun<ThrowOnError extends boolean = false>(options: Options<PostApiDashboardsReferralsVervetCodeOverTimeRunData, ThrowOnError>): RequestResult<PostApiDashboardsReferralsVervetCodeOverTimeRunResponses, PostApiDashboardsReferralsVervetCodeOverTimeRunErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDashboardsReferralsVervetCodeOverTimeRunResponses, PostApiDashboardsReferralsVervetCodeOverTimeRunErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/dashboards/referrals/vervet-code-over-time/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DoctorMessagesService {
    /**
     * List doctor message threads
     *
     * Staff list all threads (optionally filtered by status, authUserId, labVisitId, unread, awaitingReply; BHT staff see only BHT customers), without the last message's text. Customers, and staff impersonating one, list that customer's own threads with it. Ordered by last activity. `hasUnread` is true while the customer has a doctor message newer than their last read. `awaitingReply=true` keeps threads whose latest message is the customer's.
     */
    public static getApiDoctorMessagesThreads<ThrowOnError extends boolean = false>(options?: Options<GetApiDoctorMessagesThreadsData, ThrowOnError>): RequestResult<GetApiDoctorMessagesThreadsResponses, GetApiDoctorMessagesThreadsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiDoctorMessagesThreadsResponses, GetApiDoctorMessagesThreadsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads',
            ...options
        });
    }
    
    /**
     * Open a doctor chat thread for a lab visit
     *
     * Creates the thread and the customer's first message in one transaction. One thread per lab visit; 409 when one already exists (fetch it instead).
     */
    public static postApiDoctorMessagesThreads<ThrowOnError extends boolean = false>(options: Options<PostApiDoctorMessagesThreadsData, ThrowOnError>): RequestResult<PostApiDoctorMessagesThreadsResponses, PostApiDoctorMessagesThreadsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDoctorMessagesThreadsResponses, PostApiDoctorMessagesThreadsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get the doctor chat thread for a lab visit with its messages
     *
     * Answers only the thread's owner, so staff need an impersonation token. The owner's own token reading the thread moves its read marker, which is what the customer's unread card and the backoffice read receipt use. Staff reads never move it.
     */
    public static getApiDoctorMessagesThreadsByLabVisitByLabVisitId<ThrowOnError extends boolean = false>(options: Options<GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdData, ThrowOnError>): RequestResult<GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdResponses, GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdResponses, GetApiDoctorMessagesThreadsByLabVisitByLabVisitIdErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads/by-lab-visit/{labVisitId}',
            ...options
        });
    }
    
    /**
     * Send a follow-up message as the customer
     *
     * Only the thread owner, and only while the thread is open. While a doctor has it closed, customers cannot write.
     */
    public static postApiDoctorMessagesThreadsByIdMessages<ThrowOnError extends boolean = false>(options: Options<PostApiDoctorMessagesThreadsByIdMessagesData, ThrowOnError>): RequestResult<PostApiDoctorMessagesThreadsByIdMessagesResponses, PostApiDoctorMessagesThreadsByIdMessagesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDoctorMessagesThreadsByIdMessagesResponses, PostApiDoctorMessagesThreadsByIdMessagesErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads/{id}/messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reply as clinical staff, optionally closing the thread
     *
     * Appends a doctor message; when close is true the thread is also closed, which stops the customer from writing follow-ups. Requires an impersonation token for the thread's patient.
     */
    public static postApiDoctorMessagesThreadsByIdReply<ThrowOnError extends boolean = false>(options: Options<PostApiDoctorMessagesThreadsByIdReplyData, ThrowOnError>): RequestResult<PostApiDoctorMessagesThreadsByIdReplyResponses, PostApiDoctorMessagesThreadsByIdReplyErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDoctorMessagesThreadsByIdReplyResponses, PostApiDoctorMessagesThreadsByIdReplyErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads/{id}/reply',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get the pre-generated reply draft for a thread
     *
     * Returns the draft prepared for the customer's latest unanswered message, plus whether a draft is being generated right now. `status` is `ready` when a stored draft answers the latest message, `pending` while a generation job is queued or running, and `none` otherwise. `answerable` is false once the doctor wrote last or the thread closed. Requires an impersonation token for the thread's patient.
     */
    public static getApiDoctorMessagesThreadsByIdReplySuggestion<ThrowOnError extends boolean = false>(options: Options<GetApiDoctorMessagesThreadsByIdReplySuggestionData, ThrowOnError>): RequestResult<GetApiDoctorMessagesThreadsByIdReplySuggestionResponses, GetApiDoctorMessagesThreadsByIdReplySuggestionErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiDoctorMessagesThreadsByIdReplySuggestionResponses, GetApiDoctorMessagesThreadsByIdReplySuggestionErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads/{id}/reply-suggestion',
            ...options
        });
    }
    
    /**
     * Queue a fresh doctor reply draft
     *
     * Enqueues the generation job and answers 202; poll the GET for `status`. The customer's own message already queues this automatically, so this is for a missing draft (an older thread) or a deliberate refresh. Requires an impersonation token for the thread's patient; 409 when the thread is closed or the customer has nothing unanswered.
     */
    public static postApiDoctorMessagesThreadsByIdReplySuggestion<ThrowOnError extends boolean = false>(options: Options<PostApiDoctorMessagesThreadsByIdReplySuggestionData, ThrowOnError>): RequestResult<PostApiDoctorMessagesThreadsByIdReplySuggestionResponses, PostApiDoctorMessagesThreadsByIdReplySuggestionErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDoctorMessagesThreadsByIdReplySuggestionResponses, PostApiDoctorMessagesThreadsByIdReplySuggestionErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads/{id}/reply-suggestion',
            ...options
        });
    }
    
    /**
     * Close or reopen a thread as clinical staff, without a message
     *
     * Closing stops the customer from writing follow-ups; reopening lets them write again. Sends nothing to the customer. Requires an impersonation token for the thread's patient.
     */
    public static postApiDoctorMessagesThreadsByIdStatus<ThrowOnError extends boolean = false>(options: Options<PostApiDoctorMessagesThreadsByIdStatusData, ThrowOnError>): RequestResult<PostApiDoctorMessagesThreadsByIdStatusResponses, PostApiDoctorMessagesThreadsByIdStatusErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiDoctorMessagesThreadsByIdStatusResponses, PostApiDoctorMessagesThreadsByIdStatusErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/doctor-messages/threads/{id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class FeatureFlagsService {
    /**
     * List feature-flags
     */
    public static getApiFeatureFlags<ThrowOnError extends boolean = false>(options?: Options<GetApiFeatureFlagsData, ThrowOnError>): RequestResult<GetApiFeatureFlagsResponses, GetApiFeatureFlagsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiFeatureFlagsResponses, GetApiFeatureFlagsErrors, ThrowOnError>({ url: '/api/feature-flags', ...options });
    }
    
    /**
     * Create FeatureFlag
     */
    public static postApiFeatureFlags<ThrowOnError extends boolean = false>(options: Options<PostApiFeatureFlagsData, ThrowOnError>): RequestResult<PostApiFeatureFlagsResponses, PostApiFeatureFlagsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiFeatureFlagsResponses, PostApiFeatureFlagsErrors, ThrowOnError>({
            url: '/api/feature-flags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete FeatureFlag
     */
    public static deleteApiFeatureFlagsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiFeatureFlagsByIdData, ThrowOnError>): RequestResult<DeleteApiFeatureFlagsByIdResponses, DeleteApiFeatureFlagsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiFeatureFlagsByIdResponses, DeleteApiFeatureFlagsByIdErrors, ThrowOnError>({ url: '/api/feature-flags/{id}', ...options });
    }
    
    /**
     * Get FeatureFlag by ID
     */
    public static getApiFeatureFlagsById<ThrowOnError extends boolean = false>(options: Options<GetApiFeatureFlagsByIdData, ThrowOnError>): RequestResult<GetApiFeatureFlagsByIdResponses, GetApiFeatureFlagsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiFeatureFlagsByIdResponses, GetApiFeatureFlagsByIdErrors, ThrowOnError>({ url: '/api/feature-flags/{id}', ...options });
    }
    
    /**
     * Update FeatureFlag
     */
    public static putApiFeatureFlagsById<ThrowOnError extends boolean = false>(options: Options<PutApiFeatureFlagsByIdData, ThrowOnError>): RequestResult<PutApiFeatureFlagsByIdResponses, PutApiFeatureFlagsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiFeatureFlagsByIdResponses, PutApiFeatureFlagsByIdErrors, ThrowOnError>({
            url: '/api/feature-flags/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class FeedbackService {
    /**
     * List feedback
     */
    public static getApiFeedback<ThrowOnError extends boolean = false>(options?: Options<GetApiFeedbackData, ThrowOnError>): RequestResult<GetApiFeedbackResponses, GetApiFeedbackErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiFeedbackResponses, GetApiFeedbackErrors, ThrowOnError>({ url: '/api/feedback', ...options });
    }
    
    /**
     * Create Feedback
     */
    public static postApiFeedback<ThrowOnError extends boolean = false>(options: Options<PostApiFeedbackData, ThrowOnError>): RequestResult<PostApiFeedbackResponses, PostApiFeedbackErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiFeedbackResponses, PostApiFeedbackErrors, ThrowOnError>({
            url: '/api/feedback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Feedback
     */
    public static deleteApiFeedbackById<ThrowOnError extends boolean = false>(options: Options<DeleteApiFeedbackByIdData, ThrowOnError>): RequestResult<DeleteApiFeedbackByIdResponses, DeleteApiFeedbackByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiFeedbackByIdResponses, DeleteApiFeedbackByIdErrors, ThrowOnError>({ url: '/api/feedback/{id}', ...options });
    }
    
    /**
     * Get Feedback by ID
     */
    public static getApiFeedbackById<ThrowOnError extends boolean = false>(options: Options<GetApiFeedbackByIdData, ThrowOnError>): RequestResult<GetApiFeedbackByIdResponses, GetApiFeedbackByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiFeedbackByIdResponses, GetApiFeedbackByIdErrors, ThrowOnError>({ url: '/api/feedback/{id}', ...options });
    }
    
    /**
     * Update Feedback
     */
    public static putApiFeedbackById<ThrowOnError extends boolean = false>(options: Options<PutApiFeedbackByIdData, ThrowOnError>): RequestResult<PutApiFeedbackByIdResponses, PutApiFeedbackByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiFeedbackByIdResponses, PutApiFeedbackByIdErrors, ThrowOnError>({
            url: '/api/feedback/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class WearablesService {
    /**
     * List garmin-body-battery-samples
     */
    public static getApiGarminBodyBatterySamples<ThrowOnError extends boolean = false>(options?: Options<GetApiGarminBodyBatterySamplesData, ThrowOnError>): RequestResult<GetApiGarminBodyBatterySamplesResponses, GetApiGarminBodyBatterySamplesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiGarminBodyBatterySamplesResponses, GetApiGarminBodyBatterySamplesErrors, ThrowOnError>({ url: '/api/garmin-body-battery-samples', ...options });
    }
    
    /**
     * Create GarminBodyBatterySample
     */
    public static postApiGarminBodyBatterySamples<ThrowOnError extends boolean = false>(options: Options<PostApiGarminBodyBatterySamplesData, ThrowOnError>): RequestResult<PostApiGarminBodyBatterySamplesResponses, PostApiGarminBodyBatterySamplesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiGarminBodyBatterySamplesResponses, PostApiGarminBodyBatterySamplesErrors, ThrowOnError>({
            url: '/api/garmin-body-battery-samples',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete GarminBodyBatterySample
     */
    public static deleteApiGarminBodyBatterySamplesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiGarminBodyBatterySamplesByIdData, ThrowOnError>): RequestResult<DeleteApiGarminBodyBatterySamplesByIdResponses, DeleteApiGarminBodyBatterySamplesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiGarminBodyBatterySamplesByIdResponses, DeleteApiGarminBodyBatterySamplesByIdErrors, ThrowOnError>({ url: '/api/garmin-body-battery-samples/{id}', ...options });
    }
    
    /**
     * Get GarminBodyBatterySample by ID
     */
    public static getApiGarminBodyBatterySamplesById<ThrowOnError extends boolean = false>(options: Options<GetApiGarminBodyBatterySamplesByIdData, ThrowOnError>): RequestResult<GetApiGarminBodyBatterySamplesByIdResponses, GetApiGarminBodyBatterySamplesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiGarminBodyBatterySamplesByIdResponses, GetApiGarminBodyBatterySamplesByIdErrors, ThrowOnError>({ url: '/api/garmin-body-battery-samples/{id}', ...options });
    }
    
    /**
     * Update GarminBodyBatterySample
     */
    public static putApiGarminBodyBatterySamplesById<ThrowOnError extends boolean = false>(options: Options<PutApiGarminBodyBatterySamplesByIdData, ThrowOnError>): RequestResult<PutApiGarminBodyBatterySamplesByIdResponses, PutApiGarminBodyBatterySamplesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiGarminBodyBatterySamplesByIdResponses, PutApiGarminBodyBatterySamplesByIdErrors, ThrowOnError>({
            url: '/api/garmin-body-battery-samples/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List garmin-connections
     *
     * The caller's own Garmin connection, or every connection for admins. The OAuth tokens are never returned.
     */
    public static getApiGarminConnections<ThrowOnError extends boolean = false>(options?: Options<GetApiGarminConnectionsData, ThrowOnError>): RequestResult<GetApiGarminConnectionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiGarminConnectionsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/garmin-connections',
            ...options
        });
    }
    
    /**
     * List garmin-daily-snapshots
     */
    public static getApiGarminDailySnapshots<ThrowOnError extends boolean = false>(options?: Options<GetApiGarminDailySnapshotsData, ThrowOnError>): RequestResult<GetApiGarminDailySnapshotsResponses, GetApiGarminDailySnapshotsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiGarminDailySnapshotsResponses, GetApiGarminDailySnapshotsErrors, ThrowOnError>({ url: '/api/garmin-daily-snapshots', ...options });
    }
    
    /**
     * Create GarminDailySnapshot
     */
    public static postApiGarminDailySnapshots<ThrowOnError extends boolean = false>(options: Options<PostApiGarminDailySnapshotsData, ThrowOnError>): RequestResult<PostApiGarminDailySnapshotsResponses, PostApiGarminDailySnapshotsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiGarminDailySnapshotsResponses, PostApiGarminDailySnapshotsErrors, ThrowOnError>({
            url: '/api/garmin-daily-snapshots',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete GarminDailySnapshot
     */
    public static deleteApiGarminDailySnapshotsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiGarminDailySnapshotsByIdData, ThrowOnError>): RequestResult<DeleteApiGarminDailySnapshotsByIdResponses, DeleteApiGarminDailySnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiGarminDailySnapshotsByIdResponses, DeleteApiGarminDailySnapshotsByIdErrors, ThrowOnError>({ url: '/api/garmin-daily-snapshots/{id}', ...options });
    }
    
    /**
     * Get GarminDailySnapshot by ID
     */
    public static getApiGarminDailySnapshotsById<ThrowOnError extends boolean = false>(options: Options<GetApiGarminDailySnapshotsByIdData, ThrowOnError>): RequestResult<GetApiGarminDailySnapshotsByIdResponses, GetApiGarminDailySnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiGarminDailySnapshotsByIdResponses, GetApiGarminDailySnapshotsByIdErrors, ThrowOnError>({ url: '/api/garmin-daily-snapshots/{id}', ...options });
    }
    
    /**
     * Update GarminDailySnapshot
     */
    public static putApiGarminDailySnapshotsById<ThrowOnError extends boolean = false>(options: Options<PutApiGarminDailySnapshotsByIdData, ThrowOnError>): RequestResult<PutApiGarminDailySnapshotsByIdResponses, PutApiGarminDailySnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiGarminDailySnapshotsByIdResponses, PutApiGarminDailySnapshotsByIdErrors, ThrowOnError>({
            url: '/api/garmin-daily-snapshots/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List health-daily-snapshots
     */
    public static getApiHealthDailySnapshots<ThrowOnError extends boolean = false>(options?: Options<GetApiHealthDailySnapshotsData, ThrowOnError>): RequestResult<GetApiHealthDailySnapshotsResponses, GetApiHealthDailySnapshotsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiHealthDailySnapshotsResponses, GetApiHealthDailySnapshotsErrors, ThrowOnError>({ url: '/api/health-daily-snapshots', ...options });
    }
    
    /**
     * Create HealthDailySnapshot
     */
    public static postApiHealthDailySnapshots<ThrowOnError extends boolean = false>(options: Options<PostApiHealthDailySnapshotsData, ThrowOnError>): RequestResult<PostApiHealthDailySnapshotsResponses, PostApiHealthDailySnapshotsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiHealthDailySnapshotsResponses, PostApiHealthDailySnapshotsErrors, ThrowOnError>({
            url: '/api/health-daily-snapshots',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete HealthDailySnapshot
     */
    public static deleteApiHealthDailySnapshotsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiHealthDailySnapshotsByIdData, ThrowOnError>): RequestResult<DeleteApiHealthDailySnapshotsByIdResponses, DeleteApiHealthDailySnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiHealthDailySnapshotsByIdResponses, DeleteApiHealthDailySnapshotsByIdErrors, ThrowOnError>({ url: '/api/health-daily-snapshots/{id}', ...options });
    }
    
    /**
     * Get HealthDailySnapshot by ID
     */
    public static getApiHealthDailySnapshotsById<ThrowOnError extends boolean = false>(options: Options<GetApiHealthDailySnapshotsByIdData, ThrowOnError>): RequestResult<GetApiHealthDailySnapshotsByIdResponses, GetApiHealthDailySnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiHealthDailySnapshotsByIdResponses, GetApiHealthDailySnapshotsByIdErrors, ThrowOnError>({ url: '/api/health-daily-snapshots/{id}', ...options });
    }
    
    /**
     * Update HealthDailySnapshot
     */
    public static putApiHealthDailySnapshotsById<ThrowOnError extends boolean = false>(options: Options<PutApiHealthDailySnapshotsByIdData, ThrowOnError>): RequestResult<PutApiHealthDailySnapshotsByIdResponses, PutApiHealthDailySnapshotsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiHealthDailySnapshotsByIdResponses, PutApiHealthDailySnapshotsByIdErrors, ThrowOnError>({
            url: '/api/health-daily-snapshots/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List wearable-source-preferences
     */
    public static getApiWearableSourcePreferences<ThrowOnError extends boolean = false>(options?: Options<GetApiWearableSourcePreferencesData, ThrowOnError>): RequestResult<GetApiWearableSourcePreferencesResponses, GetApiWearableSourcePreferencesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiWearableSourcePreferencesResponses, GetApiWearableSourcePreferencesErrors, ThrowOnError>({ url: '/api/wearable-source-preferences', ...options });
    }
    
    /**
     * Create WearableSourcePreference
     */
    public static postApiWearableSourcePreferences<ThrowOnError extends boolean = false>(options: Options<PostApiWearableSourcePreferencesData, ThrowOnError>): RequestResult<PostApiWearableSourcePreferencesResponses, PostApiWearableSourcePreferencesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiWearableSourcePreferencesResponses, PostApiWearableSourcePreferencesErrors, ThrowOnError>({
            url: '/api/wearable-source-preferences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete WearableSourcePreference
     */
    public static deleteApiWearableSourcePreferencesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiWearableSourcePreferencesByIdData, ThrowOnError>): RequestResult<DeleteApiWearableSourcePreferencesByIdResponses, DeleteApiWearableSourcePreferencesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiWearableSourcePreferencesByIdResponses, DeleteApiWearableSourcePreferencesByIdErrors, ThrowOnError>({ url: '/api/wearable-source-preferences/{id}', ...options });
    }
    
    /**
     * Get WearableSourcePreference by ID
     */
    public static getApiWearableSourcePreferencesById<ThrowOnError extends boolean = false>(options: Options<GetApiWearableSourcePreferencesByIdData, ThrowOnError>): RequestResult<GetApiWearableSourcePreferencesByIdResponses, GetApiWearableSourcePreferencesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiWearableSourcePreferencesByIdResponses, GetApiWearableSourcePreferencesByIdErrors, ThrowOnError>({ url: '/api/wearable-source-preferences/{id}', ...options });
    }
    
    /**
     * Update WearableSourcePreference
     */
    public static putApiWearableSourcePreferencesById<ThrowOnError extends boolean = false>(options: Options<PutApiWearableSourcePreferencesByIdData, ThrowOnError>): RequestResult<PutApiWearableSourcePreferencesByIdResponses, PutApiWearableSourcePreferencesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiWearableSourcePreferencesByIdResponses, PutApiWearableSourcePreferencesByIdErrors, ThrowOnError>({
            url: '/api/wearable-source-preferences/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upsert Apple Health daily snapshots
     *
     * Upserts daily health snapshots from Apple HealthKit
     */
    public static postApiWearablesAppleHealthSnapshots<ThrowOnError extends boolean = false>(options: Options<PostApiWearablesAppleHealthSnapshotsData, ThrowOnError>): RequestResult<PostApiWearablesAppleHealthSnapshotsResponses, PostApiWearablesAppleHealthSnapshotsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiWearablesAppleHealthSnapshotsResponses, PostApiWearablesAppleHealthSnapshotsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/apple-health/snapshots',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete health data by source
     *
     * Deletes all stored health snapshots for the given source. For Garmin, also deletes body battery samples and raw webhook data. For Health Connect, also deletes sync diagnostics.
     */
    public static deleteApiWearablesData<ThrowOnError extends boolean = false>(options: Options<DeleteApiWearablesDataData, ThrowOnError>): RequestResult<DeleteApiWearablesDataResponses, DeleteApiWearablesDataErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiWearablesDataResponses, DeleteApiWearablesDataErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/data',
            ...options
        });
    }
    
    /**
     * Batch Garmin backfill (admin)
     *
     * Enqueues backfill jobs for multiple users. Each job handles token refresh and backfill in the background. Skips users without a connection or with expired refresh tokens. Returns immediately.
     */
    public static postApiWearablesGarminBackfill<ThrowOnError extends boolean = false>(options: Options<PostApiWearablesGarminBackfillData, ThrowOnError>): RequestResult<PostApiWearablesGarminBackfillResponses, PostApiWearablesGarminBackfillErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiWearablesGarminBackfillResponses, PostApiWearablesGarminBackfillErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/garmin/backfill',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Garmin OAuth2 callback
     *
     * Exchanges the authorization code for tokens, stores the connection, and redirects to amino://settings/garmin.
     */
    public static getApiWearablesGarminCallback<ThrowOnError extends boolean = false>(options?: Options<GetApiWearablesGarminCallbackData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/wearables/garmin/callback', ...options });
    }
    
    /**
     * Disconnect Garmin account
     *
     * Deregisters the user from Garmin and removes the stored connection.
     */
    public static deleteApiWearablesGarminDisconnect<ThrowOnError extends boolean = false>(options?: Options<DeleteApiWearablesGarminDisconnectData, ThrowOnError>): RequestResult<DeleteApiWearablesGarminDisconnectResponses, DeleteApiWearablesGarminDisconnectErrors, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteApiWearablesGarminDisconnectResponses, DeleteApiWearablesGarminDisconnectErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/garmin/disconnect',
            ...options
        });
    }
    
    /**
     * Start Garmin OAuth2 flow
     *
     * Returns a Garmin authorization URL. The frontend should open this URL in a browser or webview for the user to authorize. Pass `returnPath` (e.g. `/amino_age`) to control where the user lands after connecting.
     */
    public static postApiWearablesGarminLogin<ThrowOnError extends boolean = false>(options: Options<PostApiWearablesGarminLoginData, ThrowOnError>): RequestResult<PostApiWearablesGarminLoginResponses, PostApiWearablesGarminLoginErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiWearablesGarminLoginResponses, PostApiWearablesGarminLoginErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/garmin/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Refresh Garmin access token
     *
     * Refreshes the Garmin access token. Returns 410 if the refresh token has expired (user must reconnect).
     */
    public static postApiWearablesGarminRefresh<ThrowOnError extends boolean = false>(options?: Options<PostApiWearablesGarminRefreshData, ThrowOnError>): RequestResult<PostApiWearablesGarminRefreshResponses, PostApiWearablesGarminRefreshErrors, ThrowOnError> {
        return (options?.client ?? client).post<PostApiWearablesGarminRefreshResponses, PostApiWearablesGarminRefreshErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/garmin/refresh',
            ...options
        });
    }
    
    /**
     * Get Garmin connection status
     *
     * Returns the current user's Garmin connection status and metadata.
     */
    public static getApiWearablesGarminStatus<ThrowOnError extends boolean = false>(options?: Options<GetApiWearablesGarminStatusData, ThrowOnError>): RequestResult<GetApiWearablesGarminStatusResponses, GetApiWearablesGarminStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiWearablesGarminStatusResponses, GetApiWearablesGarminStatusErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/garmin/status',
            ...options
        });
    }
    
    /**
     * Garmin webhook receiver
     *
     * Receives push data from Garmin and stores as raw data for background processing. In production, only accepts requests from Garmin IP ranges.
     */
    public static postApiWearablesGarminWebhook<ThrowOnError extends boolean = false>(options: Options<PostApiWearablesGarminWebhookData, ThrowOnError>): RequestResult<PostApiWearablesGarminWebhookResponses, PostApiWearablesGarminWebhookErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiWearablesGarminWebhookResponses, PostApiWearablesGarminWebhookErrors, ThrowOnError>({
            url: '/api/wearables/garmin/webhook',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upsert Health Connect daily snapshots
     *
     * Upserts daily health snapshots from Google Health Connect
     */
    public static postApiWearablesHealthConnectSnapshots<ThrowOnError extends boolean = false>(options: Options<PostApiWearablesHealthConnectSnapshotsData, ThrowOnError>): RequestResult<PostApiWearablesHealthConnectSnapshotsResponses, PostApiWearablesHealthConnectSnapshotsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiWearablesHealthConnectSnapshotsResponses, PostApiWearablesHealthConnectSnapshotsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/health-connect/snapshots',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get per-metric merged health snapshots
     *
     * Returns daily health snapshots honoring saved per-metric platform or app/device preferences, with fallback and actual field sources. Automatic preserves the existing merge rules. Sleep phases remain from one source.
     */
    public static getApiWearablesPreferredSnapshots<ThrowOnError extends boolean = false>(options?: Options<GetApiWearablesPreferredSnapshotsData, ThrowOnError>): RequestResult<GetApiWearablesPreferredSnapshotsResponses, GetApiWearablesPreferredSnapshotsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiWearablesPreferredSnapshotsResponses, GetApiWearablesPreferredSnapshotsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/preferred-snapshots',
            ...options
        });
    }
    
    /**
     * List available health sources per metric
     */
    public static getApiWearablesSourceOptions<ThrowOnError extends boolean = false>(options?: Options<GetApiWearablesSourceOptionsData, ThrowOnError>): RequestResult<GetApiWearablesSourceOptionsResponses, GetApiWearablesSourceOptionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiWearablesSourceOptionsResponses, GetApiWearablesSourceOptionsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/source-options',
            ...options
        });
    }
    
    /**
     * Check own preferred-source recalculation
     */
    public static getApiWearablesSourceRefreshStatus<ThrowOnError extends boolean = false>(options?: Options<GetApiWearablesSourceRefreshStatusData, ThrowOnError>): RequestResult<GetApiWearablesSourceRefreshStatusResponses, GetApiWearablesSourceRefreshStatusErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiWearablesSourceRefreshStatusResponses, GetApiWearablesSourceRefreshStatusErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/source-refresh-status',
            ...options
        });
    }
    
    /**
     * Get authenticated health-sync account
     */
    public static getApiWearablesSyncAccount<ThrowOnError extends boolean = false>(options?: Options<GetApiWearablesSyncAccountData, ThrowOnError>): RequestResult<GetApiWearablesSyncAccountResponses, GetApiWearablesSyncAccountErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiWearablesSyncAccountResponses, GetApiWearablesSyncAccountErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/wearables/sync-account',
            ...options
        });
    }
}

export class AccountsService {
    /**
     * List internal-user-comments
     */
    public static getApiInternalUserComments<ThrowOnError extends boolean = false>(options?: Options<GetApiInternalUserCommentsData, ThrowOnError>): RequestResult<GetApiInternalUserCommentsResponses, GetApiInternalUserCommentsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiInternalUserCommentsResponses, GetApiInternalUserCommentsErrors, ThrowOnError>({ url: '/api/internal-user-comments', ...options });
    }
    
    /**
     * Create InternalUserComment
     */
    public static postApiInternalUserComments<ThrowOnError extends boolean = false>(options: Options<PostApiInternalUserCommentsData, ThrowOnError>): RequestResult<PostApiInternalUserCommentsResponses, PostApiInternalUserCommentsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiInternalUserCommentsResponses, PostApiInternalUserCommentsErrors, ThrowOnError>({
            url: '/api/internal-user-comments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete InternalUserComment
     */
    public static deleteApiInternalUserCommentsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiInternalUserCommentsByIdData, ThrowOnError>): RequestResult<DeleteApiInternalUserCommentsByIdResponses, DeleteApiInternalUserCommentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiInternalUserCommentsByIdResponses, DeleteApiInternalUserCommentsByIdErrors, ThrowOnError>({ url: '/api/internal-user-comments/{id}', ...options });
    }
    
    /**
     * Get InternalUserComment by ID
     */
    public static getApiInternalUserCommentsById<ThrowOnError extends boolean = false>(options: Options<GetApiInternalUserCommentsByIdData, ThrowOnError>): RequestResult<GetApiInternalUserCommentsByIdResponses, GetApiInternalUserCommentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiInternalUserCommentsByIdResponses, GetApiInternalUserCommentsByIdErrors, ThrowOnError>({ url: '/api/internal-user-comments/{id}', ...options });
    }
    
    /**
     * Update InternalUserComment
     */
    public static putApiInternalUserCommentsById<ThrowOnError extends boolean = false>(options: Options<PutApiInternalUserCommentsByIdData, ThrowOnError>): RequestResult<PutApiInternalUserCommentsByIdResponses, PutApiInternalUserCommentsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiInternalUserCommentsByIdResponses, PutApiInternalUserCommentsByIdErrors, ThrowOnError>({
            url: '/api/internal-user-comments/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List journal-notes
     */
    public static getApiJournalNotes<ThrowOnError extends boolean = false>(options?: Options<GetApiJournalNotesData, ThrowOnError>): RequestResult<GetApiJournalNotesResponses, GetApiJournalNotesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiJournalNotesResponses, GetApiJournalNotesErrors, ThrowOnError>({ url: '/api/journal-notes', ...options });
    }
    
    /**
     * Create JournalNote
     */
    public static postApiJournalNotes<ThrowOnError extends boolean = false>(options: Options<PostApiJournalNotesData, ThrowOnError>): RequestResult<PostApiJournalNotesResponses, PostApiJournalNotesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiJournalNotesResponses, PostApiJournalNotesErrors, ThrowOnError>({
            url: '/api/journal-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete JournalNote
     */
    public static deleteApiJournalNotesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiJournalNotesByIdData, ThrowOnError>): RequestResult<DeleteApiJournalNotesByIdResponses, DeleteApiJournalNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiJournalNotesByIdResponses, DeleteApiJournalNotesByIdErrors, ThrowOnError>({ url: '/api/journal-notes/{id}', ...options });
    }
    
    /**
     * Get JournalNote by ID
     */
    public static getApiJournalNotesById<ThrowOnError extends boolean = false>(options: Options<GetApiJournalNotesByIdData, ThrowOnError>): RequestResult<GetApiJournalNotesByIdResponses, GetApiJournalNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiJournalNotesByIdResponses, GetApiJournalNotesByIdErrors, ThrowOnError>({ url: '/api/journal-notes/{id}', ...options });
    }
    
    /**
     * Update JournalNote
     */
    public static putApiJournalNotesById<ThrowOnError extends boolean = false>(options: Options<PutApiJournalNotesByIdData, ThrowOnError>): RequestResult<PutApiJournalNotesByIdResponses, PutApiJournalNotesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiJournalNotesByIdResponses, PutApiJournalNotesByIdErrors, ThrowOnError>({
            url: '/api/journal-notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List user-device-push-tokens
     */
    public static getApiUserDevicePushTokens<ThrowOnError extends boolean = false>(options?: Options<GetApiUserDevicePushTokensData, ThrowOnError>): RequestResult<GetApiUserDevicePushTokensResponses, GetApiUserDevicePushTokensErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUserDevicePushTokensResponses, GetApiUserDevicePushTokensErrors, ThrowOnError>({ url: '/api/user-device-push-tokens', ...options });
    }
    
    /**
     * Create UserDevicePushToken
     */
    public static postApiUserDevicePushTokens<ThrowOnError extends boolean = false>(options: Options<PostApiUserDevicePushTokensData, ThrowOnError>): RequestResult<PostApiUserDevicePushTokensResponses, PostApiUserDevicePushTokensErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserDevicePushTokensResponses, PostApiUserDevicePushTokensErrors, ThrowOnError>({
            url: '/api/user-device-push-tokens',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UserDevicePushToken
     */
    public static deleteApiUserDevicePushTokensById<ThrowOnError extends boolean = false>(options: Options<DeleteApiUserDevicePushTokensByIdData, ThrowOnError>): RequestResult<DeleteApiUserDevicePushTokensByIdResponses, DeleteApiUserDevicePushTokensByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiUserDevicePushTokensByIdResponses, DeleteApiUserDevicePushTokensByIdErrors, ThrowOnError>({ url: '/api/user-device-push-tokens/{id}', ...options });
    }
    
    /**
     * Get UserDevicePushToken by ID
     */
    public static getApiUserDevicePushTokensById<ThrowOnError extends boolean = false>(options: Options<GetApiUserDevicePushTokensByIdData, ThrowOnError>): RequestResult<GetApiUserDevicePushTokensByIdResponses, GetApiUserDevicePushTokensByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiUserDevicePushTokensByIdResponses, GetApiUserDevicePushTokensByIdErrors, ThrowOnError>({ url: '/api/user-device-push-tokens/{id}', ...options });
    }
    
    /**
     * Update UserDevicePushToken
     */
    public static putApiUserDevicePushTokensById<ThrowOnError extends boolean = false>(options: Options<PutApiUserDevicePushTokensByIdData, ThrowOnError>): RequestResult<PutApiUserDevicePushTokensByIdResponses, PutApiUserDevicePushTokensByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiUserDevicePushTokensByIdResponses, PutApiUserDevicePushTokensByIdErrors, ThrowOnError>({
            url: '/api/user-device-push-tokens/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List user-feature-flags
     */
    public static getApiUserFeatureFlags<ThrowOnError extends boolean = false>(options?: Options<GetApiUserFeatureFlagsData, ThrowOnError>): RequestResult<GetApiUserFeatureFlagsResponses, GetApiUserFeatureFlagsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUserFeatureFlagsResponses, GetApiUserFeatureFlagsErrors, ThrowOnError>({ url: '/api/user-feature-flags', ...options });
    }
    
    /**
     * Create UserFeatureFlag
     */
    public static postApiUserFeatureFlags<ThrowOnError extends boolean = false>(options: Options<PostApiUserFeatureFlagsData, ThrowOnError>): RequestResult<PostApiUserFeatureFlagsResponses, PostApiUserFeatureFlagsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserFeatureFlagsResponses, PostApiUserFeatureFlagsErrors, ThrowOnError>({
            url: '/api/user-feature-flags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UserFeatureFlag
     */
    public static deleteApiUserFeatureFlagsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiUserFeatureFlagsByIdData, ThrowOnError>): RequestResult<DeleteApiUserFeatureFlagsByIdResponses, DeleteApiUserFeatureFlagsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiUserFeatureFlagsByIdResponses, DeleteApiUserFeatureFlagsByIdErrors, ThrowOnError>({ url: '/api/user-feature-flags/{id}', ...options });
    }
    
    /**
     * Get UserFeatureFlag by ID
     */
    public static getApiUserFeatureFlagsById<ThrowOnError extends boolean = false>(options: Options<GetApiUserFeatureFlagsByIdData, ThrowOnError>): RequestResult<GetApiUserFeatureFlagsByIdResponses, GetApiUserFeatureFlagsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiUserFeatureFlagsByIdResponses, GetApiUserFeatureFlagsByIdErrors, ThrowOnError>({ url: '/api/user-feature-flags/{id}', ...options });
    }
    
    /**
     * Update UserFeatureFlag
     */
    public static putApiUserFeatureFlagsById<ThrowOnError extends boolean = false>(options: Options<PutApiUserFeatureFlagsByIdData, ThrowOnError>): RequestResult<PutApiUserFeatureFlagsByIdResponses, PutApiUserFeatureFlagsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiUserFeatureFlagsByIdResponses, PutApiUserFeatureFlagsByIdErrors, ThrowOnError>({
            url: '/api/user-feature-flags/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List user-plan-action-progress
     */
    public static getApiUserPlanActionProgress<ThrowOnError extends boolean = false>(options?: Options<GetApiUserPlanActionProgressData, ThrowOnError>): RequestResult<GetApiUserPlanActionProgressResponses, GetApiUserPlanActionProgressErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUserPlanActionProgressResponses, GetApiUserPlanActionProgressErrors, ThrowOnError>({ url: '/api/user-plan-action-progress', ...options });
    }
    
    /**
     * Create UserPlanActionProgress
     */
    public static postApiUserPlanActionProgress<ThrowOnError extends boolean = false>(options: Options<PostApiUserPlanActionProgressData, ThrowOnError>): RequestResult<PostApiUserPlanActionProgressResponses, PostApiUserPlanActionProgressErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserPlanActionProgressResponses, PostApiUserPlanActionProgressErrors, ThrowOnError>({
            url: '/api/user-plan-action-progress',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UserPlanActionProgress
     */
    public static deleteApiUserPlanActionProgressById<ThrowOnError extends boolean = false>(options: Options<DeleteApiUserPlanActionProgressByIdData, ThrowOnError>): RequestResult<DeleteApiUserPlanActionProgressByIdResponses, DeleteApiUserPlanActionProgressByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiUserPlanActionProgressByIdResponses, DeleteApiUserPlanActionProgressByIdErrors, ThrowOnError>({ url: '/api/user-plan-action-progress/{id}', ...options });
    }
    
    /**
     * Get UserPlanActionProgress by ID
     */
    public static getApiUserPlanActionProgressById<ThrowOnError extends boolean = false>(options: Options<GetApiUserPlanActionProgressByIdData, ThrowOnError>): RequestResult<GetApiUserPlanActionProgressByIdResponses, GetApiUserPlanActionProgressByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiUserPlanActionProgressByIdResponses, GetApiUserPlanActionProgressByIdErrors, ThrowOnError>({ url: '/api/user-plan-action-progress/{id}', ...options });
    }
    
    /**
     * Update UserPlanActionProgress
     */
    public static putApiUserPlanActionProgressById<ThrowOnError extends boolean = false>(options: Options<PutApiUserPlanActionProgressByIdData, ThrowOnError>): RequestResult<PutApiUserPlanActionProgressByIdResponses, PutApiUserPlanActionProgressByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiUserPlanActionProgressByIdResponses, PutApiUserPlanActionProgressByIdErrors, ThrowOnError>({
            url: '/api/user-plan-action-progress/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List user-plan-actions
     */
    public static getApiUserPlanActions<ThrowOnError extends boolean = false>(options?: Options<GetApiUserPlanActionsData, ThrowOnError>): RequestResult<GetApiUserPlanActionsResponses, GetApiUserPlanActionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUserPlanActionsResponses, GetApiUserPlanActionsErrors, ThrowOnError>({ url: '/api/user-plan-actions', ...options });
    }
    
    /**
     * Create UserPlanAction
     */
    public static postApiUserPlanActions<ThrowOnError extends boolean = false>(options: Options<PostApiUserPlanActionsData, ThrowOnError>): RequestResult<PostApiUserPlanActionsResponses, PostApiUserPlanActionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserPlanActionsResponses, PostApiUserPlanActionsErrors, ThrowOnError>({
            url: '/api/user-plan-actions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UserPlanAction
     */
    public static deleteApiUserPlanActionsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiUserPlanActionsByIdData, ThrowOnError>): RequestResult<DeleteApiUserPlanActionsByIdResponses, DeleteApiUserPlanActionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiUserPlanActionsByIdResponses, DeleteApiUserPlanActionsByIdErrors, ThrowOnError>({ url: '/api/user-plan-actions/{id}', ...options });
    }
    
    /**
     * Get UserPlanAction by ID
     */
    public static getApiUserPlanActionsById<ThrowOnError extends boolean = false>(options: Options<GetApiUserPlanActionsByIdData, ThrowOnError>): RequestResult<GetApiUserPlanActionsByIdResponses, GetApiUserPlanActionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiUserPlanActionsByIdResponses, GetApiUserPlanActionsByIdErrors, ThrowOnError>({ url: '/api/user-plan-actions/{id}', ...options });
    }
    
    /**
     * Update UserPlanAction
     */
    public static putApiUserPlanActionsById<ThrowOnError extends boolean = false>(options: Options<PutApiUserPlanActionsByIdData, ThrowOnError>): RequestResult<PutApiUserPlanActionsByIdResponses, PutApiUserPlanActionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiUserPlanActionsByIdResponses, PutApiUserPlanActionsByIdErrors, ThrowOnError>({
            url: '/api/user-plan-actions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List user-profiles
     */
    public static getApiUserProfiles<ThrowOnError extends boolean = false>(options?: Options<GetApiUserProfilesData, ThrowOnError>): RequestResult<GetApiUserProfilesResponses, GetApiUserProfilesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUserProfilesResponses, GetApiUserProfilesErrors, ThrowOnError>({ url: '/api/user-profiles', ...options });
    }
    
    /**
     * Create UserProfile
     */
    public static postApiUserProfiles<ThrowOnError extends boolean = false>(options: Options<PostApiUserProfilesData, ThrowOnError>): RequestResult<PostApiUserProfilesResponses, PostApiUserProfilesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserProfilesResponses, PostApiUserProfilesErrors, ThrowOnError>({
            url: '/api/user-profiles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Submit consent for the authenticated user
     *
     * Updates the caller's consent fields, stamps consentDecidedAt server-side, and replays awaiting_consent conversion events when ad-tracking flips false → true.
     */
    public static postApiUserProfilesConsent<ThrowOnError extends boolean = false>(options: Options<PostApiUserProfilesConsentData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/user-profiles/consent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get the caller's email verification status
     *
     * Returns the caller's profile email, whether it has a verified contact_verifications row, and any pending (unexpired) email awaiting a code.
     */
    public static getApiUserProfilesEmailVerification<ThrowOnError extends boolean = false>(options?: Options<GetApiUserProfilesEmailVerificationData, ThrowOnError>): RequestResult<GetApiUserProfilesEmailVerificationResponses, GetApiUserProfilesEmailVerificationErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUserProfilesEmailVerificationResponses, GetApiUserProfilesEmailVerificationErrors, ThrowOnError>({ url: '/api/user-profiles/email/verification', ...options });
    }
    
    /**
     * Send a verification code to a new email
     *
     * Creates a pending email verification for the caller and sends the 6-digit code by Postmark HTML email. Rejects the caller's already-verified address and a resend within the cooldown.
     */
    public static postApiUserProfilesEmailVerification<ThrowOnError extends boolean = false>(options: Options<PostApiUserProfilesEmailVerificationData, ThrowOnError>): RequestResult<PostApiUserProfilesEmailVerificationResponses, PostApiUserProfilesEmailVerificationErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserProfilesEmailVerificationResponses, PostApiUserProfilesEmailVerificationErrors, ThrowOnError>({
            url: '/api/user-profiles/email/verification',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Confirm an email verification code
     *
     * Marks the pending code verified and moves the caller's profile email to the new address in one transaction.
     */
    public static postApiUserProfilesEmailVerificationConfirm<ThrowOnError extends boolean = false>(options: Options<PostApiUserProfilesEmailVerificationConfirmData, ThrowOnError>): RequestResult<PostApiUserProfilesEmailVerificationConfirmResponses, PostApiUserProfilesEmailVerificationConfirmErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserProfilesEmailVerificationConfirmResponses, PostApiUserProfilesEmailVerificationConfirmErrors, ThrowOnError>({
            url: '/api/user-profiles/email/verification/confirm',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UserProfile
     */
    public static deleteApiUserProfilesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiUserProfilesByIdData, ThrowOnError>): RequestResult<DeleteApiUserProfilesByIdResponses, DeleteApiUserProfilesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiUserProfilesByIdResponses, DeleteApiUserProfilesByIdErrors, ThrowOnError>({ url: '/api/user-profiles/{id}', ...options });
    }
    
    /**
     * Get UserProfile by ID
     */
    public static getApiUserProfilesById<ThrowOnError extends boolean = false>(options: Options<GetApiUserProfilesByIdData, ThrowOnError>): RequestResult<GetApiUserProfilesByIdResponses, GetApiUserProfilesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiUserProfilesByIdResponses, GetApiUserProfilesByIdErrors, ThrowOnError>({ url: '/api/user-profiles/{id}', ...options });
    }
    
    /**
     * Update UserProfile
     */
    public static putApiUserProfilesById<ThrowOnError extends boolean = false>(options: Options<PutApiUserProfilesByIdData, ThrowOnError>): RequestResult<PutApiUserProfilesByIdResponses, PutApiUserProfilesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiUserProfilesByIdResponses, PutApiUserProfilesByIdErrors, ThrowOnError>({
            url: '/api/user-profiles/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List user-ui-settings
     */
    public static getApiUserUiSettings<ThrowOnError extends boolean = false>(options?: Options<GetApiUserUiSettingsData, ThrowOnError>): RequestResult<GetApiUserUiSettingsResponses, GetApiUserUiSettingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiUserUiSettingsResponses, GetApiUserUiSettingsErrors, ThrowOnError>({ url: '/api/user-ui-settings', ...options });
    }
    
    /**
     * Create UserUiSetting
     */
    public static postApiUserUiSettings<ThrowOnError extends boolean = false>(options: Options<PostApiUserUiSettingsData, ThrowOnError>): RequestResult<PostApiUserUiSettingsResponses, PostApiUserUiSettingsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiUserUiSettingsResponses, PostApiUserUiSettingsErrors, ThrowOnError>({
            url: '/api/user-ui-settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete UserUiSetting
     */
    public static deleteApiUserUiSettingsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiUserUiSettingsByIdData, ThrowOnError>): RequestResult<DeleteApiUserUiSettingsByIdResponses, DeleteApiUserUiSettingsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiUserUiSettingsByIdResponses, DeleteApiUserUiSettingsByIdErrors, ThrowOnError>({ url: '/api/user-ui-settings/{id}', ...options });
    }
    
    /**
     * Get UserUiSetting by ID
     */
    public static getApiUserUiSettingsById<ThrowOnError extends boolean = false>(options: Options<GetApiUserUiSettingsByIdData, ThrowOnError>): RequestResult<GetApiUserUiSettingsByIdResponses, GetApiUserUiSettingsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiUserUiSettingsByIdResponses, GetApiUserUiSettingsByIdErrors, ThrowOnError>({ url: '/api/user-ui-settings/{id}', ...options });
    }
    
    /**
     * Update UserUiSetting
     */
    public static putApiUserUiSettingsById<ThrowOnError extends boolean = false>(options: Options<PutApiUserUiSettingsByIdData, ThrowOnError>): RequestResult<PutApiUserUiSettingsByIdResponses, PutApiUserUiSettingsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiUserUiSettingsByIdResponses, PutApiUserUiSettingsByIdErrors, ThrowOnError>({
            url: '/api/user-ui-settings/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class LabsService {
    /**
     * List lab-prices
     */
    public static getApiLabPrices<ThrowOnError extends boolean = false>(options?: Options<GetApiLabPricesData, ThrowOnError>): RequestResult<GetApiLabPricesResponses, GetApiLabPricesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiLabPricesResponses, GetApiLabPricesErrors, ThrowOnError>({ url: '/api/lab-prices', ...options });
    }
    
    /**
     * Create LabPrice
     */
    public static postApiLabPrices<ThrowOnError extends boolean = false>(options: Options<PostApiLabPricesData, ThrowOnError>): RequestResult<PostApiLabPricesResponses, PostApiLabPricesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiLabPricesResponses, PostApiLabPricesErrors, ThrowOnError>({
            url: '/api/lab-prices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete LabPrice
     */
    public static deleteApiLabPricesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiLabPricesByIdData, ThrowOnError>): RequestResult<DeleteApiLabPricesByIdResponses, DeleteApiLabPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiLabPricesByIdResponses, DeleteApiLabPricesByIdErrors, ThrowOnError>({ url: '/api/lab-prices/{id}', ...options });
    }
    
    /**
     * Get LabPrice by ID
     */
    public static getApiLabPricesById<ThrowOnError extends boolean = false>(options: Options<GetApiLabPricesByIdData, ThrowOnError>): RequestResult<GetApiLabPricesByIdResponses, GetApiLabPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiLabPricesByIdResponses, GetApiLabPricesByIdErrors, ThrowOnError>({ url: '/api/lab-prices/{id}', ...options });
    }
    
    /**
     * Update LabPrice
     */
    public static putApiLabPricesById<ThrowOnError extends boolean = false>(options: Options<PutApiLabPricesByIdData, ThrowOnError>): RequestResult<PutApiLabPricesByIdResponses, PutApiLabPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiLabPricesByIdResponses, PutApiLabPricesByIdErrors, ThrowOnError>({
            url: '/api/lab-prices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List labs
     */
    public static getApiLabs<ThrowOnError extends boolean = false>(options?: Options<GetApiLabsData, ThrowOnError>): RequestResult<GetApiLabsResponses, GetApiLabsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiLabsResponses, GetApiLabsErrors, ThrowOnError>({ url: '/api/labs', ...options });
    }
    
    /**
     * Create Lab
     */
    public static postApiLabs<ThrowOnError extends boolean = false>(options: Options<PostApiLabsData, ThrowOnError>): RequestResult<PostApiLabsResponses, PostApiLabsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiLabsResponses, PostApiLabsErrors, ThrowOnError>({
            url: '/api/labs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Lab
     */
    public static deleteApiLabsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiLabsByIdData, ThrowOnError>): RequestResult<DeleteApiLabsByIdResponses, DeleteApiLabsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiLabsByIdResponses, DeleteApiLabsByIdErrors, ThrowOnError>({ url: '/api/labs/{id}', ...options });
    }
    
    /**
     * Get lab by ID
     *
     * Returns a lab by ID. Public labs are accessible to everyone. Non-public labs are accessible to admins, users who have a lab visit assigned to that lab, and users whose employer has that lab as its assigned draw site.
     */
    public static getApiLabsById<ThrowOnError extends boolean = false>(options: Options<GetApiLabsByIdData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/labs/{id}', ...options });
    }
    
    /**
     * Update Lab
     */
    public static putApiLabsById<ThrowOnError extends boolean = false>(options: Options<PutApiLabsByIdData, ThrowOnError>): RequestResult<PutApiLabsByIdResponses, PutApiLabsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiLabsByIdResponses, PutApiLabsByIdErrors, ThrowOnError>({
            url: '/api/labs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class WebhooksService {
    /**
     * Receive lab results from Liaison
     *
     * Receives lab result data from external liaison system. Requires webhook token authentication.
     */
    public static postApiLiaisonWebhookSvarLab<ThrowOnError extends boolean = false>(options: Options<PostApiLiaisonWebhookSvarLabData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/liaison/webhook/svar_lab',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Receive appreciation data from Liaison
     *
     * Receives appreciation/feedback data from external liaison system. Requires webhook token authentication.
     */
    public static postApiWebhooksLiaisonApprec<ThrowOnError extends boolean = false>(options: Options<PostApiWebhooksLiaisonApprecData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/webhooks/liaison/apprec',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Receive Periode payment webhook
     *
     * Receives subscription status updates from Periode payment provider. Requires webhook token authentication.
     */
    public static postApiWebhooksPeriode<ThrowOnError extends boolean = false>(options: Options<PostApiWebhooksPeriodeData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/api/webhooks/periode',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Receive lab results from Liaison
     *
     * Receives lab result data from external liaison system. Requires webhook token authentication.
     */
    public static postLiaisonWebhookSvarLab<ThrowOnError extends boolean = false>(options: Options<PostLiaisonWebhookSvarLabData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/liaison/webhook/svar_lab',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Receive appreciation data from Liaison
     *
     * Receives appreciation/feedback data from external liaison system. Requires webhook token authentication.
     */
    public static postWebhooksLiaisonApprec<ThrowOnError extends boolean = false>(options: Options<PostWebhooksLiaisonApprecData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).post<unknown, unknown, ThrowOnError>({
            url: '/webhooks/liaison/apprec',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class MetricSourcePreferencesService {
    /**
     * List metric_source_preferences
     */
    public static getApiMetricSourcePreferences<ThrowOnError extends boolean = false>(options?: Options<GetApiMetricSourcePreferencesData, ThrowOnError>): RequestResult<GetApiMetricSourcePreferencesResponses, GetApiMetricSourcePreferencesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiMetricSourcePreferencesResponses, GetApiMetricSourcePreferencesErrors, ThrowOnError>({ url: '/api/metric_source_preferences', ...options });
    }
    
    /**
     * Create MetricSourcePreference
     */
    public static postApiMetricSourcePreferences<ThrowOnError extends boolean = false>(options: Options<PostApiMetricSourcePreferencesData, ThrowOnError>): RequestResult<PostApiMetricSourcePreferencesResponses, PostApiMetricSourcePreferencesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiMetricSourcePreferencesResponses, PostApiMetricSourcePreferencesErrors, ThrowOnError>({
            url: '/api/metric_source_preferences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete MetricSourcePreference
     */
    public static deleteApiMetricSourcePreferencesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiMetricSourcePreferencesByIdData, ThrowOnError>): RequestResult<DeleteApiMetricSourcePreferencesByIdResponses, DeleteApiMetricSourcePreferencesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiMetricSourcePreferencesByIdResponses, DeleteApiMetricSourcePreferencesByIdErrors, ThrowOnError>({ url: '/api/metric_source_preferences/{id}', ...options });
    }
    
    /**
     * Get MetricSourcePreference by ID
     */
    public static getApiMetricSourcePreferencesById<ThrowOnError extends boolean = false>(options: Options<GetApiMetricSourcePreferencesByIdData, ThrowOnError>): RequestResult<GetApiMetricSourcePreferencesByIdResponses, GetApiMetricSourcePreferencesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiMetricSourcePreferencesByIdResponses, GetApiMetricSourcePreferencesByIdErrors, ThrowOnError>({ url: '/api/metric_source_preferences/{id}', ...options });
    }
    
    /**
     * Update MetricSourcePreference
     */
    public static putApiMetricSourcePreferencesById<ThrowOnError extends boolean = false>(options: Options<PutApiMetricSourcePreferencesByIdData, ThrowOnError>): RequestResult<PutApiMetricSourcePreferencesByIdResponses, PutApiMetricSourcePreferencesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiMetricSourcePreferencesByIdResponses, PutApiMetricSourcePreferencesByIdErrors, ThrowOnError>({
            url: '/api/metric_source_preferences/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PricesService {
    /**
     * List prices
     */
    public static getApiPrices<ThrowOnError extends boolean = false>(options?: Options<GetApiPricesData, ThrowOnError>): RequestResult<GetApiPricesResponses, GetApiPricesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiPricesResponses, GetApiPricesErrors, ThrowOnError>({ url: '/api/prices', ...options });
    }
    
    /**
     * Create Price
     */
    public static postApiPrices<ThrowOnError extends boolean = false>(options: Options<PostApiPricesData, ThrowOnError>): RequestResult<PostApiPricesResponses, PostApiPricesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiPricesResponses, PostApiPricesErrors, ThrowOnError>({
            url: '/api/prices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Price
     */
    public static deleteApiPricesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiPricesByIdData, ThrowOnError>): RequestResult<DeleteApiPricesByIdResponses, DeleteApiPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiPricesByIdResponses, DeleteApiPricesByIdErrors, ThrowOnError>({ url: '/api/prices/{id}', ...options });
    }
    
    /**
     * Get Price by ID
     */
    public static getApiPricesById<ThrowOnError extends boolean = false>(options: Options<GetApiPricesByIdData, ThrowOnError>): RequestResult<GetApiPricesByIdResponses, GetApiPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiPricesByIdResponses, GetApiPricesByIdErrors, ThrowOnError>({ url: '/api/prices/{id}', ...options });
    }
    
    /**
     * Update Price
     */
    public static putApiPricesById<ThrowOnError extends boolean = false>(options: Options<PutApiPricesByIdData, ThrowOnError>): RequestResult<PutApiPricesByIdResponses, PutApiPricesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiPricesByIdResponses, PutApiPricesByIdErrors, ThrowOnError>({
            url: '/api/prices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SurveysService {
    /**
     * List question-alternatives
     */
    public static getApiQuestionAlternatives<ThrowOnError extends boolean = false>(options?: Options<GetApiQuestionAlternativesData, ThrowOnError>): RequestResult<GetApiQuestionAlternativesResponses, GetApiQuestionAlternativesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiQuestionAlternativesResponses, GetApiQuestionAlternativesErrors, ThrowOnError>({ url: '/api/question-alternatives', ...options });
    }
    
    /**
     * Create QuestionAlternative
     */
    public static postApiQuestionAlternatives<ThrowOnError extends boolean = false>(options: Options<PostApiQuestionAlternativesData, ThrowOnError>): RequestResult<PostApiQuestionAlternativesResponses, PostApiQuestionAlternativesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiQuestionAlternativesResponses, PostApiQuestionAlternativesErrors, ThrowOnError>({
            url: '/api/question-alternatives',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete QuestionAlternative
     */
    public static deleteApiQuestionAlternativesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiQuestionAlternativesByIdData, ThrowOnError>): RequestResult<DeleteApiQuestionAlternativesByIdResponses, DeleteApiQuestionAlternativesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiQuestionAlternativesByIdResponses, DeleteApiQuestionAlternativesByIdErrors, ThrowOnError>({ url: '/api/question-alternatives/{id}', ...options });
    }
    
    /**
     * Get QuestionAlternative by ID
     */
    public static getApiQuestionAlternativesById<ThrowOnError extends boolean = false>(options: Options<GetApiQuestionAlternativesByIdData, ThrowOnError>): RequestResult<GetApiQuestionAlternativesByIdResponses, GetApiQuestionAlternativesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiQuestionAlternativesByIdResponses, GetApiQuestionAlternativesByIdErrors, ThrowOnError>({ url: '/api/question-alternatives/{id}', ...options });
    }
    
    /**
     * Update QuestionAlternative
     */
    public static putApiQuestionAlternativesById<ThrowOnError extends boolean = false>(options: Options<PutApiQuestionAlternativesByIdData, ThrowOnError>): RequestResult<PutApiQuestionAlternativesByIdResponses, PutApiQuestionAlternativesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiQuestionAlternativesByIdResponses, PutApiQuestionAlternativesByIdErrors, ThrowOnError>({
            url: '/api/question-alternatives/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List question-categories
     */
    public static getApiQuestionCategories<ThrowOnError extends boolean = false>(options?: Options<GetApiQuestionCategoriesData, ThrowOnError>): RequestResult<GetApiQuestionCategoriesResponses, GetApiQuestionCategoriesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiQuestionCategoriesResponses, GetApiQuestionCategoriesErrors, ThrowOnError>({ url: '/api/question-categories', ...options });
    }
    
    /**
     * Create QuestionCategory
     */
    public static postApiQuestionCategories<ThrowOnError extends boolean = false>(options: Options<PostApiQuestionCategoriesData, ThrowOnError>): RequestResult<PostApiQuestionCategoriesResponses, PostApiQuestionCategoriesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiQuestionCategoriesResponses, PostApiQuestionCategoriesErrors, ThrowOnError>({
            url: '/api/question-categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete QuestionCategory
     */
    public static deleteApiQuestionCategoriesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiQuestionCategoriesByIdData, ThrowOnError>): RequestResult<DeleteApiQuestionCategoriesByIdResponses, DeleteApiQuestionCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiQuestionCategoriesByIdResponses, DeleteApiQuestionCategoriesByIdErrors, ThrowOnError>({ url: '/api/question-categories/{id}', ...options });
    }
    
    /**
     * Get QuestionCategory by ID
     */
    public static getApiQuestionCategoriesById<ThrowOnError extends boolean = false>(options: Options<GetApiQuestionCategoriesByIdData, ThrowOnError>): RequestResult<GetApiQuestionCategoriesByIdResponses, GetApiQuestionCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiQuestionCategoriesByIdResponses, GetApiQuestionCategoriesByIdErrors, ThrowOnError>({ url: '/api/question-categories/{id}', ...options });
    }
    
    /**
     * Update QuestionCategory
     */
    public static putApiQuestionCategoriesById<ThrowOnError extends boolean = false>(options: Options<PutApiQuestionCategoriesByIdData, ThrowOnError>): RequestResult<PutApiQuestionCategoriesByIdResponses, PutApiQuestionCategoriesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiQuestionCategoriesByIdResponses, PutApiQuestionCategoriesByIdErrors, ThrowOnError>({
            url: '/api/question-categories/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List question-numeric-rules
     */
    public static getApiQuestionNumericRules<ThrowOnError extends boolean = false>(options?: Options<GetApiQuestionNumericRulesData, ThrowOnError>): RequestResult<GetApiQuestionNumericRulesResponses, GetApiQuestionNumericRulesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiQuestionNumericRulesResponses, GetApiQuestionNumericRulesErrors, ThrowOnError>({ url: '/api/question-numeric-rules', ...options });
    }
    
    /**
     * Create QuestionNumericRule
     */
    public static postApiQuestionNumericRules<ThrowOnError extends boolean = false>(options: Options<PostApiQuestionNumericRulesData, ThrowOnError>): RequestResult<PostApiQuestionNumericRulesResponses, PostApiQuestionNumericRulesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiQuestionNumericRulesResponses, PostApiQuestionNumericRulesErrors, ThrowOnError>({
            url: '/api/question-numeric-rules',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete QuestionNumericRule
     */
    public static deleteApiQuestionNumericRulesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiQuestionNumericRulesByIdData, ThrowOnError>): RequestResult<DeleteApiQuestionNumericRulesByIdResponses, DeleteApiQuestionNumericRulesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiQuestionNumericRulesByIdResponses, DeleteApiQuestionNumericRulesByIdErrors, ThrowOnError>({ url: '/api/question-numeric-rules/{id}', ...options });
    }
    
    /**
     * Get QuestionNumericRule by ID
     */
    public static getApiQuestionNumericRulesById<ThrowOnError extends boolean = false>(options: Options<GetApiQuestionNumericRulesByIdData, ThrowOnError>): RequestResult<GetApiQuestionNumericRulesByIdResponses, GetApiQuestionNumericRulesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiQuestionNumericRulesByIdResponses, GetApiQuestionNumericRulesByIdErrors, ThrowOnError>({ url: '/api/question-numeric-rules/{id}', ...options });
    }
    
    /**
     * Update QuestionNumericRule
     */
    public static putApiQuestionNumericRulesById<ThrowOnError extends boolean = false>(options: Options<PutApiQuestionNumericRulesByIdData, ThrowOnError>): RequestResult<PutApiQuestionNumericRulesByIdResponses, PutApiQuestionNumericRulesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiQuestionNumericRulesByIdResponses, PutApiQuestionNumericRulesByIdErrors, ThrowOnError>({
            url: '/api/question-numeric-rules/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List question-responses
     */
    public static getApiQuestionResponses<ThrowOnError extends boolean = false>(options?: Options<GetApiQuestionResponsesData, ThrowOnError>): RequestResult<GetApiQuestionResponsesResponses, GetApiQuestionResponsesErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiQuestionResponsesResponses, GetApiQuestionResponsesErrors, ThrowOnError>({ url: '/api/question-responses', ...options });
    }
    
    /**
     * Create QuestionRespons
     */
    public static postApiQuestionResponses<ThrowOnError extends boolean = false>(options: Options<PostApiQuestionResponsesData, ThrowOnError>): RequestResult<PostApiQuestionResponsesResponses, PostApiQuestionResponsesErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiQuestionResponsesResponses, PostApiQuestionResponsesErrors, ThrowOnError>({
            url: '/api/question-responses',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete QuestionRespons
     */
    public static deleteApiQuestionResponsesById<ThrowOnError extends boolean = false>(options: Options<DeleteApiQuestionResponsesByIdData, ThrowOnError>): RequestResult<DeleteApiQuestionResponsesByIdResponses, DeleteApiQuestionResponsesByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiQuestionResponsesByIdResponses, DeleteApiQuestionResponsesByIdErrors, ThrowOnError>({ url: '/api/question-responses/{id}', ...options });
    }
    
    /**
     * Get QuestionRespons by ID
     */
    public static getApiQuestionResponsesById<ThrowOnError extends boolean = false>(options: Options<GetApiQuestionResponsesByIdData, ThrowOnError>): RequestResult<GetApiQuestionResponsesByIdResponses, GetApiQuestionResponsesByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiQuestionResponsesByIdResponses, GetApiQuestionResponsesByIdErrors, ThrowOnError>({ url: '/api/question-responses/{id}', ...options });
    }
    
    /**
     * Update QuestionRespons
     */
    public static putApiQuestionResponsesById<ThrowOnError extends boolean = false>(options: Options<PutApiQuestionResponsesByIdData, ThrowOnError>): RequestResult<PutApiQuestionResponsesByIdResponses, PutApiQuestionResponsesByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiQuestionResponsesByIdResponses, PutApiQuestionResponsesByIdErrors, ThrowOnError>({
            url: '/api/question-responses/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List questions
     */
    public static getApiQuestions<ThrowOnError extends boolean = false>(options?: Options<GetApiQuestionsData, ThrowOnError>): RequestResult<GetApiQuestionsResponses, GetApiQuestionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetApiQuestionsResponses, GetApiQuestionsErrors, ThrowOnError>({ url: '/api/questions', ...options });
    }
    
    /**
     * Create Question
     */
    public static postApiQuestions<ThrowOnError extends boolean = false>(options: Options<PostApiQuestionsData, ThrowOnError>): RequestResult<PostApiQuestionsResponses, PostApiQuestionsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiQuestionsResponses, PostApiQuestionsErrors, ThrowOnError>({
            url: '/api/questions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Question
     */
    public static deleteApiQuestionsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiQuestionsByIdData, ThrowOnError>): RequestResult<DeleteApiQuestionsByIdResponses, DeleteApiQuestionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiQuestionsByIdResponses, DeleteApiQuestionsByIdErrors, ThrowOnError>({ url: '/api/questions/{id}', ...options });
    }
    
    /**
     * Get Question by ID
     */
    public static getApiQuestionsById<ThrowOnError extends boolean = false>(options: Options<GetApiQuestionsByIdData, ThrowOnError>): RequestResult<GetApiQuestionsByIdResponses, GetApiQuestionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiQuestionsByIdResponses, GetApiQuestionsByIdErrors, ThrowOnError>({ url: '/api/questions/{id}', ...options });
    }
    
    /**
     * Update Question
     */
    public static putApiQuestionsById<ThrowOnError extends boolean = false>(options: Options<PutApiQuestionsByIdData, ThrowOnError>): RequestResult<PutApiQuestionsByIdResponses, PutApiQuestionsByIdErrors, ThrowOnError> {
        return (options.client ?? client).put<PutApiQuestionsByIdResponses, PutApiQuestionsByIdErrors, ThrowOnError>({
            url: '/api/questions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SystemService {
    /**
     * List API keys
     *
     * All API keys, newest first. Never returns the key.
     */
    public static getApiSystemApiKeys<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemApiKeysData, ThrowOnError>): RequestResult<GetApiSystemApiKeysResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemApiKeysResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/api-keys',
            ...options
        });
    }
    
    /**
     * Create an API key
     *
     * Creates a key that opens one API (scope: the CRM lookup or the analytics API) and expires after 30 days. The key is returned only in this response.
     */
    public static postApiSystemApiKeys<ThrowOnError extends boolean = false>(options: Options<PostApiSystemApiKeysData, ThrowOnError>): RequestResult<PostApiSystemApiKeysResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemApiKeysResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/api-keys',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Revoke an API key
     *
     * The key stops working at once. The row is kept.
     */
    public static postApiSystemApiKeysByIdRevoke<ThrowOnError extends boolean = false>(options: Options<PostApiSystemApiKeysByIdRevokeData, ThrowOnError>): RequestResult<PostApiSystemApiKeysByIdRevokeResponses, PostApiSystemApiKeysByIdRevokeErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemApiKeysByIdRevokeResponses, PostApiSystemApiKeysByIdRevokeErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/api-keys/{id}/revoke',
            ...options
        });
    }
    
    /**
     * API key usage
     *
     * Calls made with one key, newest first.
     */
    public static getApiSystemApiKeysByIdUsage<ThrowOnError extends boolean = false>(options: Options<GetApiSystemApiKeysByIdUsageData, ThrowOnError>): RequestResult<GetApiSystemApiKeysByIdUsageResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetApiSystemApiKeysByIdUsageResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/api-keys/{id}/usage',
            ...options
        });
    }
    
    /**
     * List conversion events
     *
     * Returns conversion events within a date range for manual CSV export to Google Ads.
     */
    public static getApiSystemConversions<ThrowOnError extends boolean = false>(options: Options<GetApiSystemConversionsData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options.client ?? client).get<unknown, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/conversions',
            ...options
        });
    }
    
    /**
     * List cron jobs
     *
     * Returns all registered cron job definitions.
     */
    public static getApiSystemCronJobs<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemCronJobsData, ThrowOnError>): RequestResult<GetApiSystemCronJobsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemCronJobsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/cron-jobs',
            ...options
        });
    }
    
    /**
     * Trigger a cron job
     *
     * Manually trigger a cron job with optional argument overrides.
     */
    public static postApiSystemCronJobsByWorkerTrigger<ThrowOnError extends boolean = false>(options: Options<PostApiSystemCronJobsByWorkerTriggerData, ThrowOnError>): RequestResult<PostApiSystemCronJobsByWorkerTriggerResponses, PostApiSystemCronJobsByWorkerTriggerErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemCronJobsByWorkerTriggerResponses, PostApiSystemCronJobsByWorkerTriggerErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/cron-jobs/{worker}/trigger',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Browse events
     *
     * Returns events filtered by stream, streamId, and/or type. Ordered newest first. Paginated with limit/offset.
     */
    public static getApiSystemEvents<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemEventsData, ThrowOnError>): RequestResult<GetApiSystemEventsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemEventsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/events',
            ...options
        });
    }
    
    /**
     * List distinct event streams
     *
     * Returns all distinct stream names in the events table.
     */
    public static getApiSystemEventsStreams<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemEventsStreamsData, ThrowOnError>): RequestResult<GetApiSystemEventsStreamsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemEventsStreamsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/events/streams',
            ...options
        });
    }
    
    /**
     * Get cluster health
     *
     * Returns all active nodes with their process and host stats (from heartbeats), the latest heartbeat from each VM (disk, memory, swap, WAL, archiver, last backup), and fresh PostgreSQL metrics.
     */
    public static getApiSystemHealth<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemHealthData, ThrowOnError>): RequestResult<GetApiSystemHealthResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemHealthResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/health',
            ...options
        });
    }
    
    /**
     * List jobs
     *
     * List jobs with optional filtering by status, worker, and queue.
     */
    public static getApiSystemJobs<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemJobsData, ThrowOnError>): RequestResult<GetApiSystemJobsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemJobsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs',
            ...options
        });
    }
    
    /**
     * Schedule a new job
     *
     * Create and enqueue a new background job.
     */
    public static postApiSystemJobs<ThrowOnError extends boolean = false>(options: Options<PostApiSystemJobsData, ThrowOnError>): RequestResult<PostApiSystemJobsResponses, PostApiSystemJobsErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemJobsResponses, PostApiSystemJobsErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get jobs breakdown by worker
     *
     * Returns per-worker job counts grouped by queue.
     */
    public static getApiSystemJobsByWorker<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemJobsByWorkerData, ThrowOnError>): RequestResult<GetApiSystemJobsByWorkerResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemJobsByWorkerResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs-by-worker',
            ...options
        });
    }
    
    /**
     * Cleanup old jobs
     *
     * Bulk delete completed/failed jobs older than N days.
     */
    public static postApiSystemJobsCleanup<ThrowOnError extends boolean = false>(options: Options<PostApiSystemJobsCleanupData, ThrowOnError>): RequestResult<PostApiSystemJobsCleanupResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemJobsCleanupResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/cleanup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Recover stuck jobs
     *
     * Reset all jobs with expired leases back to pending.
     */
    public static postApiSystemJobsRecoverStuck<ThrowOnError extends boolean = false>(options?: Options<PostApiSystemJobsRecoverStuckData, ThrowOnError>): RequestResult<PostApiSystemJobsRecoverStuckResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostApiSystemJobsRecoverStuckResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/recover-stuck',
            ...options
        });
    }
    
    /**
     * Get stuck jobs
     *
     * List jobs with expired leases that may need recovery.
     */
    public static getApiSystemJobsStuck<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemJobsStuckData, ThrowOnError>): RequestResult<GetApiSystemJobsStuckResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemJobsStuckResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/stuck',
            ...options
        });
    }
    
    /**
     * Delete a job
     *
     * Permanently delete a non-running job and its logs.
     */
    public static deleteApiSystemJobsById<ThrowOnError extends boolean = false>(options: Options<DeleteApiSystemJobsByIdData, ThrowOnError>): RequestResult<DeleteApiSystemJobsByIdResponses, DeleteApiSystemJobsByIdErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteApiSystemJobsByIdResponses, DeleteApiSystemJobsByIdErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/{id}',
            ...options
        });
    }
    
    /**
     * Get job detail
     *
     * Returns full job metadata and associated logs.
     */
    public static getApiSystemJobsById<ThrowOnError extends boolean = false>(options: Options<GetApiSystemJobsByIdData, ThrowOnError>): RequestResult<GetApiSystemJobsByIdResponses, GetApiSystemJobsByIdErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiSystemJobsByIdResponses, GetApiSystemJobsByIdErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/{id}',
            ...options
        });
    }
    
    /**
     * Cancel a pending job
     *
     * Cancel a job that hasn't started yet.
     */
    public static postApiSystemJobsByIdCancel<ThrowOnError extends boolean = false>(options: Options<PostApiSystemJobsByIdCancelData, ThrowOnError>): RequestResult<PostApiSystemJobsByIdCancelResponses, PostApiSystemJobsByIdCancelErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemJobsByIdCancelResponses, PostApiSystemJobsByIdCancelErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/{id}/cancel',
            ...options
        });
    }
    
    /**
     * Requeue a job
     *
     * Force-reset any job to pending status.
     */
    public static postApiSystemJobsByIdRequeue<ThrowOnError extends boolean = false>(options: Options<PostApiSystemJobsByIdRequeueData, ThrowOnError>): RequestResult<PostApiSystemJobsByIdRequeueResponses, PostApiSystemJobsByIdRequeueErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemJobsByIdRequeueResponses, PostApiSystemJobsByIdRequeueErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/{id}/requeue',
            ...options
        });
    }
    
    /**
     * Retry a failed job
     *
     * Reset a failed job to pending status for re-execution.
     */
    public static postApiSystemJobsByIdRetry<ThrowOnError extends boolean = false>(options: Options<PostApiSystemJobsByIdRetryData, ThrowOnError>): RequestResult<PostApiSystemJobsByIdRetryResponses, PostApiSystemJobsByIdRetryErrors, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemJobsByIdRetryResponses, PostApiSystemJobsByIdRetryErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/jobs/{id}/retry',
            ...options
        });
    }
    
    /**
     * List logs
     *
     * Query application logs with filtering by level, context, job, or search text.
     */
    public static getApiSystemLogs<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemLogsData, ThrowOnError>): RequestResult<GetApiSystemLogsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemLogsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs',
            ...options
        });
    }
    
    /**
     * Cleanup old logs
     *
     * Delete info/debug logs older than infoDays (default 2) and warn/error older than errorDays (default 30).
     */
    public static postApiSystemLogsCleanup<ThrowOnError extends boolean = false>(options: Options<PostApiSystemLogsCleanupData, ThrowOnError>): RequestResult<PostApiSystemLogsCleanupResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemLogsCleanupResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs/cleanup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export errors as a Claude Code prompt
     *
     * Builds a truncated markdown report of unresolved error signatures — stack traces, sample messages and metadata — ready to paste into a coding agent.
     */
    public static getApiSystemLogsExportPrompt<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemLogsExportPromptData, ThrowOnError>): RequestResult<GetApiSystemLogsExportPromptResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemLogsExportPromptResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs/export-prompt',
            ...options
        });
    }
    
    /**
     * Get signature detail
     *
     * Diagnosis, 24-bucket histogram, recent events, last payload and the concrete routes folded into one signature.
     */
    public static getApiSystemLogsSignature<ThrowOnError extends boolean = false>(options: Options<GetApiSystemLogsSignatureData, ThrowOnError>): RequestResult<GetApiSystemLogsSignatureResponses, GetApiSystemLogsSignatureErrors, ThrowOnError> {
        return (options.client ?? client).get<GetApiSystemLogsSignatureResponses, GetApiSystemLogsSignatureErrors, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs/signature',
            ...options
        });
    }
    
    /**
     * Mute a signature
     *
     * Mutes for N days. Pass days: 0 to unmute.
     */
    public static postApiSystemLogsSignatureMute<ThrowOnError extends boolean = false>(options: Options<PostApiSystemLogsSignatureMuteData, ThrowOnError>): RequestResult<PostApiSystemLogsSignatureMuteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemLogsSignatureMuteResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs/signature/mute',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Mark a signature resolved
     *
     * Removes it from the list. If the signature recurs it reappears flagged NY.
     */
    public static postApiSystemLogsSignatureResolve<ThrowOnError extends boolean = false>(options: Options<PostApiSystemLogsSignatureResolveData, ThrowOnError>): RequestResult<PostApiSystemLogsSignatureResolveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostApiSystemLogsSignatureResolveResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs/signature/resolve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List error signatures
     *
     * Groups warn/error logs into signatures (method + route pattern + status) with counts, sparklines and triage state.
     */
    public static getApiSystemLogsSignatures<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemLogsSignaturesData, ThrowOnError>): RequestResult<GetApiSystemLogsSignaturesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemLogsSignaturesResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs/signatures',
            ...options
        });
    }
    
    /**
     * Get log statistics
     *
     * Returns log counts by level and available contexts.
     */
    public static getApiSystemLogsStats<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemLogsStatsData, ThrowOnError>): RequestResult<GetApiSystemLogsStatsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemLogsStatsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/logs/stats',
            ...options
        });
    }
    
    /**
     * Get job statistics
     *
     * Returns overall job counts, registered workers, and worker argument metadata.
     */
    public static getApiSystemStats<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemStatsData, ThrowOnError>): RequestResult<GetApiSystemStatsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemStatsResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/stats',
            ...options
        });
    }
    
    /**
     * Endpoint telemetry
     *
     * Request volume, 5xx share and latency percentiles per route pattern over the range, summed across nodes from five-minute buckets. Percentiles are estimated from a fixed latency histogram.
     */
    public static getApiSystemTelemetry<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemTelemetryData, ThrowOnError>): RequestResult<GetApiSystemTelemetryResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemTelemetryResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/telemetry',
            ...options
        });
    }
    
    /**
     * Get throughput metrics
     *
     * Returns hourly job completion/failure counts over the last 24 hours.
     */
    public static getApiSystemThroughput<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemThroughputData, ThrowOnError>): RequestResult<GetApiSystemThroughputResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetApiSystemThroughputResponses, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/throughput',
            ...options
        });
    }
}

export class DefaultService {
    public static getApiSystemLive<ThrowOnError extends boolean = false>(options?: Options<GetApiSystemLiveData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
            security: [{
                    key: 'bearerAuth',
                    scheme: 'bearer',
                    type: 'http'
                }],
            url: '/api/system/live',
            ...options
        });
    }
    
    public static getHealth<ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> {
        return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/health', ...options });
    }
}
